// 揽收中心
const collectionCenter = {
  pleaseChoose: {
    zh: '请选择',
    en: 'Please select',
    pu: 'Favor selecionar'
  },
  pleaseInput: {
    zh: '请输入',
    en: 'Please enter the content',
    pu: 'Por favor digite'
  },
  collectionCenter: {
    zh: '揽收中心',
    en: '',
    pu: 'Centro de Coleta'
  },
  listingQuery: {
    zh: '揽收清单',
    en: '',
    pu: 'Lista de Coleta'
  },
  pleaseCheck: {
    zh: '请勾选要作废的数据',
    en: '',
    pu: 'Por favor, assinale os dados a serem anulados'
  },
  PleaseTickTheDataExport: {
    zh: '请选择需导出的数据',
    en: 'Please tick the data you want to export',
    pu: 'Selecione os dados que serão exportados'
  },
  lanshouTime: {
    zh: '揽收时间：',
    en: '',
    pu: 'tempo de coleta：'
  },
  StartTime: {
    zh: '开始时间',
    en: 'Start time',
    pu: 'Hora de início'
  },
  EndTime: {
    zh: '结束时间',
    en: 'End time',
    pu: 'Hora de fim'
  },
  customerOrderNumber: {
    zh: '客户订单号：',
    en: '',
    pu: 'No. de pedido do cliente'
  },
  siteNumber: {
    zh: '网点编号：',
    en: '',
    pu: 'Número do local：'
  },
  receiverNumber: {
    zh: '揽收人编号：',
    en: '',
    pu: 'No. do assistente de coleta：'
  },
  statusOfTheReceivingList: {
    zh: '揽收清单状态：',
    en: '',
    pu: 'Status da lista de coleta：'
  },
  receivingListNumber: {
    zh: '揽收清单号：',
    en: '',
    pu: 'No. de lista de coleta：'
  },
  search: {
    zh: '查询',
    en: '',
    pu: 'Consultar'
  },
  reset: {
    zh: '重置',
    en: 'reset',
    pu: 'Resetar'
  },
  export: {
    zh: '导出',
    en: 'export',
    pu: 'Exportar'
  },
  allExport: {
    zh: '全部导出',
    en: '',
    pu: 'Exportar tudo'
  },
  明细导出: {
    zh: '明细导出',
    en: '',
    pu: 'Exportar detalhes'
  },
  void: {
    zh: '作废',
    en: 'void',
    pu: 'invalido'
  },
  ind: {
    zh: '序号',
    en: 'index',
    pu: 'No.'
  },
  customerOrderNum: {
    zh: '客户订单号',
    en: '',
    pu: 'No. do pedido do cliente'
  },
  CustomerName: {
    zh: '客户名称',
    en: 'Customer name',
    pu: 'Nome do cliente'
  },
  receivingListNum: {
    zh: '揽收清单号',
    en: '',
    pu: 'No. da lista de coleta'
  },
  stayLanshouPoll: {
    zh: '待揽收票数',
    en: '',
    pu: 'quantidade dos pacotes a serem coletados'
  },
  realityLanshouPoll: {
    zh: '实际揽收票数',
    en: '',
    pu: 'quantidade real dos pacotes coletados'
  },
  signerNumber: {
    zh: '签收票数',
    en: '',
    pu: 'qauntidade de pacotes assinados'
  },
  bagsNum: {
    zh: '袋数',
    en: '',
    pu: 'quantidade de sacas'
  },
  siteNum: {
    zh: '网点编号',
    en: '',
    pu: 'Netpoint nº'
  },
  receiverNum: {
    zh: '揽收人编号',
    en: '',
    pu: 'No. do responsável pela coleta'
  },
  receiverName: {
    zh: '揽收人名称',
    en: '',
    pu: 'Nome do responsável pela coleta'
  },
  ExpectedTimeOfCollection: {
    zh: '预期揽收时间',
    en: '',
    pu: 'Tempo previsto para a coleta'
  },
  ActualCollectionTime: {
    zh: '实际揽收时间',
    en: '',
    pu: 'Tempo real para a coleta'
  },
  listingStatus: {
    zh: '清单状态',
    en: '',
    pu: 'status da lista'
  },
  signatureImage: {
    zh: '签名图片',
    en: '',
    pu: 'imagem da assinatura'
  },
  InvalidTime: {
    zh: '作废时间',
    en: '',
    pu: 'Tempo de anulação'
  },
  InvalidPeople: {
    zh: '作废人',
    en: '',
    pu: 'anulado por'
  },
  customerMerchantNumber: {
    zh: '客户商户号',
    en: '',
    pu: 'razão social do cliente'
  },
  operation: {
    zh: '操作',
    en: 'operation',
    pu: 'Operação'
  },
  viewInformation: {
    zh: '查看寄/收件人信息',
    en: '',
    pu: 'Ver informações sobre o remetente/destinatário'
  },
  detail: {
    zh: '详情',
    en: 'detail',
    pu: 'detalhe'
  },
  orderDetails: {
    zh: '详情',
    en: 'order details',
    pu: 'detalhes da ordem'
  },
  sendState: {
    zh: '寄件州',
    en: '',
    pu: 'Estado remetente'
  },
  sendCity: {
    zh: '寄件城市',
    en: '',
    pu: 'Cidade remetente'
  },
  sendRegional: {
    zh: '寄件区域',
    en: '',
    pu: 'Área de Postagem/Envio'
  },
  sendR: {
    zh: '寄件区域：',
    en: '',
    pu: 'Área de Postagem/Envio：'
  },
  sendAddress: {
    zh: '寄件地址',
    en: '',
    pu: 'Endereço remetente'
  },
  sendPeople: {
    zh: '寄件人',
    en: '',
    pu: 'remetente'
  },
  receivingState: {
    zh: '收件州',
    en: '',
    pu: 'Estado destinatário'
  },
  receivingCity: {
    zh: '收件城市',
    en: '',
    pu: 'Cidade destinatária'
  },
  receivingRegional: {
    zh: '收件区域',
    en: '',
    pu: 'Área destinatária'
  },
  receivingStreet: {
    zh: '收件街道',
    en: '',
    pu: 'Avenida destinatária'
  },
  receivingHouseNumber: {
    zh: '收件门牌号',
    en: '',
    pu: 'No. da porta destinatária'
  },
  // 客户上门交件 ----------------------
  deleteSure: {
    zh: '确定删除吗？',
    en: '',
    pu: 'confirmar para excluir?'
  },
  CustomerN: {
    zh: '客户名称：',
    en: 'Customer name：',
    pu: 'Nome do cliente：'
  },
  LanShouPerson: {
    zh: '揽收人：',
    en: '',
    pu: 'responsável pela coleta：'
  },
  lanshouT: {
    zh: '揽收时间',
    en: '',
    pu: 'Tempo de coleta'
  },
  LanShouSum: {
    zh: '揽收票数：',
    en: '',
    pu: 'quantidade de pacotes coletados：'
  },
  LSSum: {
    zh: '揽收总票数：',
    en: '',
    pu: 'Obtenha o total de votos：'
  },
  customerHandDoor: {
    zh: '客户上门交件',
    en: '',
    pu: 'Consulta de Cliente Dropoff'
  },
  customerHandRegistrationScan: {
    zh: '客户交件登记扫描',
    en: '',
    pu: 'Varredura do registro de entrega ao cliente'
  },
  conditionQuery: {
    zh: '条件查询',
    en: '',
    pu: 'Pesquisa por condição'
  },
  phoneNumber: {
    zh: '手机号码',
    en: '',
    pu: 'Telefone'
  },
  clientID: {
    zh: '客户编号',
    en: '',
    pu: 'COSTUMER ID'
  },
  clientName: {
    zh: '客户姓名',
    en: '',
    pu: 'Nome do cliente'
  },
  clientN: {
    zh: '客户姓名：',
    en: '',
    pu: 'Nome do cliente：'
  },
  inputPrompt: {
    zh: '请输入内容',
    en: '',
    pu: 'Por favor digite conteúdo'
  },
  parcelNumber: {
    zh: '包裹号：',
    en: '',
    pu: 'No. do pacote：'
  },
  parcelNum: {
    zh: '包裹号',
    en: '',
    pu: 'No. do pacote'
  },
  sannePacotes: {
    zh: '扫描包裹',
    en: '',
    pu: 'Digitalização de pacotes'
  },
  scanner: {
    zh: '扫描人',
    en: '',
    pu: 'Scanner'
  },
  BagParcelNumber: {
    zh: '袋号/包裹号',
    en: '',
    pu: 'Número da saca/No. do pacote'
  },
  scanOrInputParcelNumber: {
    zh: '请扫描或输入包裹号',
    en: '',
    pu: 'Favor escanear ou digitar o número do pacote'
  },
  createConfirmList: {
    zh: '生成确认单',
    en: '',
    pu: 'Gerar tabela de confirmação'
  },
  ListOfScannedLogisticNumbers: {
    zh: '已扫描的物流单号列表：',
    en: '',
    pu: 'Lista de número de pedidos logísticos escaneados：'
  },
  scanTime: {
    zh: '扫描时间',
    en: '',
    pu: 'Tempo da coleta'
  },
  scannedNumber: {
    zh: '已扫描的数量：',
    en: '',
    pu: 'Quantidade de pacotes escaneados：'
  },
  customerHandFindTable: {
    zh: '客户交件查询列表',
    en: '',
    pu: 'Lista de consulta de entrega pelo cliente'
  },
  LanShouPeople: {
    zh: '揽收人',
    en: '',
    pu: 'responsável pela coleta'
  },
  LanShouBody: {
    zh: '揽收人：',
    en: '',
    pu: 'responsável pela coleta：'
  },
  Print: {
    zh: '打印',
    en: '',
    pu: 'Imprimir'
  },
  ballot: {
    zh: '票数',
    en: '',
    pu: 'Quantidade'
  },
  siteName: {
    zh: '网点名称',
    en: '',
    pu: 'Nome de ponto'
  },
  // 需求4387：投诉工单的「网点名称」字段文案改为「处理网点」，与筛选/共享词条隔离，只给投诉工单列头用
  processingSite: {
    zh: '处理网点',
    en: '',
    pu: 'Base Responsável'
  },
  // 需求4387（范围变更）：投诉工单列头「大区」「网点所属州」文案改为签收网点口径，与共享词条隔离
  signSiteRegion: {
    zh: '签收网点所属大区',
    en: '',
    pu: 'Região do site de entrega'
  },
  signSiteState: {
    zh: '签收网点所属州',
    en: '',
    pu: 'Estado do site de entrega'
  },
  printNumber: {
    zh: '打印次数',
    en: '',
    pu: 'número de vezes da impressão'
  },
  printTime: {
    zh: '打印时间',
    en: '',
    pu: 'Tempo da impressão'
  },
  customerMsg: {
    zh: '客户信息',
    en: '',
    pu: 'Informações do cliente'
  },
  LanShouPersonnel: {
    zh: '揽收人员',
    en: '',
    pu: 'responsável pela coleta'
  },
  LanShouP: {
    zh: '揽收人员：',
    en: '',
    pu: 'responsável pela coleta：'
  },
  name: {
    zh: '姓名：',
    en: 'name：',
    pu: 'nome：'
  },
  lanshouMsg: {
    zh: '揽收信息',
    en: '',
    pu: 'Informações da coleta'
  },
  ticket: {
    zh: '票',
    en: 'ticket',
    pu: 'ordem'
  },
  customerSignature: {
    zh: '客户签名',
    en: '',
    pu: 'Assinatura do cliente'
  },
  cancel: {
    zh: '取消',
    en: 'cancel',
    pu: 'Cancelar'
  },
  confirm: {
    zh: '确定',
    en: 'determine',
    pu: 'Confirmar'
  },
  tableUpdatedPrintTimes: {
    zh: '查询表已更新打印次数',
    en: '',
    pu: 'Número de vezes de impressão do formulário de consulta já foi atualizado'
  },
  packageCollected: {
    zh: '当前包裹已揽收',
    en: '',
    pu: 'O pacote já foi coletado'
  },
  packageCollected1: {
    zh: '当前包裹已揽收！',
    en: '',
    pu: 'O pacote já foi coletado！'
  },
  pleaseCheckAndInput: {
    zh: '请选择条件查询并输入内容',
    en: '',
    pu: 'Favor selecionar as condições e digitir o conteúdo'
  },
  inputClientName: {
    zh: '请输入客户名称',
    en: '',
    pu: 'Por favor, digite o nome do cliente'
  },
  pleaseCheckMsg: {
    zh: '请选择条件查询内容',
    en: '',
    pu: 'Favor selecionar as condições para consultar o conteúdo'
  },
  inputParcelNumber: {
    zh: '请输入包裹号',
    en: '',
    pu: 'Favor inserir o número do pacote'
  },
  nullClientID: {
    zh: '客户id不存在，请重新搜索客户名称',
    en: '',
    pu: 'ID do cliente não existe, por favor pesquisar novamente o nome do cliente'
  },
  checkMsg: {
    zh: '请勾选数据',
    en: '',
    pu: 'Por favor, assinale os dados'
  },
  OnlyAllowedThreeMonthsOfData: {
    zh: '只允许查3个月内的数据',
    en: '',
    pu: 'Somente os dados dentro de 3 meses podem ser verificados'
  },
  OnlyAllowedOneMonthsOfData: {
    zh: '只允许查1个月内的数据',
    en: '',
    pu: 'Somente os dados dentro de 1 meses podem ser verificados'
  },
  checkExportList: {
    zh: '请选择需要导出的数据',
    en: '',
    pu: 'Por favor, selecione os dados a serem exportados'
  },
  tips: {
    zh: '提示',
    en: 'tips',
    pu: 'Dica'
  },
  exportSuccessMessage: {
    zh: '导出成功，数据将会在1~10分钟内生成表格，请到技术支持中心中的资源任务列表中下载，',
    en: 'Export successful, data will be generated into a spreadsheet within 1-10 minutes, please download from the resource task list in the Technical Support Center.',
    pu: 'Exportação bem-sucedida, os dados serão gerados em uma planilha dentro de 1-10 minutos, faça o download na lista de tarefas de recursos do Centro de Suporte Técnico,'
  },
  ExportSuccessful: {
    zh: '导出成功，数据将会在1~10分钟内生成表格，请到系统管理中的资源导出列表中下载，',
    en: 'If the export is successful, the data will be generated within 1~10 minutes, please download it from the resource export list in system management.',
    pu: 'A exportação foi bem sucedida, os dados serão gerados em 1 a 10 minutos, favor descarregá-los da lista de exportação de recursos no gerenciamento do sistema,'
  },
  ExportIsSuccessful: {
    zh: '如导出成功数据将会在1~10分钟内生成表格，请到系统管理中的',
    en: 'If the data is successfully exported, the table will be generated within 1~10 minutes, please go to',
    pu: 'Se os dados forem exportados com sucesso, a tabela será gerada dentro de 1 ~ 10 minutos, vá para'
  },
  ExportSuccessful1: {
    zh: '导出成功',
    en: 'Export successful',
    pu: 'Exportação bem-sucedida'
  },
  AListOfResourceExports: {
    zh: '资源导出列表',
    en: 'A list of resource exports',
    pu: 'Uma lista de exportações de recursos'
  },
  systemAdministrationToDownload: {
    zh: '中下载，',
    en: 'in the system administration to download,',
    pu: 'na administração do sistema para baixar,'
  },
  notRepeatTheExport: {
    zh: '请勿重复导出',
    en: 'Do not repeat the export！',
    pu: 'Não repita a exportação！'
  },
  CheckBackLater: {
    zh: '稍后查看',
    en: 'Check back later',
    pu: 'Volte mais tarde'
  },
  CheckItOutNow: {
    zh: '确认导出',
    en: 'Check it out now',
    pu: 'Confirmar a exportação'
  },
  ExportAs: {
    zh: '导出为',
    en: 'Export as',
    pu: 'Exportar como'
  },
  close: {
    zh: '关闭',
    en: 'Shut down',
    pu: 'Fechar'
  },
  Immediately: {
    zh: '立即前往',
    en: 'Go now',
    pu: 'Ir para'
  },
  // 揽收订单 -----------
  lanshouOrder: {
    zh: '揽收订单',
    en: '',
    pu: 'Pedido de Coleta'
  },
  lanshouOrderNumber: {
    zh: '揽收订单号：',
    en: '',
    pu: ' Número do pedido de coleta：'
  },
  orderNumber: {
    zh: '订单号',
    en: 'orderNumber',
    pu: 'Número do pacote'
  },
  site: {
    zh: '网点：',
    en: '',
    pu: 'Agência：'
  },
  orderStatus: {
    zh: '订单状态：',
    en: 'orderStatus：',
    pu: 'Status do pedido：'
  },
  SendZipCode: {
    zh: '寄件邮编：',
    en: '',
    pu: 'CEP remetente：'
  },
  SendZipcode: {
    zh: '寄件邮编',
    en: '',
    pu: 'CEP remetente'
  },
  receiptZipCode: {
    zh: '收件邮编：',
    en: '',
    pu: 'CEP destinatário：'
  },
  driver: {
    zh: '司机：',
    en: '',
    pu: 'motorista：'
  },
  bagsNumber: {
    zh: '袋号：',
    en: '',
    pu: 'número da saca：'
  },
  schedulingDriver: {
    zh: '调度司机',
    en: '',
    pu: 'Motoristas de despacho'
  },
  schedulingDriverAgain: {
    zh: '重新调度司机',
    en: '',
    pu: 'Redespachar motorista'
  },
  cancelSchedule: {
    zh: '取消调度',
    en: '',
    pu: 'cancelar o despacho'
  },
  lanshouOrderNum: {
    zh: '揽收订单号',
    en: '',
    pu: 'Número do pedido de coleta'
  },
  BagNumber: {
    zh: '袋号',
    en: 'Bag number',
    pu: 'Número da saca'
  },
  Barcode: {
    zh: '条形码',
    en: 'Barcode',
    pu: 'Código de barras'
  },
  BarcodeL: {
    zh: '条形码：',
    en: 'Barcode: ',
    pu: 'Código de barras：'
  },
  ExpectedCollectionTime: {
    zh: '期望揽收时间',
    en: '',
    pu: 'Tempo previsto para a coleta'
  },
  OrderStatus: {
    zh: '订单状态',
    en: 'Order status',
    pu: 'status do pedido'
  },
  driverName: {
    zh: '司机姓名',
    en: '',
    pu: 'Nome do motorista'
  },
  recipient: {
    zh: '收件人：',
    en: 'recipient：',
    pu: 'destinatário：'
  },
  RecipientMailbox: {
    zh: '收件人邮箱：',
    en: 'Recipient mailbox：',
    pu: 'email do destinatário：'
  },
  RecipientzipCode: {
    zh: '收件人邮编：',
    en: "Recipient's zip code：",
    pu: 'CEP do destinatário：'
  },
  RecipientPhone: {
    zh: '收件人电话：',
    en: "Recipient's phone：",
    pu: 'Telefone do destinatário：'
  },
  receiptState: {
    zh: '收件州：',
    en: '',
    pu: 'Estado destinatário：'
  },
  receiptCity: {
    zh: '收件城市：',
    en: '',
    pu: 'Cidade destinatária：'
  },
  receiptRegional: {
    zh: '收件区：',
    en: '',
    pu: 'Área destinatária：'
  },
  receiptAddress: {
    zh: '收件地址：',
    en: 'The delivery address：',
    pu: 'Endereço destinatário：'
  },
  receiptStreet: {
    zh: '收件街道：',
    en: '',
    pu: 'Avenida destinatária：'
  },
  receiptHouseNumber: {
    zh: '收件门牌号：',
    en: '',
    pu: 'No. da porta destinatário：'
  },
  receiptNeighborhood: {
    zh: '收件人邻里：',
    en: '',
    pu: 'vizinho destinatário: '
  },
  postPerson: {
    zh: '寄件人：',
    en: '',
    pu: 'Remetente：'
  },
  postMail: {
    zh: '寄件人邮箱：',
    en: '',
    pu: 'E-mail do remetente：'
  },
  postZip: {
    zh: '寄件人邮编：',
    en: '',
    pu: 'CEP do remetente：'
  },
  postTel: {
    zh: '寄件人电话：',
    en: '',
    pu: 'Tel. do remetente：'
  },
  postZ: {
    zh: '寄件人邮编',
    en: '',
    pu: 'CEP do remetente'
  },
  postT: {
    zh: '寄件人电话',
    en: '',
    pu: 'Tel. do remetente'
  },
  postState: {
    zh: '寄件州：',
    en: '',
    pu: 'Estado remetente：'
  },
  postCity: {
    zh: '寄件城市：',
    en: '',
    pu: 'Cidade remetente：'
  },
  postRegional: {
    zh: '寄件区：',
    en: '',
    pu: 'área remetente：'
  },
  postAddress: {
    zh: '寄件地址：',
    en: '',
    pu: 'Endereço remetente：'
  },
  postAds: {
    zh: '寄件地址',
    en: '',
    pu: 'Endereço remetente'
  },
  postStreet: {
    zh: '寄件街道：',
    en: '',
    pu: 'Avenida remetente：'
  },
  postHouseNumber: {
    zh: '寄件门牌号：',
    en: '',
    pu: 'No. da porta remetente：'
  },
  postNeighborhood: {
    zh: '寄件人邻里：',
    en: '',
    pu: 'Vizinho remetente：'
  },
  notLanShou: {
    zh: '未揽收',
    en: '',
    pu: 'Não coletado'
  },
  hasLanShou: {
    zh: '已揽收',
    en: '',
    pu: 'coletado'
  },
  cancelled: {
    zh: '已取消',
    en: '',
    pu: 'Cancelado'
  },
  LanShouing: {
    zh: '揽收中',
    en: '',
    pu: 'a coletando'
  },
  WarehouseProcessing: {
    zh: '仓库处理',
    en: '',
    pu: 'Processamento de armazém'
  },
  scheduled: {
    zh: '已调度',
    en: '',
    pu: 'despachado'
  },
  AbnormalLanShou: {
    zh: '揽收异常',
    en: '',
    pu: 'excepção da coleta'
  },
  haveBeenSigned: {
    zh: '已签收',
    en: '',
    pu: 'Pedido entregue'
  },
  pleaseCheckSite: {
    zh: '请选择网点',
    en: '',
    pu: 'Selecione uma tomada'
  },
  pleaseCheckDriver: {
    zh: '请选择司机',
    en: '',
    pu: 'Favor selecionar a motorista'
  },
  schedulingSuccess: {
    zh: '调度成功',
    en: '',
    pu: 'Despacho bem-sucedido'
  },
  // 网点 ----------------------
  siteManagement: {
    zh: '网点管理',
    en: '',
    pu: 'Gestão de Pontos'
  },
  createTime: {
    zh: '创建时间：',
    en: 'createTime：',
    pu: 'Tempo de criação：'
  },
  siteTitle: {
    zh: '网点名称：',
    en: '',
    pu: 'Nome de ponto：'
  },
  add: {
    zh: '新增',
    en: 'add',
    pu: 'Novo'
  },
  SubordinateDistribution: {
    zh: '所属分拨',
    en: '',
    pu: 'distribuição'
  },
  siteCondition: {
    zh: '网点状态',
    en: '',
    pu: 'Status do site'
  },
  CreationTime: {
    zh: '创建时间',
    en: 'Creation time',
    pu: 'Tempo de criação'
  },
  creator: {
    zh: '创建人',
    en: 'creator',
    pu: 'Criado por'
  },
  ModificationTime: {
    zh: '修改时间',
    en: 'Modification time',
    pu: 'Tempo de modificação'
  },
  ModifiedBy: {
    zh: '修改人',
    en: 'Modified by',
    pu: 'Modificado por'
  },
  Zip: {
    zh: '邮编',
    en: 'Zip',
    pu: 'CEP'
  },
  state: {
    zh: '州',
    en: 'state',
    pu: 'Estado'
  },
  city: {
    zh: '城市',
    en: 'city',
    pu: 'Cidade'
  },
  Area: {
    zh: '区',
    en: 'Area',
    pu: 'Distrito'
  },
  openBank: {
    zh: '开户银行',
    en: '',
    pu: 'Banco de abertura de conta'
  },
  RecipientStreet: {
    zh: '街道',
    en: 'Recipient street',
    pu: 'Rua Destinatário'
  },
  typeOperation: {
    zh: '操作类型：',
    en: 'The type of operation：',
    pu: 'Tipo de operação：'
  },
  edit: {
    zh: '编辑',
    en: 'Edit',
    pu: 'Editar'
  },
  Delete: {
    zh: '删除',
    en: 'Delete',
    pu: 'Excluir'
  },
  MoreActions: {
    zh: '更多操作',
    en: 'More actions',
    pu: 'Mais ações'
  },
  siteAllocation: {
    zh: '网点所属分拨：',
    en: '',
    pu: 'Subdistribuição do site'
  },
  openTheBank: {
    zh: '开户银行：',
    en: '',
    pu: 'Banco de abertura de conta：'
  },
  zipCode: {
    zh: '邮编：',
    en: 'Zip: ',
    pu: 'CEP：'
  },
  stateSite: {
    zh: '网点所属州',
    en: '',
    pu: 'Estado do ponto'
  },
  citySite: {
    zh: '城市',
    en: '',
    pu: 'Cidade'
  },
  AreaSite: {
    zh: '网点所属区：',
    en: '',
    pu: 'Distrito'
  },
  operationType: {
    zh: '操作类型',
    en: 'The type of operation',
    pu: 'Tipo de operação'
  },
  notStarted: {
    zh: '未开始',
    en: '',
    pu: 'Não começou'
  },
  completed: {
    zh: '已完成',
    en: 'completed',
    pu: 'Concluído'
  },
  cancellation: {
    zh: '已作废',
    en: '',
    pu: 'Anulado'
  },
  ifEnabled: {
    zh: '是否启用：',
    en: '',
    pu: 'Ativar ou não：'
  },
  enable: {
    zh: '启用',
    en: 'enable',
    pu: 'Ativar'
  },
  Disable: {
    zh: '停用',
    en: 'Disable',
    pu: 'Desativar'
  },
  notEnabled: {
    zh: '未启用',
    en: '',
    pu: 'desativo'
  },
  head: {
    zh: '负责人：',
    en: '',
    pu: 'responsável：'
  },
  contactPhone: {
    zh: '联系电话：',
    en: '',
    pu: 'tel. de contato：'
  },
  contactTel: {
    zh: '联系电话',
    en: '',
    pu: 'Telefone'
  },
  Save: {
    zh: '保存',
    en: 'Save',
    pu: 'Salvar'
  },
  empty: {
    zh: '清空',
    en: 'empty',
    pu: 'Limpar'
  },
  Confirm: {
    zh: '确认',
    en: '',
    pu: 'confirmar'
  },
  notNull: {
    zh: '不能为空',
    en: 'Cannot be empty',
    pu: 'Não pode estar vazio'
  },
  inputLong6: {
    zh: '请填写长度6至30位的字母+数字组合',
    en: '',
    pu: 'Preencha uma combinação de letras + números de 6 a 30 dígitos.'
  },
  inputLong6To10: {
    zh: '请填写长度6至10位的字母+数字组合',
    en: '',
    pu: 'Preencha uma combinação de letras + números de 6 a 10 dígitos.'
  },
  inputLong2To10: {
    zh: '请填写2至10位纯数字，或6至10位字母+数字组合',
    en: '',
    pu: 'Preencha 2 a 10 dígitos numéricos ou uma combinação de letras + números de 6 a 10 dígitos.'
  },
  long4to100: {
    zh: '长度不能少于4位，不能大于100位',
    en: '',
    pu: 'O comprimento não pode ser inferior a 4 dígitos e não pode ser superior a 100 dígitos'
  },
  long4To10: {
    zh: '长度不能少于4位，不能大于10位',
    en: '',
    pu: 'O comprimento não pode ser inferior a 4 dígitos e não pode ser superior a 10 dígitos'
  },

  lanshou: {
    zh: '揽收',
    en: '',
    pu: 'Coleta'
  },
  returnCourier: {
    zh: '退件',
    en: '',
    pu: 'devolução'
  },
  SaveSuccessfully: {
    zh: '保存成功',
    en: 'Save successfully',
    pu: 'Salvar com sucesso'
  },
  DeleteSucceeded: {
    zh: '删除成功',
    en: 'Delete succeeded',
    pu: 'Exclusão bem-sucedida'
  },
  ModificationSuccessful: {
    zh: '修改成功',
    en: 'Modification successful',
    pu: 'Modificação bem sucedida'
  },
  // 司机管理 --------------
  driverManagement: {
    zh: '司机管理',
    en: '',
    pu: 'Gerenciamento de motorista'
  },
  accountState: {
    zh: '状态：',
    en: 'state：',
    pu: 'status：'
  },
  belongToSite: {
    zh: '所属网点：',
    en: 'belonging point：',
    pu: 'Ponto Responsável：'
  },
  driverN: {
    zh: '司机姓名：',
    en: '',
    pu: 'Nome do motorista：'
  },
  resetPassword: {
    zh: '重置密码',
    en: 'reset password',
    pu: 'redefinir a senha'
  },
  driverNum: {
    zh: '司机编号',
    en: '',
    pu: 'No. do motorista'
  },
  theDriverName: {
    zh: '司机名称',
    en: '',
    pu: 'Nome do motorista'
  },
  belongSite: {
    zh: '所属网点',
    en: 'belonging point',
    pu: 'Ponto Responsável'
  },
  ifUse: {
    zh: '是否启用',
    en: '',
    pu: 'Ativar ou não'
  },
  contact: {
    zh: '联系方式',
    en: '',
    pu: 'contato'
  },
  updateSite: {
    zh: '修改网点',
    en: '',
    pu: 'Modificar tomadas'
  },
  driverNumber: {
    zh: '司机编号：',
    en: '',
    pu: 'No. do motorista: '
  },
  realNameL: {
    zh: '真实姓名：',
    en: '',
    pu: 'nome real：'
  },
  AccStatus: {
    zh: '账号状态：',
    en: '',
    pu: 'status da conta: '
  },
  telephoneNumber: {
    zh: '电话号码：',
    en: 'telephone number: ',
    pu: 'número telefônico: '
  },
  mailbox: {
    zh: '邮箱：',
    en: 'mailbox：',
    pu: 'email：'
  },
  spareMailbox: {
    zh: '备用邮箱：',
    en: '',
    pu: 'e-mail alternativo'
  },
  OpPwd: {
    zh: '操作密码：',
    en: '',
    pu: 'senha de operação：'
  },
  inputNumber: {
    zh: '请输入6到10位编号',
    en: '',
    pu: 'Por favor, digite um número de 6 a 10 dígitos'
  },
  onlyHalfAYear: {
    zh: '只允许查半年内的数据',
    en: '',
    pu: 'Somente os dados dentro de seis meses podem ser verificados'
  },
  inputOpPwd: {
    zh: '请输入操作密码',
    en: '',
    pu: 'Por favor, digite a senha de operação'
  },
  checkResetPwd: {
    zh: '请勾选需要重置密码的数据项',
    en: '',
    pu: 'Assinale os itens de dados que requerem redefinição de senha'
  },
  ifResetPwd: {
    zh: '是否需要重置改密码？ 初始密码为：123456',
    en: '',
    pu: 'Precisa redefinir e mudar senha? A senha inicial é: 123456'
  },
  resetSucceeded: {
    zh: '重置成功',
    en: '',
    pu: 'redefinir com sucesso'
  },
  Null: {
    zh: '暂无',
    en: 'No',
    pu: 'Não'
  },
  NoContentYet: {
    zh: '暂无内容',
    en: 'No content yet',
    pu: 'Nenhum conteúdo ainda'
  },
  // 签收查询
  signForQuery: {
    zh: '签收查询',
    en: '',
    pu: 'Consulta de Confirmações de Entrega'
  },
  signTime: {
    zh: '签收时间：',
    en: '',
    pu: 'Tempo de Assinatura：'
  },
  signT: {
    zh: '签收时间',
    en: '',
    pu: 'Tempo de Assinatura'
  },
  bigBagNumber: {
    zh: '大包号：',
    en: '',
    pu: 'Grande bolsa：'
  },
  packageNumber: {
    zh: '大包号',
    en: '',
    pu: 'Grande bolsa'
  },
  addresserCode: {
    zh: '发件人编码',
    en: '',
    pu: 'código do remetente'
  },
  addresser: {
    zh: '发件人',
    en: '',
    pu: 'Remetente'
  },
  ExpectedNumberOfDeliveries: {
    zh: '预计派件数',
    en: '',
    pu: 'quantidade estimada de pacotes entregues'
  },
  ActualNumberOfDispatches: {
    zh: '实际派件数',
    en: '',
    pu: 'quantidade real de pacotes entregues'
  },
  SendPerson: {
    zh: '派件人',
    en: '',
    pu: 'entregador'
  },
  signer: {
    zh: '签收人',
    en: '',
    pu: 'signatário'
  },
  signImage: {
    zh: '签收图片',
    en: '',
    pu: 'imagem de entrega'
  },
  note: {
    zh: '备注：',
    en: 'remark: ',
    pu: 'observações: '
  },
  Note: {
    zh: '备注',
    en: 'remark',
    pu: 'observações'
  },
  RegistrationTime: {
    zh: '登记时间：',
    en: '',
    pu: 'Data de registro：'
  },
  RegistrationT: {
    zh: '登记时间',
    en: '',
    pu: 'Data de registro'
  },
  customerMerchantNum: {
    zh: '客户商户号：',
    en: '',
    pu: 'razão social do cliente: '
  },
  ifExists: {
    zh: '请点击搜索按钮确认客户是否存在',
    en: '',
    pu: 'Favor clicar no botão de busca para verificar se o cliente existev'
  },
  PackageExist: {
    zh: '当前包裹号重复',
    en: '',
    pu: 'Duplicação o número do pacote atual'
  },
  ReceivingAbnormalPush: {
    zh: '揽收异常推送',
    en: '',
    pu: 'Empurrão de exceção de coleta'
  },
  NameOfCustomerMerchant: {
    zh: '客户商户名称',
    en: '',
    pu: 'razão social do cliente'
  },
  ProblemPiece: {
    zh: '问题件',
    en: 'Problem piece',
    pu: 'Registrar anomalia'
  },
  CauseOfTheProblem: {
    zh: '问题件原因：',
    en: '',
    pu: 'Motivo da Ocorrência：'
  },
  CauseOfTheP: {
    zh: '问题件原因',
    en: '',
    pu: 'Motivo da Ocorrência'
  },
  AreYouSureToSave: {
    zh: '是否确认保存?',
    en: '',
    pu: 'tem certeza de salvar?'
  },
  registrar: {
    zh: '登记人',
    en: '',
    pu: 'Registrador'
  },
  ProblemFileRegistrationQuery: {
    zh: '问题件登记查询',
    en: '',
    pu: 'consulta de registro de pacotes problemáticos'
  },
  ProblemFileRegistration: {
    zh: '问题件登记',
    en: '',
    pu: 'registro de pacotes problemáticos'
  },
  ProblemPieceProcessing: {
    zh: '问题件处理',
    en: '',
    pu: 'tratamento de pacotes problemáticos'
  },
  DataRecovery: {
    zh: '数据恢复',
    en: '',
    pu: 'Recuperação de dados'
  },
  MerchantNum: {
    zh: '商户号',
    en: '',
    pu: 'SELLER ID'
  },
  MerchantNumBer: {
    zh: '商户号：',
    en: '',
    pu: 'Número do comerciante：'
  },
  MerchantName: {
    zh: '商户名称',
    en: '',
    pu: 'Nome do Mercador'
  },
  MerchantN: {
    zh: '商户名称：',
    en: '',
    pu: 'Nome do Mercador：'
  },
  MerchantCode: {
    zh: '商户编码',
    en: '',
    pu: 'Código do Mercador'
  },
  TheSenderCouldNotBeReached: {
    zh: '联系不上发件人',
    en: '',
    pu: 'O remetente não pode ser contatado'
  },
  TheMailingAddressCouldNotBeFound: {
    zh: '发件地址找不到',
    en: '',
    pu: 'Endereço remetente não encontrado'
  },
  PackageFound: {
    zh: '包裹未找到',
    en: '',
    pu: 'pacote não encontrado'
  },
  parcelNotReady: {
    zh: '包裹未准备好',
    en: '',
    pu: 'Pacote não pronto'
  },
  cancelOrder: {
    zh: '取消订单',
    en: '',
    pu: 'Cancelar o pedido'
  },
  TimeoutLanShou: {
    zh: '超时揽收',
    en: '',
    pu: 'coleta fora do tempo-limite'
  },
  goodsWasRobbed: {
    zh: '货物被抢',
    en: '',
    pu: 'mercadoria roubada'
  },
  other: {
    zh: '其他',
    en: '',
    pu: 'outros'
  },
  NumName: {
    zh: '商户号/商户名称：',
    en: '',
    pu: 'Número do comerciante/Nome do comerciante：'
  },
  packageMsg: {
    zh: '包裹详情',
    en: '',
    pu: 'Detalhes do pacote'
  },
  BatchQuery: {
    zh: '支持批量查询(回车换行分割)',
    en: '',
    pu: 'Suporta a busca de lotes (múltiplas quebras de linha são inseridas)'
  },
  orderCreateTime: {
    zh: '订单创建时间：',
    en: 'createTime：',
    pu: 'Tempo de criação：'
  },
  orderCreateT: {
    zh: '订单创建时间',
    en: '',
    pu: 'Tempo de criação'
  },
  restoreSuccess: {
    zh: '恢复成功!',
    en: '',
    pu: 'Sucesso na recuperação!'
  },
  chooseCustomerName: {
    zh: '请选择客户名称',
    en: '',
    pu: 'Selecione o nome do cliente'
  },
  tableUpdated: {
    zh: '已生成确认单',
    en: '',
    pu: 'Tabela Atualizada'
  },
  pollList: {
    zh: '票数信息',
    en: '',
    pu: 'Informação de ordem'
  },
  createReceivingListNum: {
    zh: '生成的揽收清单号为：',
    en: '',
    pu: 'No.de lista de coleta atualizada: '
  },
  // 期望揽收时间：
  ExpectedCollectionT: {
    zh: '期望揽收时间：',
    en: '',
    pu: 'Tempo previsto para a coleta: '
  },
  ExpectedCollectionStartTime: {
    zh: '期望揽收 - 开始时间',
    en: '',
    pu: 'Tempo previsto para a coleta - Tempo de início '
  },
  ExpectedCollectionEndTime: {
    zh: '期望揽收 - 结束时间',
    en: '',
    pu: 'Tempo previsto para a coleta - Tempo de fim'
  },
  LanShouAddress: {
    zh: '揽收地址：',
    en: '',
    pu: 'endereço para coleta：'
  },
  confirmSchedule: {
    zh: '确认调度?',
    en: '',
    pu: 'Confirma o despacho?'
  },
  lanshouImg: {
    zh: '揽收图片',
    en: '',
    pu: 'Imagem de coleta'
  },
  LanShouDriver: {
    zh: '揽收司机：',
    en: '',
    pu: 'motorista de coleta：'
  },
  TotalNumberOfOrdersReceived: {
    zh: '总揽收订单数',
    en: '',
    pu: 'QUANTIDADE TOTAL DE PEDIDOS A SEREM COLETADOS'
  },
  ActualNumberOfOrdersReceived: {
    zh: '实际已揽收订单数',
    en: '',
    pu: 'QUANTIDADE DE PEDIDOS COLETADOS REAL'
  },
  NumberOfUnreceivedOrders: {
    zh: '未揽收订单数',
    en: '',
    pu: 'QUANTIDADES DE PEDIDOS NÃO COLETADOS'
  },
  AbnormalNumberOfOrdersReceived: {
    zh: '揽收异常订单数',
    en: '',
    pu: 'QUANTIDADE DE EXCEÇÕES DE PEDIDOS DE COLETA/ QUANTIDADE DE PEDIDOS DE COLETA ANOMALIA'
  },
  SuccessRateOfCollection: {
    zh: '揽收成功率',
    en: '',
    pu: 'Taxa de sucesso da coleta'
  },
  PleaseSelectTime: {
    zh: '请选择日期时间',
    en: '',
    pu: 'Favor selecionar uma data e hora'
  },
  summary: {
    zh: '汇总',
    en: '',
    pu: 'resumo'
  },
  huiz: {
    zh: '汇总：',
    en: '',
    pu: 'resumo：'
  },
  particulars: {
    zh: '明细',
    en: '',
    pu: 'Detalhes'
  },
  Number: {
    zh: '单号',
    en: '',
    pu: 'Número de pedido'
  },
  LanShouSite: {
    zh: '揽收网点',
    en: '',
    pu: 'Pontos de coleta'
  },
  LSSite: {
    zh: '揽收网点：',
    en: '',
    pu: 'Pontos de coleta：'
  },
  resetPasswordL: {
    zh: '重置密码：',
    en: 'reset password：',
    pu: 'redefinir a senha：'
  },
  inputPwdAgian: {
    zh: '请再次输入新密码',
    en: '',
    pu: 'Favor digitar nova senha novamente'
  },
  passwordPrompt: {
    zh: '密码必须由 8-12位字母、数字组成，可选特殊符号.',
    en: '',
    pu: 'A senha deve ser composta de 8-12 letras e números, com a opção de símbolos especiais.'
  },
  defaultPassword: {
    zh: '默认密码',
    en: '',
    pu: 'senha padrão'
  },
  newPassword: {
    zh: '新密码',
    en: 'new password',
    pu: 'nova senha'
  },
  requestedInputCode: {
    zh: '请按照要求输入密码',
    en: 'Please enter the password as required',
    pu: 'Por favor digitar a senha conforme requerido'
  },
  checkPwd: {
    zh: '确认密码',
    en: 'Confirm password',
    pu: 'Confirmar senha'
  },
  inputConfirmCode: {
    zh: '请输入确认密码',
    en: 'Please confirm your password',
    pu: 'Introduza a senha de confirmação, por favor'
  },
  checkPwdNotNewPwd: {
    zh: '确认密码与新密码不相同',
    en: '',
    pu: 'a senha de confirmação não é a mesma que a nova senha'
  },
  operator: {
    zh: '操作人',
    en: 'operator',
    pu: 'Operador'
  },
  describe: {
    zh: '描述',
    en: '',
    pu: 'descrição'
  },
  ContactNumber: {
    zh: '联系人电话',
    en: '',
    pu: 'telefone'
  },
  selectedTimeThanCurrentTime: {
    zh: '选中时间需大于当前时间',
    en: '',
    pu: 'tempo seleccionado deve ser superior ao tempo actual'
  },
  addressCollection: {
    zh: '揽收地址',
    en: '',
    pu: 'endereço para coleta'
  },
  BatchRepush: {
    zh: '批量重推',
    en: '',
    pu: 'Batch Re-push'
  },
  OperationSite: {
    zh: '操作网点',
    en: '',
    pu: 'Locais de operação'
  },
  PushResults: {
    zh: '推送结果',
    en: '',
    pu: 'Resultados de push'
  },
  pushresults: {
    zh: '推送结果：',
    en: '',
    pu: 'Resultados de push：'
  },
  OnTheWay: {
    zh: '投递中',
    en: '',
    pu: 'Entrega em andamento'
  },
  DeliveredSuccessfully: {
    zh: '投递成功',
    en: '',
    pu: 'Entrega com sucesso'
  },
  FailureDeliver: {
    zh: '投递失败',
    en: '',
    pu: 'Falha na entrega'
  },
  SuccessConsumption: {
    zh: '消费成功',
    en: '',
    pu: 'Consumo com sucesso'
  },
  FailureConsume: {
    zh: '消费失败',
    en: '',
    pu: 'Consumo falhou'
  },
  PushContent: {
    zh: '推送内容',
    en: '',
    pu: 'Conteúdo de Push'
  },
  UpToOneYear: {
    zh: '最多可查询到一年的轨迹数据',
    en: '',
    pu: 'Pode pesquisar o rastreamento até um ano '
  },
  PleaseReselectIt: {
    zh: '所选数据不符合要求，已消费成功数据不支持重新推送，请重新勾选',
    en: '',
    pu: 'Os dados selecionados não atendem aos requisitos, os dados de consumo bem sucedidos não suportam o re-push, por favor, verifique novamente assinale.'
  },
  byTimeRange: {
    zh: '按时间范围',
    en: '',
    pu: ' por faixa de tempo'
  },
  orderNumberHasBeenSigned: {
    zh: '已签收订单数',
    en: '',
    pu: 'QUANTIDADE DE PEDIDOS ASSINADOS'
  },
  orderNumberHasBeenCancelled: {
    zh: '已取消订单数',
    en: '',
    pu: 'QUANTIDADE DE PEDIDOS CANCELADOS'
  },
  byOdd: {
    zh: '按单号',
    en: '',
    pu: 'por número de ordem'
  },
  unsigned: {
    zh: '未签名!',
    en: '',
    pu: 'Não assinado'
  },
  SealedBag: {
    zh: '已封袋',
    en: '',
    pu: 'saco selado'
  },
  PleaseEnterPhone: {
    zh: '请输入手机号',
    en: '',
    pu: 'Favor digitar o número de telefone'
  },
  PushTrack: {
    zh: '轨迹推送',
    en: '',
    pu: 'Push de Rastreamento'
  },
  consumptionNumber: {
    zh: '消费次数',
    en: '',
    pu: 'Número de consumos'
  },
  hasNotBeenObtainedPleaseTryAgain: {
    zh: '还未获取到揽收图片，请稍后再保存',
    en: '',
    pu: 'Eu não obtive a coleção de fotos, salve -a mais tarde'
  },
  scannedPackageID: {
    zh: '当前被扫描的包裹号为：',
    en: '',
    pu: 'O número do pacote atualmente digitalizado é：'
  },
  pgMsg: {
    zh: '揽收包裹明细',
    en: '',
    pu: 'Detalhamento da Recolha de Pacotes'
  },
  pgBarCode: {
    zh: '包裹条形码',
    en: '',
    pu: 'Código de barras de pacotes '
  },
  pgTotal: {
    zh: '包裹总计：',
    en: '',
    pu: 'Total de pacotes：'
  },
  loading: {
    zh: '正在努力加载中...',
    en: '',
    pu: 'Carregamento em andamento...'
  },
  ParcelSubtotal: {
    zh: '包裹小计：',
    en: '',
    pu: 'Subtotal de pacotes：'
  },
  RangeEarningRate: {
    zh: '揽收率',
    en: '',
    pu: 'PORCENTAGEM DE COLETADOS'
  },
  RateOfSigning: {
    zh: '签收率',
    en: '',
    pu: 'PORCENTAGEM DE ASSINADOS'
  },
  SealedBagOrderNumber: {
    zh: '已封袋订单数',
    en: '',
    pu: 'QUANTIDADES DE PEDIDOS SELADOS/LACRADOS'
  },
  signSite: {
    zh: '签收网点',
    en: '',
    pu: 'Ponto de assinatura'
  },
  MonitoringReport: {
    zh: '订单揽收监控报表',
    en: '',
    pu: 'Relatório de Monitoramento de Pedidos de Coleta'
  },
  collectXlsx: {
    zh: '订单揽收监控报表汇总',
    en: '',
    pu: 'Resumo do relatório de monitoramento da coleta de pedidos'
  },
  detailXlsx: {
    zh: '订单揽收监控报表明细',
    en: '',
    pu: 'Detalhes do relatório de monitoramento da coleta de pedidos'
  },
  selectData: {
    zh: '请选择需要操作的数据!',
    en: '',
    pu: 'Por favor, selecione os dados a serem manipulados!'
  },
  SendSMS: {
    zh: '发送短信',
    en: '',
    pu: 'mensagens'
  },
  pleaseEnterInteger: {
    zh: '请输入整数',
    en: '',
    pu: 'Por favor, insira o número inteiro'
  },
  enclosure: {
    zh: '附件：',
    en: 'enclosure：',
    pu: 'anexo：'
  },
  enclosureFJ: {
    zh: '附件',
    en: 'enclosure',
    pu: 'anexo'
  },
  cldrUpload: {
    zh: '点击或拖拽文件到此处上传',
    en: '',
    pu: 'Clicar ou arrastar arquivo para upload aqui'
  },
  OnlyImageFormatIsSupported: {
    zh: '仅支持png、bmp、jpg、jpeg格式的图片',
    en: '',
    pu: 'Apenas imagens nos formatos png, bmp, jpg e jpeg são suportadas'
  },
  SMSType: {
    zh: '短信类型：',
    en: '',
    pu: 'Tipo de mensagem de texto：'
  },
  messageType: {
    zh: '短信类型',
    en: '',
    pu: 'Tipo de mensagem de texto'
  },
  SMSStatus: {
    zh: '短信状态：',
    en: '',
    pu: 'Estado da mensagem de texto：'
  },
  messageStatus: {
    zh: '短信状态',
    en: '',
    pu: 'Estado da mensagem de texto'
  },
  BatchPush: {
    zh: '批量补推',
    en: '',
    pu: 'Batch multi-selecção e dados push novamente'
  },
  ReceivingCall: {
    zh: '接收电话',
    en: '',
    pu: 'Recepção de chamadas'
  },
  SMSSource: {
    zh: '短信来源',
    en: '',
    pu: 'Fonte da mensagem de texto'
  },
  messageContent: {
    zh: '短信内容',
    en: '',
    pu: 'Conteúdo da mensagem de texto'
  },
  SendingTime: {
    zh: '发送时间',
    en: '',
    pu: 'Hora de envio'
  },
  SendErrorMessage: {
    zh: '发送错误信息',
    en: '',
    pu: 'Envio de mensagens de erro'
  },
  NotSent: {
    zh: '未发送',
    en: '',
    pu: 'Não enviado'
  },
  InTransit: {
    zh: '发送中',
    en: '',
    pu: 'No processo de envio'
  },
  sent: {
    zh: '已发送',
    en: '',
    pu: 'Enviado'
  },
  SendFailure: {
    zh: '发送失败',
    en: '',
    pu: 'Envia falhou'
  },
  ModifyTotalParcelsReceived: {
    zh: '修改揽收包裹总数',
    en: '',
    pu: 'Rever o número total de parcelas recolhidas'
  },
  NumberPackages: {
    zh: '包裹数量',
    en: 'Number of packages',
    pu: 'Número de pacotes'
  },
  packagesReceivedNumber: {
    zh: '揽收包裹数为：',
    en: '',
    pu: 'O número de parcelas recolhidas foi de：'
  },
  intercept: {
    zh: '单次查询最多1000条，已截取前1000条数据',
    en: '',
    pu: 'Consulta única até 1000 dados, os primeiros 1000 dados recebidos'
  },
  intercep2: {
    zh: '单次查询最多2000条，已截取前2000条数据',
    en: '',
    pu: 'Consulta única até 2000 dados, os primeiros 2000 dados recebidos'
  },
  intercept1: {
    zh: '单次查询最多10000条，已截取前10000条数据',
    en: '',
    pu: 'Consulta única até 10000 dados, os primeiros 10000 dados recebidos'
  },
  intercept50: {
    zh: '单次查询最多50条，已截取前50条数据',
    en: '',
    pu: 'Consulta única até 50 dados, os primeiros 50 dados recebidos'
  },
  intercept50000: {
    zh: '单次查询最多50000条，已截取前50000条数据',
    en: '',
    pu: 'Consulta única até 50000 dados, os primeiros 50000 dados recebidos'
  },
  intercept100: {
    zh: '单次查询最多100条，已截取前100条数据',
    en: '',
    pu: 'Consulta única até 100 dados, os primeiros 100 dados recebidos'
  },
  intercept200: {
    zh: '单次查询最多200条，已截取前200条数据',
    en: '',
    pu: 'Consulta única até 200 dados, os primeiros 200 dados recebidos'
  },
  modify: {
    zh: '修改',
    en: 'modify',
    pu: 'Modificar'
  },
  inputNum: {
    zh: '请输入数字',
    en: '',
    pu: 'Favor digitar número'
  },
  input8Sum: {
    zh: '请输入8位数字',
    en: '',
    pu: 'favro digitar 8 dígitos'
  },
  emailNotFormat: {
    zh: '邮箱格式不正确',
    en: '',
    pu: 'Formato de e-mail incorreto'
  },
  disable: {
    zh: '禁用',
    en: '',
    pu: 'Proibição de uso'
  },
  contactAddress: {
    zh: '联系地址',
    en: '',
    pu: 'Endereço para contato'
  },
  contactArs: {
    zh: '联系地址：',
    en: '',
    pu: 'Endereço para contato：'
  },
  SourceProblemPiece: {
    zh: '问题件来源：',
    en: '',
    pu: 'Fonte do problema：'
  },
  SourcePPiece: {
    zh: '问题件来源',
    en: '',
    pu: 'Fonte do problema'
  },
  merchantEmail: {
    zh: '商户邮箱',
    en: '',
    pu: 'E-mail do comerciante'
  },
  merchantE: {
    zh: '商户邮箱：',
    en: '',
    pu: 'E-mail do comerciante：'
  },
  moreYear: {
    zh: '最多可查询到一年的数据',
    en: '',
    pu: 'Até um ano de dados pesquisáveis'
  },
  MerchantManagement: {
    zh: '商户管理',
    en: '',
    pu: 'Gestão de Lojistas'
  },
  receiverBelongsSite: {
    zh: '揽收人所属网点',
    en: '',
    pu: 'Pontos de venda de propriedade do receptor'
  },
  DataSource: {
    zh: '数据来源',
    en: '',
    pu: 'Fontes de dados'
  },
  receivedPackagesTotalNumber: {
    zh: '已揽收包裹总数',
    en: '',
    pu: 'Número total de parcelas receptadas'
  },
  TotalNumberOfParcelsSignedIn24Hours: {
    zh: '24小时内签收包裹总数',
    en: '',
    pu: 'Número total de pacotes assinados dentro de 24 horas'
  },
  over24HoursUnsignedPackagesTotalNumber: {
    zh: '超24小时未签收包裹总数',
    en: '',
    pu: 'Número total de pacotes não assinados por mais de 24 horas'
  },
  in24UnsignedPackagesTotalNumber: {
    zh: '24小时内未签收包裹总数',
    en: '',
    pu: 'Número total de pacotes não assinados no prazo de 24 horas'
  },
  SigningRateWithin24Hours: {
    zh: '24小时内签收率',
    en: '',
    pu: 'Taxa de assinatura para pacotes dentro de 24 horas'
  },
  signerBelongsSite: {
    zh: '签收人所属网点',
    en: '',
    pu: 'A agência do signatário'
  },
  SignPrescriptionStatement: {
    zh: '签收时效报表汇总',
    en: '',
    pu: 'Resumo das declarações de limitação assinada'
  },
  StatisticsOfSignedPrescriptionStatements: {
    zh: '签收时效报表统计',
    en: '',
    pu: 'Relatório Estatístico de SLA de Assinatura/Confirmação'
  },
  total: {
    zh: '总计：',
    en: 'total：',
    pu: 'total：'
  },
  all: {
    zh: '总计',
    en: '',
    pu: 'total'
  },
  scannedPackagesTotal: {
    zh: '扫描包裹总数',
    en: '',
    pu: 'Número total de pacotes escaneados'
  },
  receivedParcelsTotal: {
    zh: '揽收包裹总数',
    en: '',
    pu: 'Número total de pacotes coletados'
  },
  sealingBagTotal: {
    zh: '封袋总数',
    en: '',
    pu: 'Número total de sacos selados'
  },
  sealingBagTime: {
    zh: '封袋时间',
    en: '',
    pu: 'Tempo de selagem do saco'
  },
  receiveDailyReport: {
    zh: '揽收日报表',
    en: '',
    pu: 'Declaração de dias de coleta'
  },
  vehicleManagement: {
    zh: '车辆管理',
    en: '',
    pu: 'Gestão de veículos'
  },
  carNumber: {
    zh: '车签号',
    en: '',
    pu: 'Número de escaneamento do veículo'
  },
  carID: {
    zh: '车辆编号',
    en: '',
    pu: 'Número do veículo'
  },
  carName: {
    zh: '车辆名称',
    en: '',
    pu: 'Nome do veículo'
  },
  carN: {
    zh: '车辆名称：',
    en: '',
    pu: 'Nome do veículo：'
  },
  licensePlateNumber: {
    zh: '车牌号',
    en: '',
    pu: 'número da placa de identificação'
  },
  licensePlateNum: {
    zh: '车牌号：',
    en: '',
    pu: 'número da placa de identificação：'
  },
  carType: {
    zh: '车辆类型',
    en: '',
    pu: 'Tipo de veículo'
  },
  carT: {
    zh: '车辆类型：',
    en: '',
    pu: 'Tipo de veículo：'
  },
  smallBoxTruck: {
    zh: '小型厢式货车',
    en: '',
    pu: 'Camião pequeno'
  },
  mediumBoxTruck: {
    zh: '中型厢式货车',
    en: '',
    pu: 'Camião médio'
  },
  largeBoxTruck: {
    zh: '大型半挂货车',
    en: '',
    pu: 'Camião semi-reboque grande'
  },
  owningSite: {
    zh: '所属网点',
    en: 'belonging point',
    pu: 'Ponto Responsável'
  },
  vehicleDriver: {
    zh: '车辆驾驶人',
    en: '',
    pu: 'Motorista de veículo'
  },
  vehicleD: {
    zh: '车辆驾驶人：',
    en: '',
    pu: 'Motorista de veículo：'
  },
  operationMode: {
    zh: '运营模式',
    en: 'operationMode',
    pu: 'Modelo de operação'
  },
  operationM: {
    zh: '运营模式：',
    en: 'operationMode',
    pu: 'Modelo de operação：'
  },
  directOperation: {
    zh: '直营',
    en: '',
    pu: 'Filial'
  },
  thirdPartyCooperation: {
    zh: '第三方合作',
    en: '',
    pu: 'Cooperação com terceiros'
  },
  registrant: {
    zh: '登记人',
    en: '',
    pu: 'Registrador'
  },
  codeDownload: {
    zh: '二维码下载',
    en: '',
    pu: 'Download do Código QR'
  },
  codeDownload1: {
    zh: '一维码下载',
    en: '',
    pu: 'Download de código unidimensional'
  },
  register: {
    zh: '登记',
    en: '',
    pu: 'Registro'
  },
  VehicleRegistration: {
    zh: '车辆登记',
    en: '',
    pu: 'Registro de veículos'
  },
  addVehicleRegistration: {
    zh: '新增 - 车辆登记',
    en: '',
    pu: 'Novo - Registro de veículos'
  },
  editVehicleRegistration: {
    zh: '修改 - 车辆登记',
    en: '',
    pu: 'Emendas - Registro de veículos'
  },
  printT: {
    zh: '打印时间：',
    en: '',
    pu: 'Tempo da impressão：'
  },
  printQuantity: {
    zh: '打印数量',
    en: '',
    pu: 'Número de impressões'
  },
  printQ: {
    zh: '打印数量：',
    en: '',
    pu: 'Número de impressões：'
  },
  printer: {
    zh: '打印人',
    en: '',
    pu: 'Impressoras'
  },
  viewDetails: {
    zh: '查看明细',
    en: '',
    pu: 'Ver detalhes'
  },
  pleaseInputNumber: {
    zh: '请输入数字类型',
    en: '',
    pu: 'Por favor, digite o tipo de número'
  },
  startThanEnd: {
    zh: '开始时间不能大于结束时间',
    en: 'The start time cannot be greater than the end time',
    pu: 'O tempo de início não pode ser maior do que o tempo final'
  },
  enterGreaterThan0: {
    zh: '请输入大于0的数字',
    en: 'Please enter a number greater than 0',
    pu: 'Por favor, digite um número maior que 0'
  },
  pleaseInputInteger: {
    zh: '请输入正整数',
    en: '',
    pu: 'Por favor, insira um número inteiro'
  },
  chooseSite: {
    zh: '请选择所属网点',
    en: '',
    pu: 'Selecione a filial à qual você pertence'
  },
  inputPrintSum: {
    zh: '请输入打印数量',
    en: '',
    pu: 'Favor inserir o número de impressões'
  },
  once100: {
    zh: '最多一次可打印100张',
    en: '',
    pu: 'Imprimir até 100 folhas de cada vez'
  },
  sucToPrint: {
    zh: '车签号生成成功，可前往打印',
    en: '',
    pu: 'Número de escaneamento do veículo gerado com sucesso e pronto para impressão'
  },
  printSuc: {
    zh: '打印成功',
    en: '',
    pu: 'Impresso com sucesso'
  },
  generate: {
    zh: '生成',
    en: '',
    pu: 'Gerar'
  },
  msgType: {
    zh: '消息类型：',
    en: '',
    pu: 'Tipo de mensagem：'
  },
  pushMsgType: {
    zh: '消息类型',
    en: '',
    pu: 'Tipo de mensagem'
  },
  truckLoading: {
    zh: '装车',
    en: '',
    pu: 'Carregado'
  },
  unloading: {
    zh: '卸车',
    en: '',
    pu: 'Descarregado'
  },
  consolidateCode: {
    zh: '预装车集货',
    en: '',
    pu: 'código de consolidação'
  },
  // scanLargePackage: {
  //   zh: '请先扫描大包号',
  //   en: '',
  //   pu: 'Por favor, escanear primeiro o número da saca'
  // },
  // scanSmallBag: {
  //   zh: '已有大包号，请扫描小包号',
  //   en: '',
  //   pu: 'Número da saca já disponível, por favor, escanear número de pacote pequeno'
  // },
  scanLargePackage: {
    zh: '请先扫描袋号',
    en: '',
    pu: 'Por favor, digitalizar primeiro o número da saca'
  },
  scanSmallBag: {
    zh: '已有袋号，请扫描包裹号',
    en: '',
    pu: 'Número da saca já disponível, por favor digitalizar o número do pacote'
  },
  mustLargePackage: {
    zh: '包裹必须有一个大包，不能删除',
    en: '',
    pu: 'Os pacotes devem ter o número da saca e não podem ser excluídos'
  },
  largePackageNotBeNull: {
    zh: '大包不能为空，当前包裹号不能删除',
    en: '',
    pu: 'O número da saca não pode estar vazio e o número do pacote atual não pode ser apagado'
  },
  emptyPackage: {
    zh: '空包无法提交',
    en: '',
    pu: 'Pacotes vazios não podem ser submetidos'
  },
  bigPackageExist: {
    zh: '当前大包号重复',
    en: '',
    pu: 'Duplicação atual do grande número de sacas'
  },
  scanBtn: {
    zh: '扫描：',
    en: '',
    pu: 'Bipar：'
  },
  scanTip: {
    zh: '请扫描或输入袋号/包裹号',
    en: '',
    pu: 'Favor escanear ou digitar o Número da saca/número do pacote'
  },
  scanBag: {
    zh: '请扫描或输入袋号',
    en: '',
    pu: 'Favor escanear ou digitar o Número da saca'
  },
  SealingBags: {
    zh: '封袋',
    en: 'Sealing bags',
    pu: 'Fechar Saca'
  },
  bagExist: {
    zh: '当前袋号重复',
    en: '',
    pu: 'Duplicação atual do grande número de sacas'
  },
  Bagged: {
    zh: '已装袋',
    en: 'Bagged',
    pu: 'Ensacado'
  },
  customerNumber: {
    zh: '客户单号：',
    en: 'customerNumber：',
    pu: 'Número do pedido do cliente：'
  },
  customerNum: {
    zh: '客户单号',
    en: 'customerNumber',
    pu: 'Número do pedido do cliente'
  },
  AccountBalance: {
    zh: '账户余额：',
    en: 'Account Balance：',
    pu: 'Saldo da conta：'
  },
  channel: {
    zh: '渠道：',
    en: '',
    pu: 'Canal：'
  },
  providerChannel: {
    zh: '服务商渠道：',
    en: 'providerChannel：',
    pu: 'Canal de fornecedor de serviços：'
  },
  providerC: {
    zh: '服务商：',
    en: 'providerChannel：',
    pu: 'provedor de serviços：'
  },
  sealBagScan: {
    zh: '封袋扫描',
    en: '',
    pu: 'Saca selada e digitalizada'
  },
  nullSubmit: {
    zh: '无数据提交',
    en: '',
    pu: 'Não apresentação de dados'
  },
  dotCode: {
    zh: '网点编号：',
    en: '',
    pu: 'Netpoint nº：'
  },
  dotName: {
    zh: '网点名称：',
    en: '',
    pu: 'Nome de ponto：'
  },
  owningTransitCenter: {
    zh: '所属转运中心：',
    en: '',
    pu: 'HUB de trânsito：'
  },
  businessModel: {
    zh: '经营模式',
    en: '',
    pu: 'Modelo de negócio'
  },
  directSales: {
    zh: '直营',
    en: '',
    pu: 'Filial'
  },
  joinSales: {
    zh: '加盟',
    en: '',
    pu: 'Terceirizado'
  },
  exclusive: {
    zh: '独家',
    en: 'Exclusive',
    pu: 'Exclusivo'
  },
  businessType: {
    zh: '业务类型：',
    en: '',
    pu: 'Tipo de área：'
  },
  businessT: {
    zh: '业务类型',
    en: '',
    pu: 'Tipo de negócio' // 问题件配置优化
  },
  turnTransport: {
    zh: '转运',
    en: '',
    pu: 'Trânsito'
  },
  collect: {
    zh: '揽收',
    en: 'Collect',
    pu: 'Coleta'
  },
  dispatch: {
    zh: '派送',
    en: '',
    pu: 'Entrega'
  },
  zipCodeTitle: {
    zh: '网点邮编',
    en: '',
    pu: 'Código postal do Ponto'
  },
  dotZipCode: {
    zh: '网点邮编：',
    en: '',
    pu: 'Código postal do Ponto：'
  },
  dotState: {
    zh: '网点所属州：',
    en: '',
    pu: 'Estado do ponto：'
  },
  dotCity: {
    zh: '网点所属城市：',
    en: '',
    pu: 'Cidade do ponto de rede：'
  },
  dotArea: {
    zh: '网点所属区域：',
    en: '',
    pu: 'Área do ponto de rede：'
  },
  dotStreet: {
    zh: '网点所属街道：',
    en: '',
    pu: 'Rua a que o ponto pertence：'
  },
  dotAdress: {
    zh: '网点地址：',
    en: '',
    pu: 'Endereço do ponto de rede：'
  },
  longitudeAndLatitude: {
    zh: '经纬度：',
    en: '',
    pu: 'Latitude e longitude：'
  },
  settlementCycle: {
    zh: '结算周期：',
    en: '',
    pu: 'Ciclo de colonização：'
  },
  receivingRange: {
    zh: '揽收范围：',
    en: '',
    pu: 'Âmbito da colecção.'
  },
  deliveryRange: {
    zh: '派送范围：',
    en: '',
    pu: 'Área de entrega.'
  },
  accumulationDeduction: {
    zh: '累计扣款：',
    en: '',
    pu: 'Deduções acumuladas：'
  },
  businessSubject: {
    zh: '业务主体：',
    en: '',
    pu: 'Assunto de negócios：'
  },
  dotTypeCode: {
    zh: '网点类型',
    en: '',
    pu: 'Tipe de ponto'
  },
  dotType: {
    zh: '网点类型：',
    en: '',
    pu: 'Tipe de ponto：'
  },
  hut: {
    zh: '安骏小屋',
    en: '',
    pu: 'Minidrop'
  },
  ColetaTerceirizadaSeller: {
    zh: '揽收第三方上门交件',
    en: '',
    pu: 'Coleta terceirizada no Seller'
  },
  dot: {
    zh: '网点',
    en: '',
    pu: 'Ponto de rede'
  },
  transferCenter: {
    zh: '转运中心',
    en: '',
    pu: 'Hub'
  },
  headOffice: {
    zh: '总部',
    en: '',
    pu: 'Matriz'
  },
  // 网点邮编：格式:1000000~22222222或30000000
  format1: {
    zh: '格式:1000000~22222222或30000000',
    en: '',
    pu: 'Formato:1000000~22222222 ou 30000000'
  },
  format: {
    zh: '格式:1000000~22222222',
    en: '',
    pu: 'Formato:1000000~22222222'
  },
  input8ZipCode: {
    zh: '请输入8位邮编',
    en: '',
    pu: 'Favor digitar o CEP de 8 dígitos'
  },
  placeholder: {
    zh: '填写对应范围(回车换行分割)',
    en: '',
    pu: 'Preencher a gama correspondente(clique em entrar para quebrar a linha)'
  },
  placeholderInclude: {
    zh: '(回车换行分割)',
    en: '',
    pu: '(clique em entrar para quebrar a linha)'
  },
  accountBalance: {
    zh: '账户余额：',
    en: '',
    pu: 'Saldo da conta：'
  },
  hint: {
    zh: '请填写数字，整数部分最大长度9位，可保留两位有效小数',
    en: '',
    pu: 'Favor preencher os números, o comprimento máximo da parte inteira é de 9 dígitos, duas decimais válidas podem ser retidas'
  },
  isSave: {
    zh: '是否保存',
    en: '',
    pu: 'Está salvo'
  },
  code: {
    zh: '员工编号：',
    en: '',
    pu: 'número do funcionário：'
  },
  employeeCode: {
    zh: '员工编号',
    en: '',
    pu: 'número do funcionário'
  },
  codeStatus: {
    zh: '账号状态',
    en: '',
    pu: 'status da conta'
  },
  useRange: {
    zh: '使用范围：',
    en: '',
    pu: 'Âmbito de utilização.：'
  },
  useR: {
    zh: '使用范围',
    en: '',
    pu: 'Âmbito de utilização.'
  },
  codeUse: {
    zh: '员工编号可用',
    en: '',
    pu: 'Número de funcionários disponível'
  },
  codeRepeat: {
    zh: '员工编号重复，不可用',
    en: '',
    pu: 'Número de funcionários em duplicado, não disponível'
  },
  dispatchedGoods: {
    zh: '已派件',
    en: '',
    pu: 'Saiu para entrega'
  },
  senderPhone: {
    zh: '发件人电话',
    en: "The sender's phone",
    pu: 'O telefone do remetente'
  },
  SenderAddress: {
    zh: '发件人地址',
    en: 'Sender address',
    pu: 'Endereço de remetente'
  },
  ReceivingAddress: {
    zh: '收件人地址',
    en: 'Receiving Address',
    pu: 'Endereço do destinatário'
  },
  recipientS: {
    zh: '收件人',
    en: 'recipient',
    pu: 'Destinatário'
  },
  RecipientPhoneNumber: {
    zh: '收件人电话',
    en: "Recipient's phone",
    pu: 'Telefone do destinatário'
  },
  predictWeight: {
    zh: '预计重量',
    en: 'estimated weight',
    pu: 'peso estimado'
  },
  basicInformation: {
    zh: '基本信息',
    en: '',
    pu: 'Informações básicas'
  },
  quantity: {
    zh: '件数',
    en: 'quantity',
    pu: 'Número de pacotes'
  },
  verificationCode: {
    zh: '验证码',
    en: '',
    pu: 'Código de verificaçaõ'
  },
  lanshouPeople: {
    zh: '揽收-联系人',
    en: 'pick up-contact person',
    pu: 'coleta-pessoa de contato'
  },
  lanshouPhone: {
    zh: '揽收-手机',
    en: 'pick up-phone',
    pu: 'coleta-phone'
  },
  lanshouAddress: {
    zh: '揽收-地址',
    en: 'pick up-address',
    pu: 'coleta-endereço'
  },
  recipientInformation: {
    zh: '收件人信息',
    en: 'pick up-consignee information',
    pu: 'coleta-informação de destinário'
  },
  receivePeople: {
    zh: '收件-联系人',
    en: 'consignee-contact person',
    pu: 'destinário-pessoa de contato'
  },
  receivePhone: {
    zh: '收件-手机',
    en: 'consignee-phone',
    pu: 'destinário-phone'
  },
  receiveAddress: {
    zh: '收件-地址',
    en: 'consignee-address',
    pu: 'destinário-endereço'
  },
  pickUpTotal: {
    zh: '揽收总计',
    en: 'pick-up total',
    pu: 'total de coleta'
  },
  scanOrderNumber: {
    zh: '扫码单号',
    en: 'scanned order number',
    pu: 'número de pedido escaneado'
  },
  actualWeight: {
    zh: '称重重量(KG)',
    en: 'measured weight(KG)',
    pu: 'peso medido(KG)'
  },
  View: {
    zh: '查看',
    en: 'View',
    pu: 'ver'
  },
  actualReceivedNumber: {
    zh: '实收件数',
    en: 'actual collected quantity',
    pu: 'quantidade atual de coleta'
  },
  actualReceivedWeight: {
    zh: '实收重量',
    en: 'actual weight',
    pu: 'peço atual'
  },
  belongDot: {
    zh: '所属网点：',
    en: 'belonging point：',
    pu: 'Ponto Responsável：'
  },
  belongD: {
    zh: '所属网点',
    en: 'belonging point',
    pu: 'Ponto Responsável'
  },
  employeeName: {
    zh: '员工姓名：',
    en: 'employee name：',
    pu: 'nome de empregado：'
  },
  employeeN: {
    zh: '员工姓名',
    en: 'employee name',
    pu: 'nome de empregado'
  },
  editSite: {
    zh: '修改网点',
    en: 'change point',
    pu: 'modificar o ponto'
  },
  orderDate: {
    zh: '下单日期：',
    en: 'placing order time：',
    pu: 'data de pedido：'
  },
  mainWaybillNumber: {
    zh: '主运单号：',
    en: 'main airway bill：',
    pu: 'número de rastreio pricipal：'
  },
  orderD: {
    zh: '下单日期',
    en: 'placing order time',
    pu: 'data de pedido'
  },
  mainWaybillNum: {
    zh: '主运单号',
    en: 'main airway bill',
    pu: 'número de rastreio pricipal'
  },
  senderMobile: {
    zh: '发件人联系电话',
    en: 'sender mobile',
    pu: 'telefone de remetente'
  },
  estimatedCollectedQuantity: {
    zh: '预计揽收件数',
    en: 'estimated collected quantity',
    pu: 'quantidade estimado de coleta'
  },
  actualCollectedQuantity: {
    zh: '实际揽收件数',
    en: 'actual collected quantity',
    pu: 'quantidade atual de coleta'
  },
  actualCollectedWeight: {
    zh: '实际揽收重量',
    en: 'actual collected weight',
    pu: 'peço atual de coleta'
  },
  fetchCode: {
    zh: '取件码',
    en: 'collection code',
    pu: 'código de recolha'
  },
  collectingInformation: {
    zh: '揽收人信息',
    en: 'collecting staff information',
    pu: 'informação de coletador'
  },
  collectionDot: {
    zh: '揽收网点',
    en: 'collection spot',
    pu: 'ponto de coleção'
  },
  collectionSite: {
    zh: '揽收网点：',
    en: 'collection spot：',
    pu: 'ponto de coleção：'
  },
  collectionSignaturePhoto: {
    zh: '揽收签名图片',
    en: 'collection signature and photo',
    pu: 'foto da assinatura de coleta'
  },
  collectPhoto: {
    zh: '揽收照片',
    en: '',
    pu: 'foto da Colecção'
  },
  deliveryDot: {
    zh: '签收网点',
    en: 'delivery point',
    pu: 'Ponto de assinatura'
  },
  signForSignaturePhoto: {
    zh: '签收签名图片',
    en: 'collection signature and photo',
    pu: 'foto da assinatura de entrega'
  },
  bagNumberNotExisted: {
    zh: '袋号不存在',
    en: 'bag number not existed',
    pu: 'não existe o número de saco'
  },
  province: {
    zh: '省份：',
    en: 'province：',
    pu: 'província：'
  },
  provinceee: {
    zh: '省份',
    en: 'province',
    pu: 'província'
  },
  startZipCode: {
    zh: '起始邮编',
    en: '',
    pu: 'CEP do início'
  },
  endZipCode: {
    zh: '结束邮编',
    en: '',
    pu: 'CEP do fim'
  },
  startZipC: {
    zh: '起始邮编：',
    en: '',
    pu: 'CEP do início：'
  },
  endZipC: {
    zh: '结束邮编：',
    en: '',
    pu: 'CEP do fim：'
  },
  zipCodeType: {
    zh: '邮编类型',
    en: '',
    pu: 'Tipo de CEP'
  },
  BulkExport: {
    zh: '批量导出',
    en: 'Bulk export',
    pu: 'Exportação em lote'
  },
  Import: {
    zh: '导入',
    en: 'Import',
    pu: 'Importação'
  },
  TemplateDownload: {
    zh: '下载模版',
    en: '',
    pu: 'Download do modelo'
  },
  TheTypeOfExpense: {
    zh: '费用类型',
    en: 'The type of expense',
    pu: 'Tipo de custo'
  },
  TypeOfExpense: {
    zh: '费用类型：',
    en: 'The type of expense：',
    pu: 'Tipo de custo：'
  },
  freight: {
    zh: '运费',
    en: 'freight',
    pu: 'Frete'
  },
  stateZT: {
    zh: '状态',
    en: 'state',
    pu: 'Status'
  },
  NumberOfPushes: {
    zh: '推送次数',
    en: 'Number of pushes',
    pu: 'Número de empurrões'
  },
  uploadOnlyXlsx: {
    zh: '上传文件只能是xlsx格式',
    en: '',
    pu: 'O arquivo carregado só pode ser feito em formato xlsx'
  },
  uploadNot2MB: {
    zh: '上传文件大小不能超过2MB',
    en: '',
    pu: 'O tamanho do arquivo carregado não pode exceder 2MB'
  },
  uploadNot10MB: {
    zh: '上传文件大小不能超过10MB',
    en: '',
    pu: 'O tamanho do arquivo carregado não pode exceder 10MB'
  },
  uploadNot50MB: {
    zh: '上传文件大小不能超过50MB',
    en: '',
    pu: 'O tamanho do arquivo carregado não pode exceder 50MB'
  },
  nullMsg: {
    zh: '暂无数据',
    en: '',
    pu: 'Sem dados'
  },
  provincialCapital: {
    zh: '州府(省会)城市区内',
    en: '',
    pu: 'Na capital do estado (capital provincial)'
  },
  nonProvincialCapital: {
    zh: '非州府(省会)城市',
    en: '',
    pu: 'Cidades não-capital (provinciais)'
  },
  pleaseInputStateTwoCode: {
    zh: '请填写对应州二字码(大写)',
    en: '',
    pu: 'Favor preencher o código de dois caracteres do estado correspondente (em letras maiúsculas)'
  },
  billGenerationTime: {
    zh: '账单生成时间：',
    en: '',
    pu: 'Fatura gerada quando.：'
  },
  billGenerationT: {
    zh: '账单生成时间',
    en: '',
    pu: 'Fatura gerada quando.'
  },
  distributionCost: {
    zh: '配送费',
    en: '',
    pu: 'Taxa de entrega'
  },
  collectCost: {
    zh: '揽收费',
    en: '',
    pu: 'Taxas de solicitação'
  },
  pushStatus: {
    zh: '推送状态：',
    en: '',
    pu: 'Status do impulso.：'
  },
  unpushed: {
    zh: '未推送',
    en: '',
    pu: 'Não impulsionado'
  },
  pushed: {
    zh: '已推送',
    en: '',
    pu: 'Impulsionado'
  },
  pushFailure: {
    zh: '推送失败',
    en: '',
    pu: 'Falha de impulso'
  },
  logisticsNumber: {
    zh: '物流号：',
    en: '',
    pu: 'Número de rastro：'
  },
  logisticsNum: {
    zh: '物流号',
    en: '',
    pu: 'Número de rastro'
  },
  uploadData: {
    zh: '上传数据',
    en: '',
    pu: 'Carregar dados'
  },
  trackPushTime: {
    zh: '轨迹推送时间',
    en: '',
    pu: 'Tempo de impulso do ratro'
  },
  chargedWeight: {
    zh: '计费重量',
    en: '',
    pu: 'Peso faturável'
  },
  haveRepeatData: {
    zh: '有重复数据，不能提交',
    en: '',
    pu: 'Há dados duplicados que não podem ser entregados'
  },
  dataError: {
    zh: '数据错误，不能提交',
    en: '',
    pu: 'Erro de dados, não pode entregar'
  },
  chooseNumber: {
    zh: '请选择单号类型',
    en: '',
    pu: 'Selecione o tipo de número do ordem.'
  },
  inputNumFind: {
    zh: '请在文本框内输入单号进行查询',
    en: '',
    pu: 'Digite o número do ordem na caixa de texto para consulta.'
  },
  ViewDetails: {
    zh: '查看详情',
    en: 'View details',
    pu: 'Ver detalhes'
  },
  choose100: {
    zh: '单次最多可选100个，已截取前100个商户',
    en: '',
    pu: 'Até 100 em uma única seleção, os primeiros 100 sellers foram interceptados'
  },
  pushTime: {
    zh: '推送时间',
    en: '',
    pu: 'Hora de empurrão'
  },
  pickUp: {
    zh: '上门取件',
    en: '',
    pu: 'coleta porta-a-porta'
  },
  toCollect: {
    zh: '上门揽收',
    en: '',
    pu: 'Coleta porta a porta'
  },
  dropOff: {
    zh: '上门交件',
    en: '',
    pu: 'entrega porta-a-porta'
  },
  doorPickUp: {
    zh: '上门揽收',
    en: 'door-to-door pick up',
    pu: 'coleta à porta'
  },

  lanshouTypee: {
    zh: '揽收方式',
    en: '',
    pu: 'maneira de coleta'
  },
  lanshouType: {
    zh: '揽收方式：',
    en: '',
    pu: 'maneira de coleta：'
  },
  input10Number: {
    zh: '请输入最多10位正整数',
    en: 'Please enter up to 10 positive integers',
    pu: 'Favor inserir até 10 números inteiros positivos'
  },
  waybillNumRepeat: {
    zh: '当前运单号重复',
    en: '',
    pu: 'Duplicar o número de rastreamento atual'
  },
  chooseChannel: {
    zh: '请选择业务主体',
    en: '',
    pu: 'seleccione uma entidade comercial'
  },
  pleaseSelectDotToEdit: {
    zh: '请选择网点进行编辑',
    en: '',
    pu: 'Favor selecionar um ponto de venda para edição'
  },
  ifGiveUp: {
    zh: '是否放弃编辑内容？',
    en: '',
    pu: 'O conteúdo editorial está abandonado?'
  },
  authorization: {
    zh: '授权',
    en: '',
    pu: 'autorizar'
  },
  enterMultipleVal: {
    zh: '请输入，多个值需用逗号隔开',
    en: '',
    pu: 'favor entrar, valores múltiplos a serem separados por vírgulas'
  },
  PlatformWhichBelongs: {
    zh: '所属平台：',
    en: 'The platform to which it belongs：',
    pu: 'A plataforma à qual pertence：'
  },
  platform: {
    zh: '所属平台',
    en: 'The platform to which it belongs',
    pu: 'A plataforma à qual pertence'
  },
  expressDelivery: {
    zh: '快递',
    en: 'Express',
    pu: 'Express'
  },
  bagWeight: {
    zh: '包裹重量',
    en: '',
    pu: 'parcel weight'
  },
  bagCost: {
    zh: '包裹申明价值',
    en: '',
    pu: 'Package Affirmation Value'
  },
  minimumCharge: {
    zh: '最低费用：',
    en: '',
    pu: 'custo mínimo：'
  },
  SerialNumber: {
    zh: '编号',
    en: '',
    pu: 'Número'
  },
  partitionName: {
    zh: '分区名称',
    en: '',
    pu: 'nome da divisão'
  },
  effectiveTime: {
    zh: '有效时间：',
    en: '',
    pu: 'tempo válido：'
  },
  effectiveStartTime: {
    zh: '有效起始时间：',
    en: '',
    pu: 'hora efetiva de início：'
  },
  eStartTime: {
    zh: '有效起始时间',
    en: '',
    pu: 'hora efetiva de início'
  },
  effectiveEndTime: {
    zh: '有效结束时间',
    en: '',
    pu: 'tempo final efetivo'
  },
  billingMode: {
    zh: '计费模式：',
    en: '',
    pu: 'modelo de faturamento：'
  },
  distance: {
    zh: '距离',
    en: '',
    pu: 'distância'
  },
  Weight: {
    zh: '重量',
    en: 'Weight',
    pu: 'Peso'
  },
  trialCalculation: {
    zh: '试算',
    en: '',
    pu: 'cálculo do julgamento'
  },
  trialResult: {
    zh: '试算结果：',
    en: '',
    pu: 'resultados dos cálculos dos ensaios：'
  },
  tableTips: {
    zh: '提示：d(distance)距离；w(weight)重量；p票数',
    en: '',
    pu: 'Dica: d(distance) distância; w(weight) peso; p número de votos'
  },
  tableExplain: {
    zh: '符号说明：>大于；<小于；>=大于或等于；<=小于或等于',
    en: '',
    pu: 'Descrição dos símbolos: > maior que; < menor que; >= maior ou igual a; <= menor ou igual a'
  },
  distanceMin: {
    zh: '距离(最小值)',
    en: '',
    pu: 'distância (mín.)'
  },
  pollMin: {
    zh: '票数(最小值)',
    en: '',
    pu: 'número de votos (min)'
  },
  weightMin: {
    zh: '重量(最小值)',
    en: '',
    pu: 'peso (min.)'
  },
  distanceMax: {
    zh: '距离(最大值)',
    en: '',
    pu: 'distância (máx)'
  },
  pollMax: {
    zh: '票数(最大值)',
    en: '',
    pu: 'número de votos (máximo)'
  },
  weightMax: {
    zh: '重量(最大值)',
    en: '',
    pu: 'peso (máximo)'
  },
  formula: {
    zh: '公式',
    en: '',
    pu: 'fórmula'
  },
  selectReceivingOutlets: {
    zh: '揽收网点选择',
    en: '',
    pu: 'seleção do ponto de coleta'
  },
  ZipCodeAreaName: {
    zh: '邮编分区名称：',
    en: '',
    pu: 'Divisão de Código Postal：'
  },
  query: {
    zh: '查询：',
    en: '',
    pu: 'Consultar：'
  },
  sendArea: {
    zh: '寄件区域：',
    en: '',
    pu: 'Área de Postagem/Envio：'
  },
  mailingAreaSelection: {
    zh: '寄件区域选择',
    en: '',
    pu: 'seleção da área de embarque'
  },
  enterNumber3significantDecimals: {
    zh: '请输入数字，可保留3位有效小数',
    en: '',
    pu: 'Favor inserir um número, 3 casas decimais válidas podem ser retidas'
  },
  regionName: {
    zh: '区域名称：',
    en: '',
    pu: 'nome da área：'
  },
  regionN: {
    zh: '区域名称',
    en: '',
    pu: 'nome da área'
  },
  selectiveData: {
    zh: '选择数据',
    en: '',
    pu: 'selecione os dados'
  },
  pleaseFillAreaName: {
    zh: '请填写区域名称',
    en: '',
    pu: 'por favor, preencha o nome da região'
  },
  pleaseSelectData: {
    zh: '请选择数据',
    en: '',
    pu: 'selecione os dados'
  },
  selectZonedZipCode: {
    zh: '选择分区邮编',
    en: '',
    pu: 'selecione um código postal zonal'
  },
  vehicleLife: {
    zh: '车辆使用年限：',
    en: '',
    pu: 'Idade do veículo：'
  },
  vehicleYear: {
    zh: '车辆使用年限',
    en: '',
    pu: 'Idade do veículo'
  },
  personalTaxNumber: {
    zh: '个人税号：',
    en: '',
    pu: 'Código tributário individual：'
  },
  personalTaxNum: {
    zh: '个人税号',
    en: '',
    pu: 'Código tributário individual'
  },
  drivingLicenseNumber: {
    zh: '驾驶证编号：',
    en: '',
    pu: 'número da carteira de motorista：'
  },
  drivingLicenseNum: {
    zh: '驾驶证编号',
    en: '',
    pu: 'número da carteira de motorista'
  },
  driveValidTime: {
    zh: '驾驶证有效期限：',
    en: '',
    pu: 'período de validade da carteira de motorista：'
  },
  driveValidT: {
    zh: '驾驶证有效期限',
    en: '',
    pu: 'período de validade da carteira de motorista'
  },
  driveIssuingAgency: {
    zh: '驾驶证颁发机构：',
    en: '',
    pu: 'Órgãos emissores de carteiras de motorista：'
  },
  driveIssuingA: {
    zh: '驾驶证颁发机构',
    en: '',
    pu: 'Órgãos emissores de carteiras de motorista'
  },
  to: {
    zh: '至',
    en: 'to',
    pu: 'Para'
  },
  minimumNotThanMaximum: {
    zh: '最小值不能大于最大值',
    en: '',
    pu: 'O valor mínimo não pode ser maior que o valor máximo'
  },
  operatingCost: {
    zh: '操作费用',
    en: '',
    pu: 'custos operacionais'
  },
  warehouseAnomalyCharge: {
    zh: '仓库异常费用',
    en: '',
    pu: 'custos de exceção do depósito'
  },
  orderWeight: {
    zh: '订单重量',
    en: '',
    pu: 'peso do pedido'
  },
  commodityInvoiceNumber: {
    zh: '商品发票号',
    en: '',
    pu: 'número da fatura do produto'
  },
  logisticsInvoiceType: {
    zh: '物流发票类型',
    en: '',
    pu: 'tipos de faturas de logística'
  },
  logisticsInvoiceNumber: {
    zh: '物流发票号',
    en: '',
    pu: 'número da fatura de logística'
  },
  collectScanTime: {
    zh: '揽收扫描时间',
    en: '',
    pu: 'solicitation scanning time'
  },
  actualSigningTime: {
    zh: '实际签收时间',
    en: '',
    pu: 'actual sign-off time'
  },
  oneselfQuery: {
    zh: '自定义查询',
    en: '',
    pu: 'consultas personalizadas'
  },
  criterionQuery: {
    zh: '固定查询',
    en: '',
    pu: 'consultas corrigidas'
  },
  allSelect: {
    zh: '全选',
    en: '',
    pu: 'Selecionar tudo'
  },
  queryField: {
    zh: '自定义查询展示栏位',
    en: '',
    pu: 'Campos de exibição de consulta personalizados'
  },
  collectionScanUploadTime: {
    zh: '揽收上传时间',
    en: '',
    pu: 'Tempo de coleta e upload'
  },
  signatureScanTime: {
    zh: '签收扫描时间',
    en: '',
    pu: 'tempo de assinatura e digitalização'
  },
  signatureUploadTime: {
    zh: '签收上传时间',
    en: '',
    pu: 'tempo de assinatura e upload'
  },
  collectionTrackCreateTime: {
    zh: '揽收轨迹创建时间',
    en: '',
    pu: 'tempo de criação da trilha de coleta'
  },
  receivingTrackPushTime: {
    zh: '揽收轨迹推送时间',
    en: '',
    pu: 'tempo de envio da trilha de coleta'
  },
  signatureTrackCreateTime: {
    zh: '签收轨迹创建时间',
    en: '',
    pu: 'hora da criação da trilha de aprovação'
  },
  signatureTrackPushTime: {
    zh: '签收轨迹推送时间',
    en: '',
    pu: 'tempo de envio da trilha de assinatura'
  },
  receiptArs: {
    zh: '收件地址',
    en: 'The delivery address',
    pu: 'Endereço destinatário'
  },
  SendAddress: {
    zh: '发件地址',
    en: 'Sending Address',
    pu: 'Endereço do remetente'
  },
  Recipientzc: {
    zh: '收件人邮编',
    en: "Recipient's zip code",
    pu: 'CEP do destinatário'
  },
  senderZipCode: {
    zh: '发件人邮编',
    en: 'Recipient Name',
    pu: 'Nome do destinatário'
  },
  SenderCity: {
    zh: '发件人城市',
    en: 'Sender city',
    pu: 'cidade do remetente'
  },
  SenderState: {
    zh: '发件人州',
    en: 'Sender state',
    pu: 'Estado do remetente'
  },
  receiveCity: {
    zh: '收件人城市',
    en: 'Recipient city',
    pu: 'Cidade destinatária'
  },
  receiveState: {
    zh: '收件人州',
    en: 'Recipient state',
    pu: 'Estado do destinatário'
  },
  invoiceType: {
    zh: '发票类型：',
    en: '',
    pu: 'tipo de fatura：'
  },
  invoiceT: {
    zh: '发票类型',
    en: '',
    pu: 'tipo de fatura'
  },
  receivingMode: {
    zh: '揽收模式',
    en: '',
    pu: 'Modelo de coleção'
  },
  declaredValue: {
    zh: '申明价值',
    en: '',
    pu: 'Afirmação de valor'
  },
  collectionFee: {
    zh: '揽收费用',
    en: '',
    pu: 'Cobrança de taxas'
  },
  actualCollectionMode: {
    zh: '实际揽收模式',
    en: '',
    pu: 'Padrões reais de coleta'
  },
  closeTime: {
    zh: '闭环时间',
    en: '',
    pu: 'Data de conclusão'
  },
  closedLoop: {
    zh: '已闭环',
    en: '',
    pu: 'Finalizado'
  },
  noDataExport: {
    zh: '无可导出数据',
    en: '',
    pu: 'Nenhum dado exportável'
  },
  dataNotExist: {
    zh: '数据不存在',
    en: '',
    pu: 'os dados não existem'
  },
  invoiceSecretKey: {
    zh: '发票秘钥',
    en: '',
    pu: 'Faturas Chave secreta'
  },
  exportFailure: {
    zh: '未导出成功，请重新导出',
    en: '',
    pu: 'A exportação não foi bem-sucedida, favor reexportar'
  },
  commaSeparation: {
    zh: '填写对应范围(逗号分割)',
    en: '',
    pu: 'Preencha o intervalo correspondente (separado por vírgulas)'
  },
  commaSeparationTips: {
    zh: '(逗号分割)',
    en: '',
    pu: '(separado por vírgulas)'
  },
  outRange: {
    zh: '超出范围',
    en: '',
    pu: 'Fora da faixa'
  },
  allowCreatePrompt: {
    zh: '只允许建立总部下的同一层级或者其下级网点',
    en: '',
    pu: 'Somente o mesmo nível abaixo da matriz ou de suas filiais subordinadas pode ser estabelecido'
  },
  signatureTime: {
    zh: '签名时间',
    en: '',
    pu: 'Tempo de assinatura'
  },

  bagNumber: {
    zh: '车签号：',
    en: '',
    pu: 'Número de escaneamento do veículo：'
  },
  cabinetNumber: {
    zh: '柜子编号',
    en: '',
    pu: 'Número do gabinete'
  },
  cabinetNum: {
    zh: '柜子编号：',
    en: '',
    pu: 'Número do gabinete：'
  },
  cabinetType: {
    zh: '柜子类型',
    en: '',
    pu: 'Tipo de gabinete'
  },
  cabinetT: {
    zh: '柜子类型：',
    en: '',
    pu: 'Tipo de gabinete：'
  },
  gridNumber: {
    zh: '格子编号',
    en: '',
    pu: 'Número da grade'
  },
  latticeSize: {
    zh: '格子规格',
    en: '',
    pu: 'Especificação da rede'
  },
  cabinet: {
    zh: '柜子位置',
    en: '',
    pu: 'Localização do gabinete'
  },
  cabinetAddress: {
    zh: '柜子位置：',
    en: '',
    pu: 'Localização do gabinete：'
  },
  LAL: {
    zh: '经纬度',
    en: '',
    pu: 'Latitude e longitude'
  },
  gridNum: {
    zh: '格子编号：',
    en: '',
    pu: 'Número da grade：'
  },
  belongToCabinet: {
    zh: '所属柜子编号：',
    en: '',
    pu: 'Número do gabinete：'
  },
  belongToCabinetNum: {
    zh: '所属柜子编号',
    en: '',
    pu: 'Número do gabinete'
  },
  collectParcel: {
    zh: '取件',
    en: '',
    pu: 'coleta'
  },
  delivery: {
    zh: '派件',
    en: '',
    pu: 'despacho'
  },
  mixed: {
    zh: '混合',
    en: '',
    pu: 'híbrido'
  },
  latticeS: {
    zh: '格子规格：',
    en: '',
    pu: 'Especificação da rede：'
  },
  oversized: {
    zh: '超大',
    en: '',
    pu: 'tamanho grande'
  },
  big: {
    zh: '大',
    en: '',
    pu: 'mais antigo'
  },
  middle: {
    zh: '中',
    en: '',
    pu: 'médio'
  },
  small: {
    zh: '小',
    en: '',
    pu: 'poucos'
  },
  addSuccessful: {
    zh: '新增成功',
    en: '',
    pu: 'adicionado com sucesso'
  },
  enableNotAllowDel: {
    zh: '启用状态的数据不允许删除',
    en: '',
    pu: 'a exclusão de dados no estado habilitado não é permitida'
  },
  DeleteSuccessful: {
    zh: '删除成功',
    en: 'Delete successful',
    pu: 'Excluir bem-sucedido'
  },
  towOne: {
    zh: '一拖一',
    en: '',
    pu: 'um reboque (veículo)'
  },
  doorToDoorDeliveryInquiryForm: {
    zh: '上门交件查询表',
    en: '',
    pu: 'formulário de consulta para entrega porta a porta'
  },
  dailyReportsDetailedList: {
    zh: '揽收日报表明细表',
    en: '',
    pu: 'detalhamento dos extratos diários de cobrança'
  },
  loader: {
    zh: '装车人',
    en: '',
    pu: 'Carregadeiras'
  },
  firstLoader: {
    zh: '第一次装车人',
    en: 'First loader',
    pu: 'Primeiro carregador'
  },
  loadTime: {
    zh: '装车时间',
    en: '',
    pu: 'Hora de carga'
  },
  loadSiteIdList: {
    zh: '装车网点',
    en: '',
    pu: 'Ponto de Carregamento'
  },
  loadSign: {
    zh: '装车签名',
    en: '',
    pu: 'Assinatura de carregamento'
  },
  unloader: {
    zh: '卸车人',
    en: '',
    pu: 'Descarregadores'
  },
  unloadTime: {
    zh: '卸车时间',
    en: '',
    pu: 'Tempo de descarregamento'
  },
  unLoadSign: {
    zh: '卸车签名',
    en: '',
    pu: 'Assinatura de descarregamento'
  },
  totalLoad: {
    zh: '装车总数',
    en: '',
    pu: 'número total de veículos carregados'
  },
  totalUnloading: {
    zh: '卸车总数',
    en: '',
    pu: 'total de descarregamento'
  },
  cityName: {
    zh: '城市名称：',
    en: '',
    pu: 'Cidade：'
  },
  unclaimedItem: {
    zh: '待取件：',
    en: '',
    pu: 'Pendente de coleta：'
  },
  unsolicitedItem: {
    zh: '待揽件：',
    en: '',
    pu: 'Pendente：'
  },
  detentionShipment: {
    zh: '滞留件：',
    en: '',
    pu: 'item retido：'
  },
  space: {
    zh: '空白格：',
    en: '',
    pu: 'espaço em branco：'
  },
  unclaimed: {
    zh: '待取件',
    en: '',
    pu: 'Pendente de coleta'
  },
  unsolicited: {
    zh: '待揽件',
    en: '',
    pu: 'Pendente'
  },
  detentionShip: {
    zh: '滞留件',
    en: '',
    pu: 'item retido'
  },
  blankGrid: {
    zh: '空格子',
    en: '',
    pu: 'espaço em branco'
  },
  red: {
    zh: '红色：',
    en: '',
    pu: 'vermelho'
  },
  green: {
    zh: '绿色：',
    en: '',
    pu: 'Verde'
  },
  orange: {
    zh: '橙色：',
    en: '',
    pu: 'Laranja'
  },
  white: {
    zh: '白色：',
    en: '',
    pu: 'fig. reacionário'
  },
  pleaseNumber: {
    zh: '请填写数字，多个值用逗号分隔',
    en: '',
    pu: 'preencha os números e separe vários valores com vírgulas'
  },
  selectCabinet: {
    zh: '请选择柜子',
    en: '',
    pu: 'Cidade：'
  },
  cityExtraName: {
    zh: '城市扩展名称：',
    en: '',
    pu: 'nome do ramal da cidade：'
  },
  startZipcodeLessEndZipcode: {
    zh: '开始邮编不能大于或等于结束邮编',
    en: '',
    pu: 'O código postal inicial não pode ser maior ou igual ao código postal final'
  },
  driversLicenseType: {
    zh: '驾照类型：',
    en: '',
    pu: 'Tipo de carteira de motorista：'
  },
  driversLicenseT: {
    zh: '驾照类型',
    en: '',
    pu: 'Tipo de carteira de motorista'
  },
  formulaExample: {
    zh: '公式示例：(1 + 2) * 3 - 4 / d',
    en: 'Formula example：(1 + 2) * 3 - 4 / d',
    pu: 'Fórmula de exemplo：(1 + 2) * 3 - 4 / d'
  },
  formulaError: {
    zh: '公式错误，请检查',
    en: '',
    pu: 'Erro de fórmula, verifique'
  },
  NoDataWasQueried: {
    zh: '未查询到数据',
    en: 'No data was queried',
    pu: 'Nenhum dado foi consultado'
  },
  querySiteCode: {
    zh: '仅支持网点编号或网点名称查询',
    en: '',
    pu: 'Suporta apenas a pesquisa do número ou do nome da filial'
  },
  intervalDataOverlaps: {
    zh: '区间段数据维护重叠，请检查后重新维护',
    en: '',
    pu: 'Sobreposição na manutenção dos dados do segmento de intervalo, verifique e atualize novamente'
  },
  provinceExtensionName: {
    zh: '省份扩展名称：',
    en: '',
    pu: 'nome estendido da província：'
  },
  signBag: {
    zh: '签收：',
    en: '',
    pu: 'Assinatura：'
  },
  PleaseScan: {
    zh: '请扫描',
    en: 'Please scan',
    pu: 'Favor de escanear'
  },
  pleaseEnterOrScan: {
    zh: '请输入或扫描',
    en: '',
    pu: 'digite ou escaneie'
  },
  signature: {
    zh: '签名',
    en: '',
    pu: 'Assinatura'
  },
  submit: {
    zh: '提交',
    en: 'submit',
    pu: 'Enviar'
  },
  submitSuccessfully: {
    zh: '提交成功',
    en: '',
    pu: 'Enviado com sucesso'
  },
  submitSignature: {
    zh: '提交签名',
    en: '',
    pu: 'Envio de assinaturas'
  },
  compellation: {
    zh: '姓名',
    en: 'name',
    pu: 'Nome'
  },
  deliveryPersonnelInfo: {
    zh: '派件人员信息',
    en: '',
    pu: 'Informações do despachante'
  },
  jobNumber: {
    zh: '工号',
    en: '',
    pu: 'número do trabalho'
  },
  deliverPackageInfo: {
    zh: '派送包裹信息',
    en: '',
    pu: 'Informações sobre entrega de encomendas'
  },
  signTotal: {
    zh: '签收总数',
    en: '',
    pu: 'número total de assinaturas'
  },
  howManyParcel: {
    zh: '个包裹', // 只有1个
    en: '',
    pu: 'parcelas'
  },
  howManyParcels: {
    zh: '个包裹', // 大于1个
    en: '',
    pu: 'parcelas'
  },
  bag: {
    zh: '袋', // 只有1个
    en: 'bag',
    pu: 'saco'
  },
  bags: {
    zh: '袋', // 大于1个
    en: 'bag',
    pu: 'bolsas'
  },
  recipientSign: {
    zh: '收件人签名',
    en: '',
    pu: 'assinatura do destinatário'
  },
  senderMobileNumber: {
    zh: '发件人手机号码',
    en: '',
    pu: 'número de celular do remetente'
  },
  stateOrigin: {
    zh: '发件州',
    en: '',
    pu: 'estado de envio'
  },
  sendingCity: {
    zh: '发件城市',
    en: '',
    pu: 'cidade de envio'
  },
  sendingDetailsAddress: {
    zh: '发件详细地址',
    en: '',
    pu: 'detalhes de envio'
  },
  RecipientPhoneNum: {
    zh: '收件人电话',
    en: 'Recipient phone number',
    pu: 'Nº de telefone do destinatário'
  },
  RecipientP: {
    zh: '收件人手机',
    en: "Recipient's cell phone",
    pu: 'Nº de celular do destinatário'
  },
  boxNumber: {
    zh: '箱子号',
    en: '',
    pu: 'número do caso'
  },
  boxBarCode: {
    zh: '箱子条码',
    en: '',
    pu: 'código de barras da caixa'
  },
  CommodityInvoiceKey: {
    zh: '商品发票秘钥',
    en: 'Commodity invoice key',
    pu: 'Chave da fatura da mercadoria'
  },
  tradeName: {
    zh: '商品名称',
    en: '',
    pu: 'nome do produto'
  },
  declaredVal: {
    zh: '声明价值',
    en: '',
    pu: 'valor declarado'
  },
  numberItems: {
    zh: '商品件数',
    en: '',
    pu: 'número de itens'
  },
  cteInvoiceKey: {
    zh: 'cte发票秘钥',
    en: '',
    pu: 'chave de fatura cte'
  },
  SenderInformation: {
    zh: '发件人信息',
    en: 'Sender information',
    pu: 'Informações sobre remetente'
  },
  cargoInformation: {
    zh: '货物信息',
    en: '',
    pu: 'Informações sobre a carga'
  },
  phone: {
    zh: '电话：',
    en: 'Phone：',
    pu: 'Telefone：'
  },
  cellphone: {
    zh: '手机：',
    en: '',
    pu: 'Celular：'
  },
  detailedArs: {
    zh: '详细地址：',
    en: 'detailed address：',
    pu: 'endereo detalhado：'
  },
  CPF: {
    zh: '税号：',
    en: 'CPF：',
    pu: 'CPF/CNPJ：'
  },
  adrser: {
    zh: '发件人：',
    en: '',
    pu: 'remetente：'
  },
  senderName: {
    zh: '发件人',
    en: '',
    pu: 'Remetente'
  },
  stateOri: {
    zh: '发件州：',
    en: '',
    pu: 'estado de envio：'
  },
  sendingCt: {
    zh: '发件城市：',
    en: '',
    pu: 'cidade de envio：'
  },
  tradeN: {
    zh: '商品名称：',
    en: '',
    pu: 'nome do produto：'
  },
  totalWeight: {
    zh: '总重量：',
    en: 'Total weight：',
    pu: 'Peso total：'
  },
  totalParcels: {
    zh: '总包裹数：',
    en: '',
    pu: 'número total de parcelas：'
  },
  totalDeclaredValue: {
    zh: '总声明价值：',
    en: '',
    pu: 'Valor total declarado：'
  },
  boxLen: {
    zh: '箱子长：',
    en: '',
    pu: 'comprimento da caixa：'
  },
  boxWei: {
    zh: '箱子宽：',
    en: '',
    pu: 'largura da caixa：'
  },
  boxHei: {
    zh: '箱子高：',
    en: '',
    pu: 'altura da caixa：'
  },
  supportModifyData: {
    zh: '仅支持修改一条数据',
    en: '',
    pu: 'suporta a modificação de apenas uma parte dos dados'
  },
  oddNumber: {
    zh: '单号：',
    en: '',
    pu: 'número ímpar'
  },
  TypesProblem: {
    zh: '问题件类型：',
    en: 'Types of problem parcels：',
    pu: 'Tipo de pacote anormal：'
  },
  selectProblemFirst: {
    zh: '请先选择问题件类型',
    en: '',
    pu: 'selecione primeiro o tipo de problema'
  },
  RecipientProvince: {
    zh: '收件人省份',
    en: 'Recipient province',
    pu: 'Província do destinatário'
  },
  cancelReason: {
    zh: '取消原因',
    en: '',
    pu: 'motivo do cancelamento'
  },
  actPickUpCode: {
    zh: '实际揽收码',
    en: '',
    pu: 'Código atual'
  },
  batchNo: {
    zh: '波次号',
    en: '',
    pu: 'Número de Onda'
  },
  clearImage: {
    zh: '清场图片',
    en: '',
    pu: 'Imagem de Apuramento'
  },
  pickupCode: {
    zh: '揽收码',
    en: '',
    pu: 'Código'
  },
  pleaseFillLetterOrNum: {
    zh: '请填写字母或数字',
    en: '',
    pu: 'por favor, preencha com letras ou números'
  },
  pleaseFillNumAndSpecialSymbol: {
    zh: '请填写数字及特殊符号, 例: 005.339.857-22',
    en: '',
    pu: 'preencha os números e os símbolos especiais, por exemplo, 005.339.857-22.'
  },
  brazilPhoneRestrict: {
    zh: '长度不低于10位，允许包含 + - 空格等特殊字符',
    en: '',
    pu: 'o comprimento não deve ser inferior a 10 dígitos, permitindo a inclusão de caracteres especiais, como espaços +-.'
  },
  enterpriseTaxNumber: {
    zh: '企业税号：',
    en: '',
    pu: 'código tributário da empresa：'
  },
  enterpriseTaxNum: {
    zh: '企业税号',
    en: '',
    pu: 'código tributário da empresa'
  },
  enterpriseTaxNumTips: {
    zh: '数字长度为14，包含.-/等特殊字符',
    en: '',
    pu: 'the number is 14 characters in length and contains special characters such as periods (.) -/'
  },
  enterpriseTaxNumTips11: {
    zh: '数字长度为11，格式为`xxx.xxx.xxx-yy`',
    en: '',
    pu: 'Número com 11 dígitos, formato `xxx.xxx.xxx-yy`'
  },
  enterpriseTaxNumTips14: {
    zh: '数字长度为14，格式为`xx.xxx.xxx/yyyy-zz`',
    en: '',
    pu: 'Número com 14 dígitos, formato `xx.xxx.xxx-yyyy-zz`'
  },
  problemPieceType: {
    zh: '问题件类型',
    en: 'The type of problem piece',
    pu: 'Tipo de ocorrência' // 问题件配置优化
  },
  checkItemTips: {
    zh: '勾选项中订单状态为问题件的数据已过滤',
    en: '',
    pu: 'os dados marcados com status de pedido de Peças problemáticas são filtrados.'
  },
  dataBeingGenerated: {
    zh: '正在生成数据',
    en: '',
    pu: 'dados que estão sendo gerados'
  },
  loadingSuc: {
    zh: '装车成功',
    en: '',
    pu: 'Carregamento bem-sucedido'
  },
  carNum: {
    zh: '车辆编号：',
    en: '',
    pu: 'Número do veículo：'
  },
  next: {
    zh: '下一步',
    en: 'Next',
    pu: 'Próximo passo'
  },
  scanningVehicle: {
    zh: '扫描车辆',
    en: '',
    pu: 'escaneamento de veículos'
  },
  scanningBag: {
    zh: '扫描袋号',
    en: '',
    pu: 'Leitura do número da saca'
  },
  scanningCarTag: {
    zh: '扫描车签号',
    en: '',
    pu: 'Leitura da ordem de coleta'
  },
  carScan: {
    zh: '车辆扫描：',
    en: '',
    pu: 'Scaneamento do veículo：'
  },
  scanQRCodeOrNum: {
    zh: '请扫描车辆二维码或输入车辆编号',
    en: '',
    pu: ' Leia o código QR do veículo'
  },
  carDriver: {
    zh: '驾驶人：',
    en: '',
    pu: 'motorista：'
  },
  bagNumScan: {
    zh: '袋号扫描：',
    en: '',
    pu: 'leitura do número da bolsa：'
  },
  pleaseScanBagNum: {
    zh: '请扫描袋号',
    en: '',
    pu: 'favor escanear o número da sacola'
  },
  carNumScan: {
    zh: '车签号扫描：',
    en: '',
    pu: 'verificação do número do carro：'
  },
  pleaseScanCarNum: {
    zh: '请扫描车签号',
    en: '',
    pu: 'digitalize o número do adesivo do carro'
  },
  loadingEnd: {
    zh: '装车结束',
    en: '',
    pu: 'Fim do carregamento'
  },
  scanned: {
    zh: '已扫描',
    en: '',
    pu: 'Digitalizado'
  },
  signFor: {
    zh: '签收',
    en: '',
    pu: 'Assinatura'
  },
  cabinetPickup: {
    zh: '取件(智能柜取件)',
    en: '',
    pu: 'Coleta(Captador de gabinete inteligente)'
  },
  smartCabinet: {
    zh: '智能柜',
    en: '',
    pu: 'gabinete inteligente'
  },
  SMSManagement: {
    zh: '短信管理',
    en: '',
    pu: 'Gestão de SMS'
  },
  UnacquiredTime: {
    zh: '未获取到时间',
    en: '',
    pu: 'O horário não foi obtido'
  },
  unloadingEnd: {
    zh: '卸车结束',
    en: '',
    pu: 'Fim do descarregamento'
  },
  bagsAmount: {
    zh: '袋数：',
    en: '',
    pu: 'quantidade de sacas：'
  },
  scanningTime: {
    zh: '扫描时间：',
    en: '',
    pu: 'Tempo de varredura：'
  },
  unloadedSuccessfully: {
    zh: '卸车成功',
    en: '',
    pu: 'Descarregado com sucesso'
  },
  carTagNull: {
    zh: '车签号不能为空',
    en: '',
    pu: 'O número de registro do carro não pode estar vazio'
  },
  endOfUnloading: {
    zh: '结束卸车',
    en: '',
    pu: 'Fim do descarregamento'
  },
  max180DaysDate: {
    zh: '最多可查询到180天的数据',
    en: '',
    pu: 'Até 180 dias de dados'
  },
  loaderDot: {
    zh: '装车人所属网点',
    en: '',
    pu: 'rede do carregador'
  },
  loadingAddress: {
    zh: '装车地址',
    en: '',
    pu: 'endereço de carregamento'
  },
  unloaderDot: {
    zh: '卸车人所属网点',
    en: '',
    pu: 'rede de descarregadores'
  },
  unloadingAddress: {
    zh: '卸车地址',
    en: '',
    pu: 'endereço de descarregamento'
  },
  totalNumberBagsLoaded: {
    zh: '装车总袋数',
    en: '',
    pu: 'número total de sacos carregados'
  },
  totalBagsUnloaded: {
    zh: '卸车总袋数',
    en: '',
    pu: 'Total de sacos descarregados'
  },
  BagSealer: {
    zh: '封袋人',
    en: '',
    pu: 'Selador'
  },
  bagPackerDot: {
    zh: '封袋人所属网点',
    en: '',
    pu: 'saída do selador de sacos'
  },
  InPocketTotal: {
    zh: '袋内总包裹数',
    en: '',
    pu: 'número total de pacotes na sacola'
  },
  loadingScanningTime: {
    zh: '装车扫描时间',
    en: '',
    pu: 'tempo de varredura de carga'
  },
  unloadingScanningTime: {
    zh: '卸车扫描时间',
    en: '',
    pu: 'tempo de varredura de descarga'
  },
  loadingUploadingTime: {
    zh: '装车上传时间',
    en: '',
    pu: 'tempo de carregamento e upload'
  },
  unloadingUploadTime: {
    zh: '卸车上传时间',
    en: '',
    pu: 'tempo de descarregamento e upload'
  },
  compatibleBasecode: {
    zh: '兼容字母、特殊字符（-）数字的组合，最大长度为30',
    en: '',
    pu: 'Compatível com combinações de letras, caracteres especiais (-), números, comprimento máximo de 30'
  },
  tipoTitle: {
    zh: '订单类型',
    en: '',
    pu: 'Tipo do pedido'
  },
  tipo: {
    zh: '订单类型：',
    en: '',
    pu: 'Tipo do pedido：'
  },
  forwardBusiness: {
    zh: '正向业务',
    en: 'Forward business',
    pu: 'Negócio direto'
  },
  reverseBusiness: {
    zh: '逆向业务',
    en: 'Reverse business',
    pu: 'Negócio reverso'
  },
  tudo: {
    zh: '全部',
    en: 'all',
    pu: 'Todos'
  },
  normal: {
    zh: '普通订单',
    en: '',
    pu: 'normal'
  },
  cutOff: {
    zh: '截单订单',
    en: '',
    pu: 'cut-off'
  },
  max3DaysDate: {
    zh: '最多可查询到3天的数据',
    en: '',
    pu: 'Até 3 dias de dados'
  },
  max7DaysDate: {
    zh: '最多可查询到7天的数据',
    en: '',
    pu: 'Até 7 dias de dados'
  },
  max15DaysDate: {
    zh: '最多可查询到15天的数据',
    en: '',
    pu: 'Até 15 dias de dados'
  },
  SenderMailbox: {
    zh: '发件人邮箱',
    en: 'Sender mailbox',
    pu: 'email de remetente'
  },
  MerchantNumber: {
    zh: '商户编号',
    en: '',
    pu: 'Número do comerciante'
  },
  toBeCollectedNumber: {
    zh: '待揽收包裹数',
    en: '',
    pu: 'Número de pacotes aguardando coleta'
  },
  MerchantClass: {
    zh: '商家等级',
    en: '',
    pu: 'Nível do comerciante'
  },
  addresseeContactNumber: {
    zh: '收件人联系电话',
    en: '',
    pu: 'Número de contato do destinatário'
  },
  choose1000: {
    zh: '单次最多可选1000个，已截取前1000个商户',
    en: '',
    pu: 'Até 1000 em uma única seleção, os primeiros 1000 sellers foram interceptados'
  },
  ForecastWeight: {
    zh: '预报重量',
    en: 'Forecast weight',
    pu: 'Peso previsto'
  },
  ActualWeight: {
    zh: '实际重量',
    en: '',
    pu: 'peso real'
  },
  commodityInvoiceType: {
    zh: '商品发票类型',
    en: '',
    pu: 'Tipo de fatura de mercadoria'
  },
  commodityInvoiceKey: {
    zh: '商品发票密钥',
    en: '',
    pu: 'Chave da fatura de mercadorias'
  },
  LogisticsInvoiceType: {
    zh: '物流发票类型',
    en: '',
    pu: 'Tipo de fatura de logística'
  },
  LogisticsInvoiceKey: {
    zh: '物流发票密钥',
    en: '',
    pu: 'Chave de fatura logística'
  },
  carLoadingVotes: {
    zh: '装车总票数',
    en: '',
    pu: 'Número total de votos carregados'
  },
  carUnloadingVotes: {
    zh: '卸车总票数',
    en: '',
    pu: 'Número total de votos descarregados'
  },
  loadingPicture: {
    zh: '装车图片',
    en: '',
    pu: 'Carregando imagem'
  },
  unloadingPicture: {
    zh: '卸车图片',
    en: '',
    pu: 'imagem de descarregamento'
  },
  sealVehiclePicture: {
    zh: '封车图片',
    en: '',
    pu: 'imagem de fechamento do veículo'
  },
  unsealVehiclePicture: {
    zh: '解封车图片',
    en: '',
    pu: 'imagem de desbloquear o veículo'
  },
  upload5Photos: {
    zh: '最多上传5张照片',
    en: '',
    pu: 'Faça upload de até 5 fotos'
  },
  upload1Photo: {
    zh: '最多上传1张照片',
    en: '',
    pu: 'Faça upload de até 1 foto'
  },
  // 上传装/卸车图片
  Upload: {
    zh: '上传',
    en: '',
    pu: 'Enviar'
  },
  picture: {
    zh: '图片',
    en: '',
    pu: 'Imagem'
  },
  pleaseUploadLI: {
    zh: '请上传装车照片.',
    en: '',
    pu: 'Faça favor de carregar a foto de carregamento.'
  },
  pleaseUploadUnLI: {
    zh: '请上传卸车照片.',
    en: '',
    pu: 'Faça favor de carregar a foto de descarregamento.'
  },
  proofArrival: {
    zh: '到达凭证',
    en: '',
    pu: 'comprovante de chegada'
  },
  departureCertificate: {
    zh: '离开凭证',
    en: '',
    pu: 'certificado de partida'
  },
  merchantData: {
    zh: '商家数据展示',
    en: '',
    pu: 'Dados de seller'
  },
  merchantsTotalNumber: {
    zh: '商家总数',
    en: '',
    pu: 'total'
  },
  completeMerchant: {
    zh: '完成商家',
    en: '',
    pu: 'quantidade concluído'
  },
  residualMerchant: {
    zh: '剩余商家',
    en: '',
    pu: 'quantidade restante'
  },
  degreeCompletion: {
    zh: '完成度',
    en: '',
    pu: 'persentagem de conclusão'
  },
  singleVolumeData: {
    zh: '单量数据展示',
    en: '',
    pu: 'Dados de pedido'
  },
  unit: {
    zh: '单量',
    en: 'quantity per unit',
    pu: 'quantidade por unidade'
  },
  totalUnit: {
    zh: '总计单量',
    en: '',
    pu: 'total'
  },
  completionUnit: {
    zh: '完成单量',
    en: '',
    pu: 'quantidade concluído'
  },
  residualUnit: {
    zh: '剩余单量',
    en: '',
    pu: 'quantidade restante'
  },
  outgoingVehiclesNumber: {
    zh: '出车数量',
    en: '',
    pu: 'soma de veículo saído'
  },
  assistantsNumber: {
    zh: '助理数量',
    en: '',
    pu: 'quantidade de ajudante'
  },
  closedLoopUnit: {
    zh: '闭环单量',
    en: '',
    pu: 'quantidade de closed-loop'
  },
  complaintsNumber: {
    zh: '投诉数量',
    en: '',
    pu: 'quantidade de reclamação'
  },
  AbnormalUnivariate: {
    zh: '异常单量',
    en: '',
    pu: 'quantidade de anormal'
  },
  lanshouLargeScreen: {
    zh: '揽收看板可视化大屏',
    en: '',
    pu: 'Tela de visulização de coleta'
  },
  SenderCompany: {
    zh: '发件人公司',
    en: 'Sender Company',
    pu: 'Empresa do remetente'
  },
  lanshouZipcode: {
    zh: '揽收-邮编',
    en: '',
    pu: 'coleta-CEP'
  },
  receiveZipcode: {
    zh: '收件-邮编',
    en: '',
    pu: 'destinário-CEP'
  },
  scanPgTrc: {
    zh: '扫描大包号/运单号',
    en: '',
    pu: 'Digitalização do número da parcela/número da carta de porte'
  },
  scanPgTrcN: {
    zh: '扫描大包号/运单号：',
    en: '',
    pu: 'Digitalização do número da parcela/número da carta de porte：'
  },
  BagTrcNumber: {
    zh: '袋号/运单号',
    en: '',
    pu: 'Número da saca/número da carta de porte'
  },
  maxQuery1000: {
    zh: '最大查询1000条',
    en: '',
    pu: 'Consulta máxima de 1000 registros'
  },
  totalNumberOfPackages: {
    zh: '包裹总数',
    en: 'Total number of packages',
    pu: 'Total de pacotes'
  },
  pleaseRescan: {
    zh: '单号不符合要求请重新扫描',
    en: '',
    pu: 'Por favor, escaneie novamente o número de rastreamento, pois não está de acordo com os requisitos.'
  },
  largeVan: {
    zh: '大型厢式货车',
    en: '',
    pu: 'Van grande'
  },
  lightweightEnclosedCar: {
    zh: '轻型封闭式货车',
    en: '',
    pu: 'Veículo de carga leve fechado'
  },
  Volume: {
    zh: '车辆容积',
    en: '',
    pu: 'Volume do veículo'
  },
  Payload: {
    zh: '车辆载重',
    en: '',
    pu: 'Carga do veículo'
  },
  GrossWeight: {
    zh: '车辆毛重',
    en: '',
    pu: 'Gross Weight'
  },
  CNPJ: {
    zh: '车辆所属公司税号',
    en: '',
    pu: 'Código tributário da empresa de veículos'
  },
  trailerPlates: {
    zh: '拖车车牌',
    en: '',
    pu: 'Placa de licença do reboque'
  },
  vehicleStateRgtNumber: {
    zh: '车辆州注册号',
    en: '',
    pu: 'Número de registro estadual do veículo'
  },
  RNTRC: {
    zh: 'RNTRC',
    en: '',
    pu: 'RNTRC'
  },
  documentation: {
    zh: '车辆文件编号',
    en: '',
    pu: 'Número do documento do veículo'
  },
  trailerPlatesNotNull: {
    zh: '车辆拖车车牌不能为空',
    en: '',
    pu: 'As placas do reboque do veículo não podem estar vazias'
  },
  returnRegistration: {
    zh: '退件登记：',
    en: '',
    pu: 'Registro de devoluções：'
  },
  returnPoint: {
    zh: '退回网点：',
    en: '',
    pu: 'Retorno aos pontos de venda：'
  },
  returnSite: {
    zh: '退回网点',
    en: '',
    pu: 'Retorno aos pontos de venda'
  },
  UploadSuccessful: {
    zh: '上传成功',
    en: 'Upload successful',
    pu: 'Carregar bem-sucedido'
  },
  required: {
    zh: '请填写网点编号、网点名称、网点类型',
    en: '',
    pu: 'Preencha o número da tomada, o nome da tomada e o tipo de tomada'
  },
  requiredSiteStatus: {
    zh: '请填写是否启用项',
    en: '',
    pu: 'Preencha se o item está habilitado ou não'
  },
  orderPerDay: {
    zh: '日均下单量',
    en: '',
    pu: 'Volume de criação diária'
  },
  orderNum: {
    zh: '应揽收量',
    en: '',
    pu: 'Volume de contas a receber'
  },
  collectNum: {
    zh: '实际揽收量',
    en: '',
    pu: 'Cobranças reais'
  },
  unreceivedNum: {
    zh: '未揽收量',
    en: '',
    pu: 'Volume não coletado'
  },
  unreceivedOrder: {
    zh: '未揽收订单',
    en: '',
    pu: 'Pedidos não coletados'
  },
  registrantSiteName: {
    zh: '登记人所属网点',
    en: '',
    pu: 'Rede do registrante'
  },
  operatedObject: {
    zh: '操作对象',
    en: 'Operated object',
    pu: 'Objeto operado'
  },
  exportAllOrderData: {
    zh: '导出全部订单数据',
    en: 'Export all order data',
    pu: 'Exportar todos os dados de pedidos'
  },
  deliveryPostcode: {
    zh: '派送邮编：',
    en: '',
    pu: 'Código postal de entrega：'
  },
  zipCodeRangeSizePrompts: {
    zh: '起始邮编不能大于结束邮编',
    en: '',
    pu: 'O código postal inicial não pode ser maior que o código postal final'
  },
  noDuplicationAllowed: {
    zh: '不允许存在重复',
    en: '',
    pu: 'Não são permitidas duplicatas'
  },
  repeat: {
    zh: '重复值为：',
    en: '',
    pu: 'O valor de repetição é'
  },
  upload3Photos: {
    zh: '最多上传3张照片',
    en: '',
    pu: 'Faça upload de até 3 fotos'
  },
  deliverer: {
    zh: '派送人',
    en: '',
    pu: 'Entregador'
  },
  waybillNumber: {
    zh: '运单号',
    en: 'waybillNumber',
    pu: 'Número de waybill'
  },
  collectWay: {
    zh: '实际揽收方式',
    en: '',
    pu: 'Modo real de cobrança'
  },
  zipCodeDistance: {
    zh: '邮编距离',
    en: '',
    pu: 'Distância do Código Postal'
  },
  regionalType: {
    zh: '地域类型',
    en: '',
    pu: 'Tipo Regional'
  },
  riskRatio: {
    zh: '风险比例',
    en: '',
    pu: 'Proporção de Risco'
  },
  returnRegistrationTime: {
    zh: '退件登记时间',
    en: '',
    pu: 'Tempo de registro para devoluções'
  },
  returnReceiptTime: {
    zh: '退件签收时间',
    en: '',
    pu: 'Retorna o tempo de assinatura'
  },
  returnRegistrationPoint: {
    zh: '退件登记网点',
    en: '',
    pu: 'Devolve pontos de registro'
  },
  returnDignatureNetwork: {
    zh: '退件签收网点',
    en: '',
    pu: 'Devoluções Locais de assinaturas'
  },
  registrationNetwork: {
    zh: '登记网点',
    en: '',
    pu: 'Pontos de registro'
  },
  printDetails: {
    zh: '打印详情',
    en: '',
    pu: 'Imprimir detalhes'
  },
  printDot: {
    zh: '打印网点',
    en: '',
    pu: 'Locais de impressão'
  },
  vehicleNumber: {
    zh: '车辆号',
    en: 'Vehicle Number',
    pu: 'Número do Veículo'
  },
  vehicleLocation: {
    zh: '车辆所属网点',
    en: 'Vehicle Branch/Location',
    pu: 'Filial/Localização do Veículo'
  },
  arrivalLocation: {
    zh: '到达地点',
    en: 'Arrival Location',
    pu: 'Local de Chegada'
  },
  arrivalScanningPersonnel: {
    zh: '到达扫描人',
    en: 'Arrival Scanning Personnel',
    pu: 'Pessoal de Escaneamento de Chegada'
  },
  departureTime: {
    zh: '离开时间',
    en: 'Departure Time',
    pu: 'Hora de Saída'
  },
  departureScanningPersonnel: {
    zh: '离开扫描人',
    en: 'Departure Scanning Personnel',
    pu: 'Pessoal de Escaneamento de Saída'
  },
  imageDetails: {
    zh: '图片详情',
    en: 'Image Details',
    pu: 'Detalhes da Imagem'
  },
  arrival: {
    zh: '到达',
    en: 'Arrival',
    pu: 'Chegada'
  },
  departure: {
    zh: '离开',
    en: 'Departure',
    pu: 'Saída'
  },
  leaveLocation: {
    zh: '离开地点',
    en: 'Leave location',
    pu: 'Deixar local'
  },
  noImageAvailable: {
    zh: '暂无图片',
    en: 'No image available',
    pu: 'Nenhuma imagem disponível'
  },
  shennAgingExpirationTime: {
    zh: 'SHEIN时效到期时间',
    en: '',
    pu: 'Tempo de exigência de prazo de SHEIN'
  },
  TheAffiliatedNetworkEmpty: {
    zh: '所属网点为空',
    en: 'The affiliated network is empty',
    pu: 'A rede afiliada está vazia'
  },
  arrivalPoint: {
    zh: '到达网点',
    en: '',
    pu: 'chegar ao ponto'
  },
  exitNode: {
    zh: '离开网点',
    en: '',
    pu: 'sair do ponto'
  },
  rangeWaveNumber: {
    zh: '揽收波次号',
    en: '',
    pu: 'número da onda de coleta'
  },
  waveNumberCreationTime: {
    zh: '波次号创建时间',
    en: '',
    pu: 'tempo de criação do número da onda de coleta'
  },
  collectionPointInventory: {
    zh: '揽收网点入库',
    en: '',
    pu: 'Coletar o pool de receitas'
  },
  connectedSuccessfully: {
    zh: '揽收客户端设备对接成功!',
    en: '',
    pu: 'Integração bem-sucedida do dispositivo cliente da coleta!'
  },
  scheduleCollectionTime: {
    zh: '计划揽收时间',
    en: '',
    pu: 'Horário de coleta programado'
  },
  englishSplit: {
    zh: '用英文逗号隔开',
    en: '',
    pu: 'Separa-los por vírgula em inglês'
  },
  merchant: {
    zh: '商家',
    en: '',
    pu: 'Seller'
  },
  BagManage: {
    zh: '袋号管理',
    en: '',
    pu: 'Gerenciamento de sacas'
  },
  packageCollection: {
    zh: '包裹收集',
    en: 'Package Collection',
    pu: 'Coleta de pacotes'
  },
  confirmPackage: {
    zh: '确认包裹',
    en: '',
    pu: 'Confirmar pacotes'
  },
  quantityBagsLabel: {
    zh: '袋子数量',
    en: '',
    pu: 'Qtd. Sacas'
  },
  CommercialOwner: {
    zh: '商户',
    en: '',
    pu: 'Vendedor'
  },
  scanCount: {
    zh: '扫描计数',
    en: '',
    pu: 'Qtd. Sacas'
  },
  exportChilderInfor: {
    zh: '子包信息导出',
    en: '',
    pu: 'Exportar informações do subpacote'
  },
  export1: {
    zh: '勾选导出',
    en: '',
    pu: 'Exportar selecionados'
  },
  repeatDataTips: {
    zh: '请不要重复扫描',
    en: '',
    pu: 'não repita a varredura'
  },
  auditTime: {
    zh: '稽查时间',
    en: '',
    pu: 'Tempo de inspeção'
  },
  auditNetwork: {
    zh: '稽查网点',
    en: '',
    pu: 'Ponto de inspeção'
  },
  auditor: {
    zh: '稽查人',
    en: '',
    pu: 'Inspetor'
  },
  auditResult: {
    zh: '稽查结果',
    en: '',
    pu: 'Resultado'
  },
  auditBatchNumber: {
    zh: '稽查批次号',
    en: '',
    pu: 'Número de Lote de inspeção'
  },
  billOrBag: {
    zh: '单号/袋号',
    en: '',
    pu: 'Nº do pedido/ Nº da saca'
  },
  processingResult: {
    zh: '处理结果',
    en: '',
    pu: 'Resultado'
  },
  auditImg: {
    zh: '稽查照片',
    en: '',
    pu: 'Foto de inspeção'
  },
  checkParcel: {
    zh: '稽查包裹',
    en: '',
    pu: 'Qtd. De Pacote'
  },
  abnormalData: {
    zh: '异常数据',
    en: '',
    pu: 'Dados anormais'
  },
  SelectOnly: {
    zh: '网点或者格口只需选中其中一个',
    en: '',
    pu: 'Selecionar apenas ponto ou grade'
  },
  SelectNet: {
    zh: '选择网点',
    en: '',
    pu: 'Selecionar ponto'
  },
  SelectGriude: {
    zh: '选择格口',
    en: '',
    pu: 'Selecionar grade'
  },
  PrintCopies: {
    zh: '打印份数',
    en: '',
    pu: 'Quantidade de cópias para impressão'
  },
  printRecord: {
    zh: '打印记录',
    en: '',
    pu: 'Registro de impressão'
  },
  copies: {
    zh: '份数',
    en: '',
    pu: 'Quantidade de cópias'
  },
  selectOr: {
    zh: '请选择网点或者格口',
    en: '',
    pu: 'Selecionar ponto ou grade'
  },
  inputcopies: {
    zh: '请输入打印份数',
    en: '',
    pu: 'Faça favor de inserir a quantidade de cópias'
  },
  more20: {
    zh: '最多一次打印20份',
    en: '',
    pu: 'Imprir até 20 cópias por vez'
  },
  bangdingduoge: {
    zh: '该网点绑定了多个格口, 请选择格口打印!',
    en: '',
    pu: 'O ponto está vingulado a várias grades, selecione grade para imprimir!'
  },
  netAdress: {
    zh: '网点地址',
    en: '',
    pu: 'Endereço de Ponto'
  },
  threeCode: {
    zh: '三段码',
    en: '',
    pu: 'Código de três segmentos'
  },
  fenboCode: {
    zh: '分拨编码',
    en: '',
    pu: 'Código de distribuição'
  },
  inputLWH: {
    zh: '请输入长宽高',
    en: '',
    pu: 'Digite o comprimento, a largura e a altura'
  },
  pleaseChooseNextSite: {
    zh: '请选择下一站',
    en: '',
    pu: 'Por favor, selecione a próxima parada'
  },
  bei: {
    zh: '被',
    en: '',
    pu: 'foi'
  },
  sendNextStop: {
    zh: '发往下一站',
    en: '',
    pu: 'foi enviado para próxima parada'
  },
  bbei: {
    zh: '并被',
    en: '',
    pu: 'e foi'
  },
  signExport: {
    zh: '签收信息导出',
    en: '',
    pu: 'Exportar informações de recebimento'
  },
  // xxxxx已被【xxxx】的【xxx】揽收
  // xxxxx já foi coletado por 【xxx】 de 【xxxx】
  yibei: {
    zh: '已被',
    en: '',
    pu: 'já foi coletado por'
  },
  de: {
    zh: '的',
    en: '',
    pu: 'de'
  },
  haveClosedLoop: {
    zh: '已被闭环',
    en: '',
    pu: 'Ciclo já foi fechado'
  },
  // 专为轨迹查询描述判断使用-------start
  status1: {
    zh: '闭环',
    en: '',
    pu: 'Circuito fechado'
  },
  status2: {
    zh: '已揽收',
    en: '',
    pu: 'Coletados'
  },
  status3: {
    zh: '已签收',
    en: '',
    pu: 'Pedido entregue'
  },
  status4: {
    zh: '封袋',
    en: '',
    pu: 'Fechar Saca'
  },
  status5: {
    zh: '换袋',
    en: '',
    pu: 'Mudar de saco'
  },
  status6: {
    zh: '装车',
    en: '',
    pu: 'Varredura de carregamento'
  },
  status7: {
    zh: '卸车',
    en: '',
    pu: 'Varredura de descarregamento'
  },
  rebag: {
    zh: '重新封袋',
    en: '',
    pu: 'Re-selar o saco'
  },
  // 专为轨迹查询描述判断使用-------end
  secondLoadingLicensePlate: {
    zh: '第二次装车车牌号',
    en: '',
    pu: 'o número da placa no segundo carregamento'
  },
  firstLoadingTime: {
    zh: '第一次装车时间',
    en: '',
    pu: 'tempo do primeiro carregamento'
  },
  firstUnloadingTime: {
    zh: '第一次卸车时间',
    en: '',
    pu: 'tempo do primeiro descarregamento'
  },
  secondLoadingTime: {
    zh: '第二次装车时间',
    en: '',
    pu: 'tempo do segundo carregamento '
  },
  vehicleArrivalTime: {
    zh: '车辆到达时间',
    en: '',
    pu: 'tempo de chegada do veículo'
  },
  collectDuration: {
    zh: '揽收时长(小时)',
    en: '',
    pu: 'Duração da coleta（hora）'
  },
  cDuration: {
    zh: '揽收时长',
    en: '',
    pu: 'Duração da coleta'
  },
  transferDuration: {
    zh: '中转时长(小时)',
    en: '',
    pu: 'Duração de trânsito（hora）'
  },
  tfDuration: {
    zh: '中转时长',
    en: '',
    pu: 'Duração de trânsito'
  },
  transportDuration: {
    zh: '运输时长(小时)',
    en: '',
    pu: 'Duração de transportar（hora）'
  },
  tDuration: {
    zh: '运输时长',
    en: '',
    pu: 'Duração de transportar'
  },
  ScannerFail: {
    zh: '扫描失败',
    en: '',
    pu: 'Falha na bipagem'
  },
  tip01: {
    zh: '袋内以下单号尚未做到件, 请先操作到件',
    en: '',
    pu: 'O pedido de pacote desta saca ainda não entrega, por favor, opere “a entrega de pacote“ primeiro'
  },
  tip02: {
    zh: '以下订单推送服务商失败',
    en: '',
    pu: 'Os pedidos enviados ao parceiro falhou'
  },
  tip03: {
    zh: '订单推送成功：',
    en: '',
    pu: 'Os pedidos foram enviados com sucesso：'
  },
  tip04: {
    zh: '个包裹',
    en: '',
    pu: 'pacotes'
  },
  pleaseSelectBusinessTime: {
    zh: '请选择营业时间',
    en: '',
    pu: 'Os dados do horário de funcionamento não podem estar vazios'
  },
  pleaseSelectBusinessWeek: {
    zh: '营业星期不能为空',
    en: '',
    pu: ' A semana de funcionamento não pode estar vazio'
  },
  pleaseChooseAgainTime: {
    zh: '时间选择有误，请重新选择',
    en: '',
    pu: 'O tempo selecionado está errado, por favor, selecine novamente'
  },
  finance: {
    zh: '财务',
    en: '',
    pu: 'Financeiro'
  },
  trackingPackage: {
    zh: '轨迹',
    en: 'Tracking Package',
    pu: 'Tracking do Pacote'
  },
  BasicInformation: {
    zh: '基础资料',
    en: 'Basic information',
    pu: 'Dados Básicos / Cadastro Básico'
  },
  module: {
    zh: '模块',
    en: '',
    pu: 'módulo'
  },
  titleName: {
    zh: '标题名称',
    en: '',
    pu: 'nome de título'
  },
  transfer: {
    zh: '中转',
    en: '',
    pu: 'trânsito'
  },
  serviceQuality: {
    zh: '服务质量',
    en: '',
    pu: 'qualidade de serviço'
  },
  max5Files: {
    zh: '限制最多上传5个文件',
    en: '',
    pu: 'Máximo arquivo a upload é 5'
  },
  max1Files: {
    zh: '限制最多上传1个文件',
    en: '',
    pu: 'Máximo arquivo a upload é 1'
  },
  pleaseWait: {
    zh: '文件上传中，请等待...',
    en: '',
    pu: 'O arquivo está sendo carregado, por favor, aguarde...'
  },
  uploadFileFormat: {
    zh: '上传文件支持PDF、doc、docx、xls、xlsx、csv、png、jpg、bmg、jpeg、txt、MP4、GIF等格式',
    en: '',
    pu: 'A transferência de arquivos suporta formatos como PDF, doc, docx, xls, xlsx, csv, png, jpg, bmg, jpeg, txt, MP4, GIF, entre outros.'
  },
  notGetSignImg: {
    zh: '还未获取到签名截图，请稍后...',
    en: '',
    pu: 'Por favor, aguarde, ainda não recebe a captura de tela de assinatura'
  },
  closedTotalParcels: {
    zh: '闭环包裹总数',
    en: '',
    pu: 'Níumero total de pacotes fechados'
  },
  unloadTotalParcels: {
    zh: '卸车总包裹数',
    en: '',
    pu: 'Total de pacotes descarregados'
  },
  signTotalParcels: {
    zh: '签收包裹总数',
    en: '',
    pu: 'Total de pacotes recebidos'
  },
  warehouseDeliveryAbnormalData: {
    zh: '送仓异常数据',
    en: '',
    pu: 'Dados anômalos de entrega ao armazém'
  },
  suspectedMissingItem: {
    zh: '疑似丢件',
    en: '',
    pu: 'Possível perda de pacote'
  },
  suspectedMissedScan: {
    zh: '疑似漏扫',
    en: '',
    pu: 'Possível falta de escaneamento'
  },
  unloadDot: {
    zh: '卸车网点',
    en: '',
    pu: 'Ponto de descarregamento'
  },
  currentUnloadingVehicle: {
    zh: '当前卸车车辆',
    en: '',
    pu: 'Veículo descarregando '
  },
  shouldUnload: {
    zh: '应卸车',
    en: '',
    pu: 'Veículo a descarregar'
  },
  Type: {
    zh: '类型',
    en: '',
    pu: 'Tipo de saca'
  },
  numberPackages: {
    zh: '包裹数',
    en: '',
    pu: 'Quantidade de pacotes'
  },
  group: {
    zh: '组别',
    en: '',
    pu: 'Group'
  },
  region: {
    zh: '大区',
    en: '',
    pu: 'Região'
  },
  area: {
    zh: '区',
    en: '',
    pu: 'Bairro'
  },
  DotHoldUp: {
    zh: '网点滞留量',
    en: '',
    pu: 'Qtd. de retenção de pontos'
  },
  within5Hours: {
    zh: '5小时内',
    en: '',
    pu: 'Dentro de 5 horas'
  },
  within10Hours: {
    zh: '10小时内',
    en: '',
    pu: 'Dentro de 10 horas'
  },
  over10Hours: {
    zh: '超10小时',
    en: '',
    pu: 'Mais de 10 horas'
  },
  bulkyOrder: {
    zh: '大件订单',
    en: '',
    pu: 'Pedido de carga grande'
  },
  responseResult: {
    zh: '响应结果',
    en: '',
    pu: 'Resposta do resultado'
  },
  allDeclaredValue: {
    zh: '总申明价值',
    en: '',
    pu: 'Valor declarado total'
  },
  suborderDeclaredValue: {
    zh: '子单申明价值',
    en: '',
    pu: 'Valor declarado de pedido subsidiário'
  },
  receiveBatchNumber: {
    zh: '揽收批次号',
    en: '',
    pu: 'Número do lote de coleta'
  },
  doorToLanSCollectionsTotal: {
    zh: '上门揽收总揽收量',
    en: '',
    pu: 'Qtd. total de coleta nos seller'
  },
  doorToLanSTotal: {
    zh: '上门揽收总数',
    en: '',
    pu: 'Total de coletas'
  },
  doorToDoorTotal: {
    zh: '上门交件总量',
    en: '',
    pu: 'Total de entregas'
  },
  doorToDoorCollectionsTotal: {
    zh: '上门交件总揽收量',
    en: '',
    pu: 'Qtd. total de entrega nos Mini Drop'
  },
  value: {
    zh: '值',
    en: '',
    pu: 'número'
  },
  punctualDepartureRateOutlets: {
    zh: '网点准时发车率',
    en: '',
    pu: 'taxa de pontualidade de partida no ponto'
  },
  transitCenterPunctualDepartureRate: {
    zh: '转运中心准时发车率',
    en: '',
    pu: 'taxa de pontualidade de partida no centro de trânsito'
  },
  OnTimeArrivalRate: {
    zh: '运抵准时率',
    en: '',
    pu: 'taxa de pontualidade de chegada'
  },
  networkLoadingTime: {
    zh: '网点装车时间',
    en: '',
    pu: 'tempo de carregamento no ponto'
  },
  networkLoader: {
    zh: '网点装车人',
    en: '',
    pu: 'carregador no ponto'
  },
  unloadingTransferCenterTime: {
    zh: '转运中心卸车时间',
    en: '',
    pu: 'tempo de descarregamento no centro de trânsito'
  },
  unloadingTransferCenterP: {
    zh: '转运中心卸车人',
    en: '',
    pu: 'descarregador no centro de trânsito'
  },
  transferCenterLoadingTime: {
    zh: '转运中心装车时间',
    en: '',
    pu: 'tempo de carregamento no centro de trânsito'
  },
  transferCenterLoader: {
    zh: '转运中心装车人',
    en: '',
    pu: 'carregador no centro de trânsito'
  },
  chooseOneWeek: {
    zh: '单次最多查询一个星期的数据',
    en: '',
    pu: 'Cada vez só pode consultar dados de uma semana ao máximo'
  },
  senderSubregion: {
    zh: '寄件人所属大区',
    en: '',
    pu: 'Macro region de rementente'
  },
  senderOwningRegion: {
    zh: '寄件人所属区域',
    en: '',
    pu: 'Micro region de rementente'
  },
  collectionNetworkSubregion: {
    zh: '揽收网点所属大区',
    en: '',
    pu: 'Macro region de pontos coletado'
  },
  collectionNetworkOwningRegion: {
    zh: '揽收网点所属区域',
    en: '',
    pu: 'Micro region de pontos coletados'
  },
  QYcnpj: {
    zh: '签约CNPJ',
    en: '',
    pu: 'Assinar CNPJ'
  },
  modalDriverLicence: {
    zh: '驾驶证',
    en: '',
    pu: 'Carteira de motorista'
  },
  driver1: {
    // 员工管理用于判断角色葡语
    zh: '司机',
    en: '',
    pu: 'Motorista'
  },
  FileReadingFailurePleaseWait: {
    zh: '文件读取失败，请稍后再试',
    en: '',
    pu: 'A leitura do arquivo falhou, por favor tente novamente mais tarde'
  },
  TypeBill: {
    zh: '账单类型',
    en: 'Type of bill',
    pu: 'Tipo de fatura'
  },
  BillingTime: {
    zh: '账单时间',
    en: 'billing time',
    pu: 'tempo de faturamento'
  },
  infoPackage: {
    zh: '包裹信息',
    en: '',
    pu: 'Informação do pacote'
  },
  loadingPoint: {
    zh: '装车地点',
    en: '',
    pu: 'Local de carregamento'
  },
  signatureConfirmation: {
    zh: '签名确认',
    en: '',
    pu: 'Assinatura confirmada'
  },
  driverIsExpect: {
    zh: '司机是否符合预期',
    en: '',
    pu: 'O motorista está de acordo com as expectativas?'
  },
  driverRemark: {
    zh: '司机如果跟预期不一致，可在该栏位备注',
    en: '',
    pu: 'Se o motorista não corresponder às expectativas, pode fazer uma observação neste campo.'
  },
  loadingSignPicture: {
    zh: '装车签名图片',
    en: '',
    pu: 'foto de assinatura de carregamento'
  },
  networkLoadingSignaturePicture: {
    zh: '网点装车签名图片',
    en: '',
    pu: 'Foto de assinatura de carregamento no ponto'
  },
  transferCenterLoadingSignaturePicture: {
    zh: '转运中心装车签名图片',
    en: '',
    pu: 'Foto de assinatura de carregamento no centro de  trânsito'
  },
  currentOddNumberRepeat: {
    zh: '当前单号重复',
    en: '',
    pu: 'Pedido repetido'
  },
  pushSucess: {
    zh: '推送成功',
    en: '',
    pu: 'sucesso de push'
  },
  Falha: {
    zh: '推送失败',
    en: '',
    pu: 'Falha de impulso'
  },
  pushException: {
    zh: '推送异常',
    en: '',
    pu: 'envio abnormal'
  },
  parcelTrack: {
    zh: '包裹轨迹',
    en: '',
    pu: 'rastreio de pacote'
  },
  batchTrack: {
    zh: '批量轨迹',
    en: '',
    pu: 'rastreios em massa'
  },
  truncatedBatchTrack: {
    zh: '截单批量轨迹',
    en: '',
    pu: 'rastreio de lote de cut-off'
  },
  lastLoadingTrack: {
    zh: '最后一次装车轨迹',
    en: '',
    pu: 'rastreio de último carregamento'
  },
  ReasonForFailure: {
    zh: '失败原因',
    en: 'Reason for failure',
    pu: 'Motivo da reprovação'
  },
  collectWarehousing: {
    zh: '网点揽收入库',
    en: '',
    pu: 'Entrada do armazém na coleta no Ponto'
  },
  collectPackageTrack: {
    zh: '揽收包裹轨迹',
    en: '',
    pu: 'rastreamento de coleta de pacotes'
  },
  max2000Line: {
    zh: '精确搜索，一行一项，最多支持2000行',
    en: '',
    pu: 'Pesquisa precisa, 1 linha por 1 item, ao máximo 2000 linhas'
  },
  max100Line: {
    zh: '精确搜索，一行一项，最多支持100行',
    en: '',
    pu: 'Pesquisa precisa, 1 linha por 1 item, ao máximo 100 linhas'
  },
  max200Line: {
    zh: '精确搜索，一行一项，最多支持200行',
    en: '',
    pu: 'Pesquisa precisa, 1 linha por 1 item, ao máximo 200 linhas'
  },
  senderProvince: {
    zh: '寄件人省份',
    en: '',
    pu: 'Província de remetente'
  },
  delivererJobType: {
    zh: '派送员岗位类型',
    en: '',
    pu: 'Tipo de cargo de entregador'
  },
  clearSearchCriteria: {
    zh: '清空搜索条件',
    en: '',
    pu: 'Limpar critérios de pesquisa'
  },
  outletWarehouse: {
    zh: '网点出库',
    en: '',
    pu: 'Saída de ponto'
  },
  customerOrderStatus: {
    zh: '客户订单状态',
    en: '',
    pu: 'Status de pedido de cliente'
  },
  nowOperating: {
    zh: '最新操作',
    en: '',
    pu: 'Última operação'
  },
  nowOperatingTime: {
    zh: '最新操作时间',
    en: '',
    pu: 'Tempo da última operação'
  },
  IntermediateWeight: {
    zh: '中转复重(kg) ',
    en: '',
    pu: 'Re-pesagem de trânsito(kg)'
  },
  expectedDeliveryOutlets: {
    zh: '预计派送网点',
    en: '',
    pu: 'Ponto de entrega previsto'
  },
  max100Tips: {
    zh: '本操作一次最多可执行100条数据，当前已超过100条，请重新勾选！',
    en: '',
    pu: 'Esta peração pode executar no máximo 100 dados por vez, já excedeu 100, por favor reselecione'
  },
  NoDistributionRequired: {
    zh: '选中的订单不是待分配状态，无需分配！',
    en: '',
    pu: 'Pedido selecinado não está em status de distribuir,não precisa de distribuir'
  },
  // 为了方便拼接——————————start
  // 已执行成功xx条数据
  // Já executou xx dados com successo
  executedSuccessfully: {
    zh: '已执行成功',
    en: '',
    pu: 'Já executou'
  },
  pieceData: {
    zh: '条数据',
    en: '',
    pu: 'dados com successo'
  },
  // 为了方便拼接——————————end
  pleaseEnterRemarks: {
    zh: '请输入备注内容',
    en: '',
    pu: 'Insira a observação'
  },
  distributionWaybillCollection: {
    zh: '将选中的运单分配给以下指定揽收网点进行揽收',
    en: '',
    pu: 'Distribue o pedido  selecionado para o ponto de coleta designado abaixo'
  },
  allowedDistributionWaybill: {
    zh: "仅状态为'待分配'的运单可分配揽收网点",
    en: '',
    pu: "Apenas com status 'Aguardando distribuir' podem ser designadas para pontos de coleta"
  },
  operationComplete: {
    zh: '操作完成',
    en: '',
    pu: 'Operação concluída'
  },
  waybillTrack: {
    zh: '运单轨迹',
    en: '',
    pu: 'Rastreio'
  },
  noteRecord: {
    zh: '备注记录',
    en: '',
    pu: 'Registros de observação'
  },
  photoInformation: {
    zh: '照片信息',
    en: '',
    pu: 'Informação de foto'
  },
  send: {
    zh: '寄',
    en: '',
    pu: 'Remetente'
  },
  receiver: {
    zh: '收',
    en: '',
    pu: 'Destinatário'
  },
  sendingPhone: {
    zh: '发件手机',
    en: '',
    pu: 'Celular do remetente'
  },
  sendingTelephone: {
    zh: '发件电话',
    en: '',
    pu: 'Telefone do remetente'
  },
  sendingCompany: {
    zh: '发件公司',
    en: '',
    pu: 'Empresa  remetente'
  },
  receivingPhone: {
    zh: '收件手机',
    en: '',
    pu: 'Celular do destinatário'
  },
  receivingTelephone: {
    zh: '收件电话',
    en: '',
    pu: 'Telefone do destinatário'
  },
  receivingCompany: {
    zh: '收件公司',
    en: '',
    pu: 'Empresa  destinatária'
  },
  customerOrderWeight: {
    zh: '客户下单重量(kg)',
    en: '',
    pu: 'Peso de pedido de cliente(kg)'
  },
  collectLenWidHgh: {
    zh: '揽收长宽高(cm)',
    en: '',
    pu: 'Dimensões de coleta (comprimento x largura x altura em cm)'
  },
  preCollectionOutlets: {
    zh: '预揽收网点',
    en: '',
    pu: 'Ponto de coleta previsto'
  },
  rejectWhetherReturn: {
    zh: '拒收是否退回',
    en: '',
    pu: 'Rejeitado, deve ser devolvido?'
  },
  viewSheet: {
    zh: '查看面单',
    en: '',
    pu: 'Verificar etiqueta'
  },
  placeOrderLenWidHgh: {
    zh: '下单长宽高(cm)',
    en: '',
    pu: 'Comprimento, largura e altura do pedido (cm)'
  },
  transferReHeavy: {
    zh: '中转仓复重(kg)',
    en: '',
    pu: 'Re-pesagem no armazém de trânsito(kg)'
  },
  receivingWeight: {
    zh: '揽收重量(kg)',
    en: '',
    pu: 'Peso da coleta (kg)'
  },
  transferLenWidHgh: {
    zh: '中转长宽高(cm)',
    en: '',
    pu: 'Comprimento, largura e altura do trânsito (cm)'
  },
  deliveryRoute: {
    zh: '派送路线',
    en: '',
    pu: 'Rota de entrega'
  },
  cnsignmentInformation: {
    zh: '托寄物信息',
    en: '',
    pu: 'Informações do item enviado'
  },
  InternalLocus: {
    zh: '内部轨迹',
    en: '',
    pu: 'Rastreio interno'
  },
  customerTrajectory: {
    zh: '客户轨迹',
    en: '',
    pu: 'Rastreio pra cliente'
  },
  controlsEmployee: {
    zh: '操作员',
    en: '',
    pu: 'Operador'
  },
  largeOrderDetails: {
    zh: '大件订单详情',
    en: '',
    pu: 'Detalhes do pedido de carga grande'
  },
  waybillSRMessage: {
    zh: '运单寄收信息',
    en: '',
    pu: 'Informações de envio e recebimento do rastreio'
  },
  predictedTrajectory: {
    zh: '预测轨迹',
    en: '',
    pu: 'Rastreio previsto'
  },
  EstimatedTimeDelivery: {
    zh: '预计送达时间',
    en: '',
    pu: 'Horário estimado de entrega'
  },
  realTimeTrajectory: {
    zh: '实时轨迹',
    en: '',
    pu: 'Rastreio em tempo real'
  },
  receiveSign: {
    zh: '揽收签收',
    en: '',
    pu: 'Confirmação de Recebimento da Coleta'
  },
  senderSignature: {
    zh: '发件人签名',
    en: '',
    pu: 'Assinatura do remetente'
  },
  signatory: {
    zh: '签署人',
    en: '',
    pu: 'Assinante'
  },
  signTimeS: {
    zh: '签署时间',
    en: '',
    pu: 'Horário da assinatura'
  },
  sendSign: {
    zh: '派件签收',
    en: '',
    pu: 'Recebimento de entrega'
  },
  SignedByDOC: {
    zh: '签署人DOC',
    en: '',
    pu: 'Documento do assinante'
  },
  signatoryTime: {
    zh: '签署人时间',
    en: '',
    pu: 'Hora da assinatura'
  },
  collectSignTakePicture: {
    zh: '揽收签收拍照',
    en: '',
    pu: 'Foto de confirmação da coleta '
  },
  collectCarNumTakePicture: {
    zh: '揽收车签号拍照',
    en: '',
    pu: 'Foto do nº do veículo de coleta'
  },
  transferPhotograph: {
    zh: '中转拍照',
    en: '',
    pu: 'Foto de transbordo'
  },
  sendTakePhotos: {
    zh: '派件签收拍照',
    en: '',
    pu: 'Foto de confirmação de entrega'
  },
  physicalTransferWarehouse: {
    zh: '实际中转仓',
    en: '',
    pu: 'Armazém de transbordo real'
  },
  lenWidHgh: {
    zh: '长宽高（cm）',
    en: '',
    pu: ''
  },
  prescriptionName: {
    zh: '时效名称',
    en: '',
    pu: 'Nome do Prazo'
  },
  ageingStandardValue: {
    zh: '时效标准值（单位：h）',
    en: '',
    pu: 'Valor Padrão do Prazo (unidade: h)'
  },
  prescriptionArrival: {
    zh: '运抵时效',
    en: '',
    pu: 'Prazo de Entrega'
  },
  firstLoadingLicensePlate: {
    zh: '第一次装车车牌号',
    en: '',
    pu: 'Placa do primeiro carregamento'
  },
  firstLoadedUser: {
    zh: '第一次装车操作人',
    en: '',
    pu: 'Primeiro Operador de Carregamento'
  },
  firstLoadSite: {
    zh: '第一次装车网点',
    en: '',
    pu: 'Primeiro Ponto de Carregamento'
  },
  firstUnloadUser: {
    zh: '第一次卸车操作人',
    en: '',
    pu: 'Primeiro Operador de Descarregamento'
  },
  firstUnloadSite: {
    zh: '第一次卸车网点',
    en: '',
    pu: 'Primeiro Ponto de Descarregamento'
  },
  secondLoadedUser: {
    zh: '第二次装车操作人',
    en: '',
    pu: 'Segundo Operador de Carregamento'
  },
  secondLoadSite: {
    zh: '第二次装车网点',
    en: '',
    pu: 'Segundo Ponto de Carregamento'
  },
  networkLoadScanTime: {
    zh: '网点装车扫描时间',
    en: '',
    pu: 'Horário de Bipagem do Carregamento no Ponto'
  },
  networkLoadVehicleNum: {
    zh: '网点装车车牌号',
    en: '',
    pu: 'Placa do Veículo no Carregamento do Ponto'
  },
  networkLoadUploadingTime: {
    zh: '网点装车上传时间',
    en: '',
    pu: 'Horário de Upload do Carregamento no Ponto'
  },
  transferLoadScanTime: {
    zh: '转运中心装车扫描时间',
    en: '',
    pu: 'Horário de Bipagem do Carregamento no Centro de Transferência'
  },
  transferLoadVehicleNum: {
    zh: '转运中心装车车牌号',
    en: '',
    pu: 'Placa do Veículo no Carregamento do Centro de Transferência'
  },
  transferLoadUploadingTime: {
    zh: '转运中心装车上传时间',
    en: '',
    pu: 'Horário de Upload do Carregamento no Centro de Transferência'
  },
  outletUnloader: {
    zh: '网点卸车人',
    en: '',
    pu: 'Operador de Descarregamento no Ponto'
  },
  outletUnloadingTime: {
    zh: '网点卸车时间',
    en: '',
    pu: 'Horário de Descarregamento no Ponto'
  },
  exportChangeTip: {
    zh: '导出成功，数据将会在1~10分钟内生成表格，请到系统管理中的资源任务列表中下载，',
    en: '',
    pu: 'Exportação bem-sucedida, os dados serão gerados em uma tabela dentro de 1 a 10 minutos. Por favor, acesse A Lista de Exportação de Recursos em Administração do Sistema para baixar.'
  },
  vehicleMsgConfirmTime: {
    zh: '车辆信息确认时间',
    en: '',
    pu: 'Horário de Confirmação das Informações do Veículo'
  },
  vehicleMsgConfirmPeople: {
    zh: '车辆信息确认人',
    en: '',
    pu: 'Responsável pela Confirmação das Informações do Veículo'
  },
  loadPkgConfirmTime: {
    zh: '装车包裹确认时间',
    en: '',
    pu: 'Horário de Confirmação dos Pacotes Carregados'
  },
  loadPkgConfirmPeople: {
    zh: '装车包裹确认人',
    en: '',
    pu: 'Responsável pela Confirmação dos Pacotes Carregados'
  },
  loadPkgTicketSum: {
    zh: '装车包裹票数',
    en: '',
    pu: 'Qtd. dos Pacotes Carregados'
  },
  loadPkgBagSum: {
    zh: '装车包裹袋数',
    en: '',
    pu: 'Qtd. de Sacas Carregadas'
  },
  loadSumConfirm: {
    zh: '装车数量确认',
    en: '',
    pu: 'Confirmação da Qtd. Carregada'
  },
  loadDataConfirmRemark: {
    zh: '装车数据确认备注',
    en: '',
    pu: 'Observações sobre a Confirmação dos Dados de Carregamento'
  },
  vehicleConfirmScan: {
    zh: '车辆确认扫描',
    en: '',
    pu: 'Bipagem de Confirmação do Veículo'
  },
  inputVehicleNumber: {
    zh: '请输入车牌号码',
    en: '',
    pu: 'Insira o Número da Placa'
  },
  licensePlateRules: {
    zh: '格式为三个字母 + 四个数字（例如：ABC1234）或者三字母 + 一数字 + 一字母 + 两数字（例如：ABC1D23）',
    en: '',
    pu: 'Formato: Três Letras + Quatro Números (ex.: ABC1234) ou Três Letras + Um Número + Uma Letra + Dois Números (ex.: ABC1D23)'
  },
  bagCountDiscrepancy: {
    zh: '装卸车总袋数差异',
    en: '',
    pu: 'Diferença na Qtd. Total de Sacas entre Carregamento e Descarregamento'
  },
  votesDiscrepancy: {
    zh: '装卸车总票数差异',
    en: '',
    pu: 'Diferença na Qtd. Total de Pacotes entre Carregamento e Descarregamento'
  },
  unloadSignImg: {
    zh: '卸车签名图片',
    en: '',
    pu: 'Imagem da Assinatura do Descarregamento'
  },
  unloadPoint: {
    zh: '卸车地点',
    en: '',
    pu: 'Local de Descarregamento'
  },
  unloadCompletionTime: {
    zh: '卸车完成时间',
    en: '',
    pu: 'Tempo de Conclusão do Descarregamento'
  },
  errRemark: {
    zh: '如果卸车数据出现异常经现场核实，可在该栏位备注',
    en: '',
    pu: 'Caso haja alguma anomalia nos dados de descarregamento confirmada no local, uma observação pode ser feita nesta coluna.'
  },
  withLoadDataDiff: {
    zh: '与装车数据的差异：xx袋（xx票）',
    en: '',
    pu: 'Diferença nos Dados de Carregamento: xx sacas (xx pacotes)'
  },
  w1: {
    zh: '与装车数据的差异：',
    en: '',
    pu: 'Diferença nos Dados de Carregamento: '
  },
  w2: {
    zh: '袋（',
    en: '',
    pu: ' sacas ('
  },
  w3: {
    zh: '票）',
    en: '',
    pu: ' pacotes)'
  },
  toUnload: {
    zh: '已卸车数量为0，请先卸车',
    en: '',
    pu: 'A Qtd. descarregada é 0, por favor, descarregue primeiro.'
  },
  verifyDot: {
    zh: '确认网点',
    en: '',
    pu: 'Confirmar ponto de coleta.'
  },
  verifyTime: {
    zh: '确认时间',
    en: '',
    pu: 'Data de confirmação'
  },
  verifyPerson: {
    zh: '确认人',
    en: '',
    pu: 'Confirmador'
  },
  shouldUnloaded: {
    zh: '应卸',
    en: '',
    pu: 'Deveria Ser Descarregado'
  },
  actualUnloaded: {
    zh: '实卸',
    en: '',
    pu: 'Descarregado Realmente'
  },
  owningTransitCenter1: {
    zh: '所属转运中心',
    en: '',
    pu: 'HUB de trânsito'
  },
  stateSite1: {
    zh: '网点所属州',
    en: '',
    pu: 'Estado do ponto'
  },
  shouldAuditedTotal: {
    zh: '应稽查总数',
    en: '',
    pu: 'Qtd. total de auditorias devidas'
  },
  physicalAuditTotal: {
    zh: '实际稽查总数',
    en: '',
    pu: 'Qtd. total de auditorias efectivas'
  },
  discrepancyTotal: {
    zh: '差异总数',
    en: '',
    pu: 'Total de discrepâncias'
  },
  auditedBagOrBill: {
    zh: '稽查袋号/单号',
    en: '',
    pu: 'Nº de Saca/Rastreio Auditado'
  },
  pocketParcelNumber: {
    zh: '袋内包裹单号',
    en: '',
    pu: 'Nº de rastreio dos pacotes na saca'
  },
  actualAuditScanNumber: {
    zh: '实际稽查扫描单号',
    en: '',
    pu: 'Nº de rastreio de auditorias efectivas'
  },
  checkScanningTime: {
    zh: '稽查扫描时间',
    en: '',
    pu: 'Hora da auditoria de bipagem'
  },
  driverLicenseAttachment: {
    zh: '驾照附件',
    en: '',
    pu: 'Anexo da carteira de motorista'
  },
  theParcelBagged: {
    zh: '该包裹已封袋',
    en: '',
    pu: ' O pacote já foi vinculado a um lacre.'
  },
  ScanNumber1: {
    zh: '单号',
    en: '',
    pu: 'Número de pedido'
  },
  shouldSignedGrossAmount: {
    zh: '应签收总量',
    en: '',
    pu: 'Total Estimado de Entregas'
  },
  actualSignGrossAmount: {
    zh: '实际签收总量',
    en: '',
    pu: 'Total Real de Entregas'
  },
  unsignedGrossAmount: {
    zh: '未签收总量',
    en: '',
    pu: 'Total de Entregas Não Realizadas'
  },
  glpUnloadTotal: {
    zh: 'GLP未卸车总量',
    en: '',
    pu: 'Qtd. de não descarregado em GLP'
  },
  today: {
    zh: '当日',
    en: '',
    pu: 'No Dia'
  },
  sameDay: {
    zh: '当天',
    en: '',
    pu: 'No dia'
  },
  nearlyAWeek: {
    zh: '近一周',
    en: '',
    pu: 'Última semana'
  },
  aboutAMonth: {
    zh: '近一月',
    en: '',
    pu: 'Último mês'
  },
  sameMonth: {
    zh: '当月',
    en: '',
    pu: 'No mês'
  },
  mdRetention: {
    zh: 'MD滞留量',
    en: '',
    pu: 'Qtd. de Retenção MD'
  },
  mdLanshou: {
    zh: 'MD揽收量',
    en: '',
    pu: 'Volume de Coleta de MD'
  },
  spmdRetention: {
    zh: 'SP-MD滞留量',
    en: '',
    pu: 'Qtd. de Retenção SP-MD'
  },
  francamdRetention: {
    zh: 'Franca-MD滞留量',
    en: '',
    pu: 'Qtd. de Retenção Franca-MD'
  },
  jaumdRetention: {
    zh: 'Jau-MD滞留量',
    en: '',
    pu: 'Qtd. de Retenção Jaú-MD'
  },
  rjmdRetention: {
    zh: 'RJ-MD滞留量',
    en: '',
    pu: 'Qtd. de Retenção RJ-MD'
  },
  mgmdRetention: {
    zh: 'MG-MD滞留量',
    en: '',
    pu: 'Qtd. de Retenção MG-MD'
  },
  mdToxxx: {
    zh: 'MD至***转运中',
    en: '',
    pu: 'MD para *** em Trânsito'
  },
  mdToSpzh005: {
    zh: 'MD至SP-Z-H005',
    en: '',
    pu: 'MD para SP-Z-H005'
  },
  mdToSpzh006: {
    zh: 'MD至SP-Z-H006',
    en: '',
    pu: 'MD para SP-Z-H006'
  },
  mdToSpzh002: {
    zh: 'MD至SP-Z-H-002',
    en: '',
    pu: 'MD para SP-Z-H002'
  },
  mdToSpzh004: {
    zh: 'MD至SP-Z-H004',
    en: '',
    pu: 'MD para SP-Z-H004'
  },
  mdToMgzh001: {
    zh: 'MD至MG-Z-H001',
    en: '',
    pu: 'MD para MG-Z-H001'
  },
  mdToRjwh001: {
    zh: 'MD至RJ-W-H001',
    en: '',
    pu: 'MD para RJ-W-H001'
  },
  arrivexxx: {
    zh: '到达***转运中心',
    en: '',
    pu: 'Chegada no Centro de Transferência ***'
  },
  packageDetail: {
    zh: '包裹明细',
    en: '',
    pu: 'Detalhes do Pacote'
  },
  arriveSpzh005: {
    zh: '到达SP-Z-H005转运中心',
    en: '',
    pu: 'Chegada no Centro de Transferência SP-Z-H005'
  },
  arriveSpzh006: {
    zh: '到达SP-Z-H006转运中心',
    en: '',
    pu: 'Chegada no Centro de Transferência SP-Z-H006'
  },
  arriveSpzh002: {
    zh: '到达SP-Z-H002转运中心',
    en: '',
    pu: 'Chegada no Centro de Transferência SP-Z-H002'
  },
  arriveSpzh004: {
    zh: '到达SP-Z-H004转运中心',
    en: '',
    pu: 'Chegada no Centro de Transferência SP-Z-H004'
  },
  arriveMgzh001: {
    zh: '到达MG-Z-H001转运中心',
    en: '',
    pu: 'Chegada no Centro de Transferência MG-Z-H001'
  },
  arriveRjwh001: {
    zh: '到达RJ-W-H001转运中心',
    en: '',
    pu: 'Chegada no Centro de Transferência RJ-W-H001'
  },
  xxxToWrglp01: {
    zh: '****至WR-GLP-01',
    en: '',
    pu: '**** para WR-GLP-01'
  },
  spzh005ToWrglp01: {
    zh: 'SP-Z-H005至WR-GLP-01',
    en: '',
    pu: 'SP-Z-H005 para WR-GLP-01'
  },
  spzh006ToWrglp01: {
    zh: 'SP-Z-H006至WR-GLP-01',
    en: '',
    pu: 'SP-Z-H006 para WR-GLP-01'
  },
  spzh004ToWrglp01: {
    zh: 'SP-Z-H004至WR-GLP-01',
    en: '',
    pu: 'SP-Z-H004 para WR-GLP-01'
  },
  spzh002ToWrglp01: {
    zh: 'SP-Z-H002至WR-GLP-01',
    en: '',
    pu: 'SP-Z-H002 para WR-GLP-01'
  },
  mgzh001ToWrglp01: {
    zh: 'MG-Z-H001至WR-GLP-01',
    en: '',
    pu: 'MG-Z-H001 para WR-GLP-01'
  },
  rjwh001ToWrglp01: {
    zh: 'RJ-W-H001至WR-GLP-01',
    en: '',
    pu: 'RJ-W-H001 para WR-GLP-01'
  },
  dataVisual: {
    zh: '安骏营运看板数据可视化',
    en: '',
    pu: 'Visualização de dados do painel de operações da Anjun'
  },
  signConditionView: {
    zh: '签收情况概览',
    en: '',
    pu: 'Visão geral da situação de entrega'
  },
  unsignEachLinkdetail: {
    zh: '未签收各环节明细',
    en: '',
    pu: 'Detalhes de não entrega em cada etapa'
  },
  MDScanVolume: {
    zh: 'MD扫描总量',
    en: '',
    pu: 'Qtd. total de bipagem em MD'
  },
  loadCapacity: {
    zh: '已装车量',
    en: '',
    pu: 'Qtd. já carregado'
  },
  stayTruckload: {
    zh: '待装车量',
    en: '',
    pu: 'Qtd. a ser carregado'
  },
  loadingRate: {
    zh: '装车率',
    en: '',
    pu: 'Taxa de carregamento'
  },
  stayLoadRate: {
    zh: '待装车率',
    en: '',
    pu: 'Taxa de qtd. a ser carregado'
  },
  MDName: {
    zh: 'MD名称',
    en: '',
    pu: 'Nome do MD'
  },
  predictTruckload: {
    zh: '预计装车量',
    en: '',
    pu: 'Qtd. estimada de carregamento'
  },
  loadedScansNumber: {
    zh: '已装车扫描量',
    en: '',
    pu: 'Qtd. já bipada no carregamento'
  },
  loadingScanRate: {
    zh: '装车扫描率',
    en: '',
    pu: 'Taxa de bipagem no carregamento'
  },
  retention: {
    zh: '滞留',
    en: '',
    pu: 'Retenção'
  },
  signedUnloadedDiffPackages: {
    zh: '签收与卸车差异包裹总数',
    en: '',
    pu: 'Diferença no total de pacotes entre descarregamento e assinatura'
  },
  closedSignedDiffPackages: {
    zh: '闭环与签收差异包裹总数',
    en: '',
    pu: 'Diferença no total de pacotes entre o ciclo fechado e a assinatura'
  },
  unloadedParcelsTotalNum: {
    zh: '卸车包裹总数',
    en: '',
    pu: 'Total de pacotes descarregados'
  },
  loadingInfo: {
    zh: '装车信息统计列表',
    en: '',
    pu: 'Lista de estatísticas de informações de carregamento'
  },
  baggingInfo: {
    zh: '装袋信息统计列表',
    en: '',
    pu: 'Lista de estatísticas de informações de bipagem'
  },
  bagInfo: {
    zh: '袋子详细信息列表',
    en: '',
    pu: 'Lista de informações detalhadas das sacas'
  },
  SuspectedLostPackage: {
    zh: '包裹疑似丢失',
    en: 'Suspected lost package',
    pu: 'Pacote possivelmente perdido'
  },
  CollectionPunctualityRate: {
    zh: '揽收准时率',
    en: 'Collection punctuality rate',
    pu: 'Taxa de coleta pontual'
  },
  NationalPunctualityRate: {
    zh: '全国准时率',
    en: 'National punctuality rate',
    pu: 'Taxa de pontualidade nacional'
  },
  SPPunctualityRate: {
    zh: 'SP准时率',
    en: 'SP punctuality rate',
    pu: 'Taxa de pontualidade SP'
  },
  FrancaPunctualityRate: {
    zh: 'Franca准时率',
    en: 'Franca punctuality rate',
    pu: 'Taxa de pontualidade Franca'
  },
  JauPunctualityRate: {
    zh: 'Jau准时率',
    en: 'Jau punctuality rate',
    pu: 'Taxa de pontualidade Jau'
  },
  MGPunctualityRate: {
    zh: 'MG准时率',
    en: 'MG punctuality rate',
    pu: 'Taxa de pontualidade MG'
  },
  RJPunctualityRate: {
    zh: 'RJ准时率',
    en: 'RJ punctuality rate',
    pu: 'Taxa de pontualidade RJ'
  },
  TotalCollectionPackages: {
    zh: '揽收包裹总数',
    en: 'Total collection packages',
    pu: 'Total de pacotes coletados'
  },
  TotalPackagesLoadedBranch: {
    zh: '网点装车包裹总数',
    en: 'Total packages loaded at the branch',
    pu: 'Total de pacotes carregados no ponto'
  },
  TotalUnloadedParcelsTransferCenter: {
    zh: '转运中心卸车包裹总数',
    en: 'Total unloaded parcels at the transfer center',
    pu: 'Total de pacotes descarregados no centro de transferência'
  },
  TotalPackagesLoadedTransferCenter: {
    zh: '转运中心装车包裹总数',
    en: 'Total packages loaded at the transfer center',
    pu: 'Total de pacotes carregados no centro de transferência'
  },
  TotalUnloadedParcelsDestinationWarehouse: {
    zh: '揽收目的仓卸车包裹总数',
    en: 'Total unloaded parcels at the destination warehouse',
    pu: 'Total de pacotes descarregados no armazém de destino de coleta'
  },
  TotalSignedParcelsDestinationWarehouse: {
    zh: '目的仓签收包裹总数',
    en: 'Total signed parcels at the destination warehouse',
    pu: 'Total de pacotes recebidos no armazém de destino'
  },
  TotalClosedPackages: {
    zh: '闭环包裹总数',
    en: 'Total closed packages',
    pu: 'Níumero total de pacotes fechados'
  },
  SecondarySummary: {
    zh: '二级汇总',
    en: 'Secondary summary',
    pu: 'Resumo de segundo nível'
  },
  SecondarySummaryDetail: {
    zh: '二级汇总明细',
    en: 'Secondary summary detail',
    pu: 'Detalhes do resumo de segundo nível'
  },
  TotalCollected: {
    zh: '已揽收总量',
    en: 'Total collected',
    pu: 'Total coletado'
  },
  TotalSealedBags: {
    zh: '已封袋总量',
    en: 'Total sealed bags',
    pu: 'Total selado'
  },
  TotalLoadedBranch: {
    zh: '网点装车总量',
    en: 'Total loaded at the branch',
    pu: 'Total carregado no ponto'
  },
  TotalUnloadedTransferCenter: {
    zh: '转运中心卸车总数',
    en: 'Total unloaded at the transfer center',
    pu: 'Total descarregado no centro de transferência'
  },
  TotalLoadedTransferCenter: {
    zh: '转运中心装车总数',
    en: 'Total loaded at the transfer center',
    pu: 'Total carregado no centro de transferência'
  },
  TotalSigned: {
    zh: '已签收总量',
    en: 'Total signed',
    pu: 'Total recebido'
  },
  BranchLoadingLicensePlate: {
    zh: '网点装车车牌',
    en: 'Branch loading license plate',
    pu: 'Placa do veículo carregado no ponto'
  },
  LoadingTransferCenter: {
    zh: '装车转运中心',
    en: 'Loading transfer center',
    pu: 'Centro de transferência de carregamento'
  },
  UnloadingTransferCenter: {
    zh: '卸车转运中心',
    en: 'Unloading transfer center',
    pu: 'Centro de transferência de descarregamento'
  },
  longitudeInputError: {
    // 经度
    zh: '格式：[-180 ,180] 最多小数点后7位',
    en: '',
    pu: 'Formato: [-180,180] com até 7 casas decimais'
  },
  latitudeInputError: {
    // 纬度
    zh: '格式：[-90,90] 最多小数点后7位',
    en: '',
    pu: 'Formato: [-90,90] com até 7 casas decimais'
  },
  SummarySuspectedLostPackageLinks: {
    zh: '疑似丢失包裹环节汇总',
    en: 'Summary of suspected lost package links',
    pu: 'Resumo de Etapas de Suspeita de Pacotes Perdidos'
  },
  SuspectedLostPackageDetails: {
    zh: '疑似丢失包裹明细',
    en: 'Suspected lost package details',
    pu: 'Detalhes de Pacotes Suspeitos de Estarem Perdidos'
  },
  SummaryExport: {
    zh: '汇总导出',
    en: 'Summary export',
    pu: 'Resumo da exportação'
  },
  AnjunTrackingNumber: {
    zh: '安骏单号',
    en: 'Anjun tracking number',
    pu: 'Número de localização Anjun'
  },
  yesterday: {
    zh: '昨日',
    en: '',
    pu: 'Ontem'
  },
  smallCollect: {
    zh: '小件揽收',
    en: '',
    pu: 'Coleta de Pequenos Pacotes'
  },
  smallDelivery: {
    zh: '小件派送',
    en: '',
    pu: 'Pacote comum'
  },
  largeDelivery: {
    zh: '大件派送',
    en: '',
    pu: 'Pacotes grandes'
  },
  smallCollectRange: {
    zh: '小件揽收范围',
    en: '',
    pu: 'Área de Coleta de Pequenos Pacotes'
  },
  smallDeliveryRange: {
    zh: '小件派送范围',
    en: '',
    pu: 'Área de Entrega de Pequenos Pacotes'
  },
  largeDeliveryRange: {
    zh: '大件派送范围',
    en: '',
    pu: 'Área de Entrega de Volumes Grandes'
  },
  collector: {
    zh: '揽收员',
    en: '',
    pu: 'Coletador'
  },
  collectingLoadingRecords: {
    zh: '揽收装车记录',
    en: '',
    pu: 'Registro de Carregamento de Coleta'
  },
  ji: {
    // 寄
    zh: '寄',
    en: '',
    pu: 'Enviar'
  },
  shou: {
    zh: '收',
    en: '',
    pu: 'Receber'
  },
  TimeOfArrivalAtGLP: {
    zh: '到达GLP时间',
    en: 'Time of arrival at GLP',
    pu: 'Hora de chega em GLP'
  },
  unloadedVehicleDetailsGLP: {
    zh: 'GLP未卸车车维度明细',
    en: 'GLP unloaded vehicle dimension details',
    pu: 'Detalhes de veículo não descarregado em GLP'
  },
  unloadedParcelDimensionGLP: {
    zh: 'GLP未卸车包裹维度明细',
    en: 'GLP unloaded parcel dimension details',
    pu: 'Detalhes de pacote não descarregado em GLP'
  },
  unloadedBagDimensionGLP: {
    zh: 'GLP未卸车袋维度明细',
    en: 'GLP unloaded bag dimension details',
    pu: 'Detalhes de saca não descarregada em GLP'
  },
  greaterThanAddresseeDistance: {
    zh: '与收件人距离   大于',
    en: '',
    pu: 'Distância até o Destinatário    Maior que'
  },
  lessThanAddresseeDistance: {
    zh: '与收件人距离   小于',
    en: '',
    pu: 'Distância até o Destinatário    Menor que'
  },
  SigningTimeoutTotal: {
    zh: '目的仓签收超时包裹总数',
    en: 'Total number of overdue parcels signed for at destination warehouse',
    pu: 'Número total de encomendas em atraso assinadas no armazém de destino'
  },
  SecondUnloadingTime: {
    zh: '第二次卸车时间',
    en: 'Second unloading time',
    pu: 'Segundo tempo de descarga'
  },
  TransportationArrivalHours: {
    zh: '运抵操作时长(小时)',
    en: 'Transportation arrival operation hours (hours)',
    pu: 'Duração da operação de chegada do transporte (horas)'
  },
  merchantCode: {
    zh: '商户号',
    en: '',
    pu: 'Número do comerciante'
  },
  beforeYesterday: {
    zh: '前天',
    en: 'the day before yesterday',
    pu: 'anteontem'
  },
  allParcel: {
    zh: '全部包裹',
    en: '',
    pu: 'Todos os Pacotes'
  },
  partialPackage: {
    zh: '部分包裹',
    en: '',
    pu: 'Alguns Pacotes'
  },
  MDLink: {
    zh: 'MD环节',
    en: '',
    pu: 'Mini Drop'
  },
  MDToTransitCenter: {
    zh: 'MD至转运中心',
    en: '',
    pu: 'MD ao Centro de Transferência'
  },
  loadTotal: {
    zh: '装车总量',
    en: '',
    pu: 'Qtd. de Carregamento'
  },
  transitCenterAnomaly: {
    zh: '转运中心异常',
    en: '',
    pu: 'Detalhes de anomalia de transferência'
  },
  transferCenterToGLP: {
    zh: '***转运中心发往GLP',
    en: '',
    pu: 'de *** ao GLP'
  },
  GLPUnloadingProcess: {
    zh: 'GLP卸车环节',
    en: '',
    pu: 'Descarregamento em GLP'
  },
  shouldArrivedGLPTotal: {
    zh: '应到达GLP总量',
    en: '',
    pu: 'Qtd. de chegada prevista'
  },
  actuallyArrivedGLPTotal: {
    zh: '实际到达GLP总量',
    en: '',
    pu: 'Qtd. de chegada real'
  },
  handoverToSHEIN: {
    zh: '与SHEIN交接',
    en: '',
    pu: 'Recebimento de  SHEIN'
  },
  abnormalParcelsTotal: {
    zh: '异常包裹总数',
    en: '',
    pu: 'Qtd. de anomalia'
  },
  auditLink: {
    zh: '稽查环节',
    en: '',
    pu: 'Inspeção'
  },
  actualCheckedBagsNum: {
    zh: '实际稽查袋数',
    en: '',
    pu: 'Qtd. de saca inspecionado real'
  },
  abnormalBagNum: {
    zh: '异常袋数',
    en: '',
    pu: 'Qtd. de saca anormal'
  },
  actualAuditVotes: {
    zh: '实际稽查票数',
    en: '',
    pu: 'Qtd. de pacote inspecionado real'
  },
  abnormalTotalVotes: {
    zh: '异常总票数',
    en: '',
    pu: 'Qtd. de pacote anormal'
  },
  anomalyRate: {
    zh: '异常率',
    en: '',
    pu: 'Taxa de anomalia'
  },
  MDRangeTotal: {
    zh: 'MD揽收总量',
    en: '',
    pu: 'Qtd. de Coleta'
  },
  MDRetention: {
    zh: 'MD滞留总量',
    en: '',
    pu: 'Qtd. de Pendência'
  },
  actualUnloadedTotal: {
    zh: '实际卸车总量',
    en: '',
    pu: 'Qtd. de Descarregamento'
  },
  actualLoadingTotal: {
    zh: '实际装车总量',
    en: '',
    pu: 'Qtd. de Carregamento'
  },
  wholeCountry: {
    zh: '全国',
    en: '',
    pu: 'Nacional'
  },
  inspectBag: {
    zh: '稽查袋号',
    en: '',
    pu: 'Nº de Saca'
  },
  ScanNumber: {
    zh: '扫描单号',
    en: '',
    pu: 'Código de barra'
  },
  actualBag: {
    zh: '实际袋号',
    en: '',
    pu: 'Número real da bolsa'
  },
  parcelOddNumber: {
    zh: '包裹单号',
    en: '',
    pu: 'número da parcela'
  },
  local: {
    zh: '本地',
    en: 'local',
    pu: 'Local'
  },
  crossBorder: {
    zh: '跨境',
    en: 'cross-border',
    pu: 'Transfronteiriça'
  },
  BrazilianLocalCustomer: {
    zh: '巴西本地客户',
    en: 'Brazilian local customer',
    pu: 'Cliente local brasileiro'
  },
  serviceProviderTrailDescription: {
    zh: '服务商轨迹描述',
    en: '',
    pu: 'Descrição de rastreamento do transportador'
  },
  trajectoryStatusCode: {
    zh: '轨迹状态码',
    en: '',
    pu: 'Código de estado de rastreamento'
  },
  uploadFileFormat1: {
    zh: '上传文件支持xls、xlsx等格式',
    en: '',
    pu: 'A transferência de arquivos suporta formatos como xls, xlsx entre outros.'
  },
  matchExpressWaybillStatus: {
    zh: '匹配快递运单状态',
    en: '',
    pu: 'Correspondência do status do conhecimento de transporte do correio'
  },
  matchOrNot: {
    zh: '是否匹配',
    en: '',
    pu: 'se corresponde ou não a'
  },
  batchMatching: {
    zh: '批量匹配',
    en: '',
    pu: 'Correspondência de lotes'
  },
  batchEdit: {
    zh: '批量修改',
    en: '',
    pu: 'modificação de lote'
  },
  matchingExpressDescription: {
    zh: '匹配快递描述',
    en: '',
    pu: 'Descrição do Match Courier'
  },
  matchDeliveryStatusCode: {
    zh: '匹配快递状态码',
    en: '',
    pu: 'Código de status do correio correspondente'
  },
  batchTrackMatching: {
    zh: '批量轨迹匹配',
    en: '',
    pu: 'Correspondência de trilhas em lote'
  },
  batchEditTrajectoryMatching: {
    zh: '批量修改轨迹匹配',
    en: '',
    pu: 'Modificar em lote a correspondência de trilhas'
  },
  // 'id为' + data1 + '的数据已经匹配，请重新操作'
  idis: {
    zh: 'id为',
    en: '',
    pu: 'Os dados com id'
  },
  dataMatchedPleaseTryAgain: {
    zh: '的数据已经匹配，请重新操作',
    en: '',
    pu: 'foram combinados, por favor, reabra a operação.'
  },
  filAlreadyMatchedData: {
    zh: '已过滤掉已匹配的数据',
    en: '',
    pu: 'Os dados correspondentes foram filtrados'
  },
  serviceProviderTrailCode: {
    zh: '服务商轨迹状态码',
    en: '',
    pu: 'Código de status de rastreamento do transportador'
  },
  serviceProviderName: {
    zh: '服务商名称',
    en: '',
    pu: 'Nome do transportador'
  },
  pleaseInputFuzzyQuery: {
    zh: '请输入或模糊查询',
    en: '',
    pu: 'Digite ou faça uma consulta difusa'
  },
  exactQuery: {
    zh: '精确查询',
    en: '',
    pu: 'Pesquisa precisa'
  },
  waybillStatusMatches: {
    zh: '运单状态匹配',
    en: '',
    pu: 'Correspondência do status do conhecimento de embarque'
  },
  pleaseFindOrSelectWaybillStatus: {
    zh: '请输入查找或选择快递运单状态',
    en: '',
    pu: 'Digite uma pesquisa ou selecione o status da carta de porte do correio'
  },
  idTip: {
    zh: 'id为',
    en: '',
    pu: 'Os dados com id '
  },
  idTip2: {
    zh: '的数据已经匹配，请重新操作',
    en: '',
    pu: ' foram combinados, reabra a operação'
  },
  matchExpressSubState: {
    zh: '匹配快递子状态',
    en: '',
    pu: 'Correspondência de subestados expressos'
  },
  eachRegionMD: {
    zh: '各区域MD揽收情况分布',
    en: '',
    pu: 'Distribuição da coleta MD em cada região'
  },
  MDSendTo: {
    zh: 'MD发往各转运中心情况分布',
    en: '',
    pu: 'Distribuição do envio de MD para os centros de transferência'
  },
  arriveTransitCenters: {
    zh: '到达各转运中心情况分布',
    en: '',
    pu: 'Distribuição da chegada aos centros de transferência'
  },
  SendToGLP: {
    zh: '各区域发往GLP情况分布',
    en: '',
    pu: 'Distribuição do envio de cada região para o GLP'
  },
  collectLoading: {
    zh: '揽收装车',
    en: '',
    pu: 'Carregamento de coleta'
  },
  deliveryLoading: {
    zh: '派送装车',
    en: '',
    pu: 'Carregamento de entrega'
  },
  networkProblemRgtTotal: {
    zh: '网点问题件登记统计',
    en: '',
    pu: 'Registro e Estatísticas de Pacotes com Problemas na Agência'
  },
  quantityUnit: {
    zh: '数量单位：票',
    en: '',
    pu: 'Unidade de Contagem: Pacote'
  },
  endTakeUp: {
    zh: '末端揽收',
    en: '',
    pu: 'Coleta no LM'
  },
  receivable: {
    zh: '应揽收',
    en: '',
    pu: 'Pacotes previstos para coleta'
  },
  actualCollection: {
    zh: '实际揽收',
    en: '',
    pu: 'Pacotes efetivamente coletados'
  },
  shouldLoading: {
    zh: '应装车',
    en: '',
    pu: 'Pacotes previstos para carregamento'
  },
  actualLoading: {
    zh: '实际装车',
    en: '',
    pu: 'Pacotes efetivamente carregados'
  },
  differenceValue: {
    zh: '差值',
    en: '',
    pu: 'Diferença'
  },
  firstLevelSortingCenter: {
    zh: '一级分拣中心',
    en: '',
    pu: 'Centro de Triagem Nível 1'
  },
  suspectedMissedSweep: {
    zh: '疑似到件漏扫',
    en: '',
    pu: 'Possível falha de escaneamento na entrada'
  },
  secondThirdSortingCenters: {
    zh: '二三级分拣中心',
    en: '',
    pu: 'Centro de Triagem Nível 2/3'
  },
  suspectedUnloadingMissingSweep: {
    zh: '疑似卸车漏扫',
    en: '',
    pu: 'Possível falha de escaneamento no descarregamento'
  },
  nodeOperationData: {
    zh: '网点操作数据',
    en: '',
    pu: 'Dados Operacionais da base'
  },
  networkEntry: {
    zh: '网点入库',
    en: '',
    pu: 'Entrada na base'
  },
  D2DOrder: {
    zh: 'D2D订单',
    en: '',
    pu: 'Pedidos D2D'
  },
  uploadFileFormatJPG: {
    zh: '上传文件支持JPG、JPEG、PNG格式',
    en: '',
    pu: 'A transferência de arquivos suporta formatos como JPG、JPEG、PNG, entre outros.'
  },
  copySmallwareRange: {
    zh: '复制小件派送范围',
    en: '',
    pu: 'Copiar o intervalo de entrega para itens pequenos'
  },
  returnWaybillNumber: {
    zh: '退件运单号',
    en: 'Return Waybill Number',
    pu: 'Número da nota de devolução'
  },
  scanOrderNumbers: {
    zh: '扫描单号',
    en: 'Scan Order Number',
    pu: 'Número do pedido de digitalização'
  },
  originalWaybillNumber: {
    zh: '原始运单号',
    en: 'Original Waybill Number',
    pu: 'Número original da nota'
  },
  returnOrderNumber: {
    zh: '退件单订单号',
    en: 'Return Order Number',
    pu: 'Número do pedido de devolução'
  },
  forwardScanOrderNumber: {
    zh: '原始扫描单号',
    en: 'Original Scan Order Number',
    pu: 'Número do pedido de varredura original'
  },
  orderPlacementResult: {
    zh: '下单结果',
    en: 'Order Placement Result',
    pu: 'Resultado da criação do pedido'
  },
  latestReturnTrack: {
    zh: '退件单最新轨迹',
    en: 'Latest Return Track',
    pu: 'Última trajetória de devolução'
  },
  InitiateRejection: {
    zh: '发起退件',
    en: '',
    pu: 'Início das devoluções'
  },
  initiateReturnTotal: {
    zh: '发起退件总数',
    en: '',
    pu: 'Número total de devoluções iniciadas'
  },
  orderSuccessful: {
    zh: '退件单下单成功',
    en: '',
    pu: 'Pedido de devolução feito com sucesso'
  },
  orderFailure: {
    zh: '退件单下单失败',
    en: '',
    pu: 'Falha ao fazer um pedido de devolução'
  },
  orderFailedOrder: {
    zh: '下单失败单号',
    en: '',
    pu: 'Número do pedido com falha'
  },
  reason: {
    zh: '原因',
    en: '',
    pu: 'razão'
  },
  order: {
    zh: '单号',
    en: '',
    pu: 'Número de pedido'
  },
  relatedWaybillNumber: {
    zh: '关联运单号',
    en: 'Related Waybill Number',
    pu: 'Número da nota fiscal relacionado'
  },
  forwardOrder: {
    zh: '正向订单',
    en: 'Forward Order',
    pu: 'Pedido direto'
  },
  reverseOrder: {
    zh: '逆向订单',
    en: 'Reverse Order',
    pu: 'Pedido reverso'
  },
  returnNote: {
    zh: '退件单',
    en: 'Return Note',
    pu: 'Nota de Devolução'
  },
  selectWaybill: {
    zh: '请选择需要打印的运单号',
    en: 'Please select the waybill number to print',
    pu: 'Por favor, selecione o número da etiqueta para imprimir'
  },
  originalWaybill: {
    zh: '原单号',
    en: 'Original Waybill Number',
    pu: 'Número Original da Etiqueta'
  },
  returnNoteNum: {
    zh: '退件单号',
    en: 'Return Note Number',
    pu: 'Número da Nota de Devolução'
  },
  destination: {
    zh: '目的地',
    en: 'Destination',
    pu: 'Destino'
  },
  totalPackagesInBag: {
    zh: '袋内包裹总数',
    en: 'Total number of packages in the bag',
    pu: 'Número total de pacotes na sacola'
  },
  RemainingNumberRegistrations: {
    zh: '剩余可登记数量',
    en: 'Remaining number of registrations',
    pu: 'Número de registro restante'
  },
  SelectedBranch: {
    zh: '已选网点',
    en: 'Selected Branch',
    pu: 'Filial selecionada'
  },
  voucherDetails: {
    zh: '凭证详情',
    en: 'Voucher Details',
    pu: 'Detalhes do voucher'
  },
  problemItem: {
    zh: '问题件在退件前必须要派送登记的次数',
    en: 'The number of registrations required before sending the problem item',
    pu: 'Número de registro necessário antes de enviar o item com problema'
  },
  SelectUpTo10PiecesOfData: {
    zh: '选中的数据中可以撤回的数据不能超过10条',
    en: 'The number of revocable data in the selected data cannot exceed 10',
    pu: 'Os dados selecionados não podem ser retirados mais de 10'
  },
  PleaseSelectDataThatCanBeRecalled: {
    zh: '请选择可以撤回的数据',
    en: 'Please select data that can be recalled',
    pu: 'Selecione os dados que podem ser retirados'
  },
  WithdrawalInProgress: {
    zh: '撤回中',
    en: 'Withdrawal in progress',
    pu: 'Retirada em andamento'
  },
  CannotExportDataWithPaymentStatusAsRevoked: {
    zh: '不能导出付款状态为撤回中的数据',
    en: 'Cannot export data with payment status as revoked',
    pu: 'Não é possível exportar o estado do pagamento como dados em retirada'
  },
  AgreementName: {
    zh: '协议名称',
    en: 'Agreement name',
    pu: 'Nome do acordo'
  },
  userClicksTime: {
    zh: '用户点击确认的时间',
    en: 'The time when the user clicks the confirmation',
    pu: 'O tempo em que o usuário clica no confirmação'
  },
  ArrivalTimeAtHUB: {
    zh: '到达HUB时间',
    en: 'Arrival Time at HUB',
    pu: 'Tempo de chegada ao HUB'
  },
  AddCollectionTime: {
    zh: '添加揽收时间',
    en: 'Add Collection Time',
    pu: 'Adicionar tempo de coleta'
  },
  ArrivalTimeAtTransferCenter: {
    zh: '到达转运中心时间',
    en: 'Arrival Time at Transfer Center',
    pu: 'Tempo de chegada ao centro de transferência'
  },
  ArrivalAtTransferCenter: {
    zh: '到达转运中心',
    en: 'Arrival at Transfer Center',
    pu: 'Chegada ao centro de transferência'
  },
  orderNumberWithTotal: {
    zh: '安骏订单号（总件数）',
    en: 'Anjun Order No. (Total Items)',
    pu: 'Número do Pedido Anjun (Total de Itens)'
  },
  transitWeight: {
    zh: '中转称重(kg)',
    en: 'Transit Weighing (kg)',
    pu: 'Pesagem de Trânsito (kg)'
  },
  orderWeightKG: {
    zh: '下单重量(kg)',
    en: 'Order Weight (kg)',
    pu: 'Peso do Pedido (kg)'
  },
  weightDifference: {
    zh: '重量差异',
    en: 'Weight Difference',
    pu: 'Diferença de Peso'
  },
  calculationRule: {
    zh: '计算规则:(中转称重-下单重量)/下单重量，百分比取绝对值',
    en: 'Calculation Rule: (Transit Weight - Order Weight)/Order Weight, take absolute value as percentage',
    pu: 'Regra de cálculo: (Peso de Trânsito - Peso do Pedido)/Peso do Pedido, considerar valor absoluto como porcentagem'
  },
  weightComparisonRule: {
    zh: '如果中转称重 > 下单重量，则使用符号↑，且大于等于3%则标记红色',
    en: 'If transit weight > order weight, use symbol ↑, and mark in red if the difference is ≥3%',
    pu: 'Se peso de trânsito > peso do pedido, use símbolo ↑, e marque em vermelho se a diferença for ≥3%'
  },
  weightComparisonRule2: {
    zh: '如果中转称重 < 下单重量，则使用符号↓',
    en: 'If transit weight < order weight, use symbol ↓',
    pu: 'Se peso de trânsito < peso do pedido, use símbolo ↓'
  },
  transitMeasurement: {
    zh: '中转测量体积(m³)',
    en: 'Transit Measurement Volume (m³)',
    pu: 'Volume de Medição de Trânsito (m³)'
  },
  volumeWeight: {
    zh: '体积重(kg)',
    en: 'Volumetric Weight (kg)',
    pu: 'Peso Volumétrico (kg)'
  },
  orderVolume: {
    zh: '下单体积(m³)',
    en: 'Order Volume (m³)',
    pu: 'Volume do Pedido (m³)'
  },
  volumeDifference: {
    zh: '体积差异',
    en: 'Volume Difference',
    pu: 'Diferença de Volume'
  },
  volumeCalculationRule: {
    zh: '计算规则:(中转测量体积-下单体积)/下单体积，百分比取绝对值',
    en: 'Calculation Rule: (Transit Measurement Volume - Order Volume)/Order Volume, take absolute value as percentage',
    pu: 'Regra de cálculo: (Volume de Medição de Trânsito - Volume do Pedido)/Volume do Pedido, considerar valor absoluto como porcentagem'
  },
  volumeComparisonWarning: {
    zh: '如果中转测量体积 > 下单体积，则使用符号↑，且大于等于3%则标记红色',
    en: 'If the transit measured volume > order volume, use the ↑ symbol, and mark it in red if ≥3%',
    pu: 'Se o volume medido em trânsito > volume do pedido, use o símbolo ↑ e marque em vermelho se ≥3%'
  },
  volumeDecreaseWarning: {
    zh: '如果中转测量体积 < 下单体积，则使用符号↓',
    en: 'If the transit measured volume < order volume, use the ↓ symbol',
    pu: 'Se o volume medido em trânsito < volume do pedido, use o símbolo ↓'
  },
  MerchantDataDisplay: {
    zh: '商家数据展示',
    en: 'Merchant data display',
    pu: 'Exibição de dados do comércio'
  },
  CollectionLink: {
    zh: '揽收环节',
    en: 'Collection Link',
    pu: 'Link de coleta'
  },
  SigningLink: {
    zh: '签收环节',
    en: 'Signing Link',
    pu: 'Link de assinatura'
  },
  TotalNumberOfMerchantsToBeCollected: {
    zh: '应揽收商家总数',
    en: 'Total number of merchants to be collected',
    pu: 'Número total de comércios a serem coletados'
  },
  TotalNumberOfMerchantsCompleted: {
    zh: '已完成商家总数',
    en: 'Total number of merchants completed',
    pu: 'Número total de comércios concluídos'
  },
  TotalNumberOfMerchantsNotCollected: {
    zh: '未揽收商家总数',
    en: 'Total number of merchants not collected',
    pu: 'Número total de comércios não coletados'
  },
  CollectionRate: {
    zh: '揽收率',
    en: 'Collection Rate',
    pu: 'Taxa de coleta'
  },
  KPIReached: {
    zh: 'KPI达成',
    en: 'KPI reached',
    pu: 'KPI alcançado'
  },
  CollectionTime: {
    zh: '揽收时效',
    en: 'Collection Time',
    pu: 'Tempo de coleta'
  },
  SaoPauloCityMetropolitanArea: {
    zh: '圣保罗市/大都市区运抵时效',
    en: 'Delivery time to Sao Paulo city/metropolitan area',
    pu: 'Cidade de São Paulo / Área Metropolitana'
  },
  DeliveryTimeToSaoPauloCountryside: {
    zh: '圣保罗乡下运抵时效',
    en: 'Delivery time to Sao Paulo countryside',
    pu: 'Tempo de chegada rural de São Paulo'
  },
  DeliveryTimeToOutsideTheState: {
    zh: '外州运抵时效',
    en: 'Delivery time to outside the state',
    pu: 'Tempo de chegada para fora do estado'
  },
  TotalAmountToBeCollected: {
    zh: '应揽收总量',
    en: 'Total amount to be collected',
    pu: 'Total a receber'
  },
  TotalAmountCollected: {
    zh: '已揽收总量',
    en: 'Total amount collected',
    pu: 'Total recebido'
  },
  TotalAmountNotCollected: {
    zh: '未揽收总量',
    en: 'Total amount not collected',
    pu: 'Total não recebido'
  },
  TotalNumberOfExpectedSignatures: {
    zh: '应收签收总数',
    en: 'Total number of expected signatures',
    pu: 'Total de assinaturas esperadas'
  },
  TotalNumberOfSignatures: {
    zh: '已签收数量',
    en: 'Total number of signatures',
    pu: 'Total de assinaturas'
  },
  TotalNumberOfSignaturesNotCollected: {
    zh: '未签收数量',
    en: 'Total number of signatures not collected',
    pu: 'Total de assinaturas não recebidas'
  },
  actualDeliveryBranch: {
    zh: '实际派送网点',
    en: 'Actual delivery branch',
    pu: 'Ponto de entrega'
  },
  deliveryMan: {
    zh: '派送员',
    en: 'Delivery man',
    pu: 'Entregador'
  },
  originalOrder: {
    zh: '原单',
    en: 'Original order',
    pu: 'Pedido original'
  },
  originalOrderReturned: {
    zh: '原单退回',
    en: 'Original order returned',
    pu: 'Pedido original devolvido'
  },
  newOrderReturned: {
    zh: '新单退回',
    en: 'New order returned',
    pu: 'Novo pedido devolvido'
  },
  receiptDate: {
    zh: '签收日期',
    en: 'Receipt Date',
    pu: 'Data de Recebimento'
  },
  shipmentStatus: {
    zh: '运单状态',
    en: 'Shipment Status',
    pu: 'Status do Pacote'
  },
  pendingArrival: {
    zh: '有发未到',
    en: 'Pending arrival',
    pu: 'Aguardando chegada'
  },
  pendingShipment: {
    zh: '有到未发',
    en: 'Pending shipment',
    pu: 'Aguardando envio'
  },
  PleasePackAllTheLargeParcelsSameRecipientBeforeProceeding: {
    zh: '请将同一收件人的大件快递全部装齐再操作',
    en: 'Please pack all the large parcels of the same recipient before proceeding',
    pu: 'Por favor, coloque todos os grandes pacotes do mesmo destinatário.'
  },
  RemainingToBeInstalled: {
    zh: '剩余应装',
    en: 'Remaining to be installed',
    pu: 'Resto de equipamento'
  },
  PleaseUnloadAllLargeParcelsSameRecipientBeforeProceeding: {
    zh: '请将同一收件人的大件快递全部卸车后再操作',
    en: 'Please unload all large parcels of the same recipient before proceeding',
    pu: 'Por favor, despegue todos os grandes pacotes do mesmo destinatário.'
  },
  RemainingVehiclesToBeUnloaded: {
    zh: '剩余应卸车',
    en: 'Remaining vehicles to be unloaded',
    pu: 'O restante deve ser descarregado.'
  },
  regionNameZh: {
    zh: '大区名称—中文',
    en: 'Region Name - Chinese',
    pu: 'Nome da Região - Chinês'
  },
  regionNamePu: {
    zh: '大区名称—葡语',
    en: 'Region Name - Portuguese',
    pu: 'Nome da Região - Português'
  },
  governingState: {
    zh: '管辖州',
    en: 'Governing State',
    pu: 'Estado Governante'
  },
  governingTransferCenter: {
    zh: '管辖转运中心',
    en: 'Governing Transfer Center',
    pu: 'Centro de Transferência Governante'
  },
  governingServicePoint: {
    zh: '管辖网点',
    en: 'Governing Service Point',
    pu: 'Ponto de Serviço Governante'
  },
  addRegion: {
    zh: '新增大区',
    en: 'Add Region',
    pu: 'Adicionar Região'
  },
  operatorRegion: {
    zh: '操作人大区',
    en: '',
    pu: 'Região operacional'
  },
  actualStorageRegion: {
    zh: '实际入库大区',
    en: '',
    pu: 'Região operacional de entrada real'
  },
  expectedPickupTickets: {
    zh: '应揽收票数',
    en: 'Expected Pickup Tickets Count',
    pu: 'Quantidade de Tickets de Coleta Esperados'
  },
  postalCodeState: {
    zh: '邮编所属州',
    en: 'State of Postal Code',
    pu: 'Estado do Código Postal'
  },
  postalCodeCity: {
    zh: '邮编所属城市',
    en: 'City of Postal Code',
    pu: 'Cidade do Código Postal'
  },
  regionType: {
    zh: '区域类型',
    en: 'Region Type',
    pu: 'Tipo de Região'
  },
  urbanArea: {
    zh: '城区',
    en: 'Urban Area',
    pu: 'Área Urbana'
  },
  suburbanArea: {
    zh: '郊区',
    en: 'Suburban Area',
    pu: 'Área Suburbana'
  },
  postalCodeValidation: {
    zh: '起始邮编不能大于结束邮编，且邮编不允许重复！',
    en: 'The starting postal code cannot be greater than the ending postal code, and duplicate postal codes are not allowed!',
    pu: 'O CEP inicial não pode ser maior que o CEP final, e CEPs duplicados não são permitidos!'
  },
  keepAtLeastOneRow: {
    zh: '至少保留一行',
    en: 'Keep at least one row',
    pu: 'Mantenha pelo menos uma linha'
  },
  uploadPostalCodeFile: {
    zh: '上传邮编文件',
    en: 'Upload Postal Code File',
    pu: 'Carregar Arquivo de CEP'
  },
  importTemplateDownload: {
    zh: '导入模板下载',
    en: 'Download Import Template',
    pu: 'Baixar Modelo de Importação'
  },
  postalCodeTemplateDownload: {
    zh: '邮编模板下载',
    en: 'Postal Code Template Download',
    pu: 'Download de Modelo de CEP'
  },
  deliveryRegionType: {
    zh: '派送区域类型',
    en: 'Delivery Region Type',
    pu: 'Tipo de Região de Entrega'
  },
  fileUploadMessage: {
    zh: '请上传xlsx类型的文件',
    en: 'Please upload a file in xlsx format',
    pu: 'Por favor, envie um arquivo no formato xlsx'
  },
  // 第 ${i + 1} 行区域类型不能为空
  rowValidationError: {
    zh: '第{rowNumber}行区域类型不能为空',
    en: 'Row {rowNumber} area type cannot be empty',
    ptBr: 'O tipo de área da linha {rowNumber} não pode estar vazio'
  },
  rowValidationError1: {
    zh: '第',
    en: 'Row',
    pu: 'O tipo de área da linha'
  },
  rowValidationError2: {
    zh: '行区域类型不能为空',
    en: 'area type cannot be empty',
    pu: 'não pode estar vazio'
  },
  orderOverview: {
    zh: '订单总览',
    en: 'Order Overview',
    pu: 'Visão Geral de Pedidos'
  },
  waybillMonitoring: {
    zh: '运单监控',
    en: 'Waybill Monitoring',
    pu: 'Monitoramento de Conhecimento de Transporte'
  },
  totalOrders: {
    zh: '订单总量',
    en: 'Total Orders',
    pu: 'Total de Pedidos'
  },
  customerOrderCount: {
    zh: '下单客户数',
    en: 'Number of Ordering Customers',
    pu: 'Número de Clientes que Fizeram Pedidos'
  },
  positiveWaybillMonitoring: {
    zh: '正向在途运单监控',
    en: 'In-Transit Waybill Monitoring (Positive)',
    pu: 'Monitoramento de Conhecimentos de Transporte em Trânsito (Positivo)'
  },
  checkFormFields: {
    zh: '请检查表单内容',
    en: 'Please check your form entries',
    pu: 'Por favor verifique os campos do formulário'
  },
  fileReadFailed: {
    zh: '文件读取失败',
    en: 'File read failed',
    pu: 'Falha na leitura do arquivo'
  },
  noParsableDataInFile: {
    zh: '文件中没有可解析的数据',
    en: 'No parsable data in the file',
    pu: 'Não há dados analisáveis no arquivo'
  },
  emptyDataParsed: {
    zh: '解析到空数据，请检查文件内容是否符合模板',
    en: 'Parsed empty data, please check if the file content matches the template',
    pu: 'Dados vazios analisados, verifique se o conteúdo do arquivo corresponde ao modelo'
  },
  tips1: {
    zh: '第 ',
    en: 'Row ',
    pu: 'A linha '
  },
  tips1_1: {
    zh: ' 行存在空字段，请检查数据完整性',
    en: ' has empty fields. Please check data integrity.',
    pu: ' possui campos vazios. Por favor, verifique a integridade dos dados.'
  },
  tip2: {
    zh: ' 行邮编格式错误，需为8位纯数字',
    en: ' has invalid zip code format. It must be 8 digits.',
    pu: ' possui CEP inválido. Deve conter 8 dígitos numéricos.'
  },
  tip3: {
    zh: ' 行起始邮编不能大于结束邮编',
    en: ' Start zip code cannot be greater than end zip code',
    pu: ' O CEP inicial não pode ser maior que o CEP final'
  },
  tip4: {
    zh: ' 行区域类型必须为 CAP 或 INT',
    en: ' Region type must be either CAP or INT',
    pu: ' O tipo de região deve ser CAP ou INT'
  },
  tip5: {
    zh: ' 行与第 yyy 行邮编范围重叠，请调整',
    en: ' ZIP code range overlaps with row yyy, please adjust',
    pu: ' Intervalo de CEP está sobreposto com a linha yyy, favor corrigir'
  },
  tip5_1: {
    zh: ' 行与第 ',
    en: ' ZIP code range overlaps with row ',
    pu: ' Intervalo de CEP está sobreposto com a linha '
  },
  tip5_2: {
    zh: ' 行邮编范围重叠，请调整',
    en: ', please adjust',
    pu: ', favor corrigir'
  },
  ModifyDeliveryMethod: {
    zh: '修改派送方式',
    en: 'Modify Delivery Method',
    pu: 'Modificar Método de Entrega'
  },
  DeliveryMethod: {
    zh: '派送方式',
    en: 'Delivery Method',
    pu: 'Método de Entrega'
  },
  HoldForCompleteDelivery: {
    zh: '到齐再派',
    en: 'Hold for Complete Delivery',
    pu: 'Entregar Somente com Lote Completo'
  },
  firstComeFirstServeDelivery: {
    zh: '先到先派',
    en: 'First-In-First-Out Delivery',
    pu: 'Entregar por Ordem de Chegada'
  },
  effectiveStartHub: {
    zh: '时效起点HUB',
    en: 'Effective Start HUB',
    pu: 'HUB de início de vigência'
  },
  orderPlaced: {
    zh: '已下单',
    en: '',
    pu: 'Pedido criado'
  },
  alert: {
    zh: '提醒',
    en: 'Alert',
    pu: 'Alerta'
  },
  confirmCancelTickets: {
    zh: '确定要取消这些工单吗？',
    en: 'Are you sure you want to cancel these tickets?',
    pu: 'Tem certeza de que deseja cancelar estes tickets?'
  },
  cancelIrreversible: {
    zh: '取消后不可恢复。',
    en: 'Cancellation cannot be undone.',
    pu: 'O cancelamento não pode ser desfeito.'
  },
  ticketClosed: {
    zh: '工单已闭环。',
    en: '',
    pu: 'O acareação já terminou'
  },
  ticketCancelled: {
    zh: '存在”已取消“的工单，不可修改状态或结果',
    en: 'Cancelled tickets cannot be modified',
    pu: 'Chamados cancelados não podem ser modificados'
  },
  client: {
    zh: '客户',
    en: '',
    pu: 'Cliente'
  },
  displayRange: {
    zh: '展示范围',
    en: 'Display Range',
    pu: 'Escopo de exibição'
  },
  expressSystemDesktop: {
    zh: '快递系统PC端',
    en: 'Express System Desktop',
    pu: 'Sistema de Entregas Desktop'
  },
  expressMobileApp: {
    zh: '快递系统APP',
    en: 'Express Mobile App',
    pu: 'Aplicativo Móvel de Entregas'
  },
  validReturnReason: {
    zh: '是否可作为网点退件原因',
    en: 'Valid return reason',
    pu: 'Usável como motivo de devolução?'
  },
  outboundTime: {
    zh: '出仓时间',
    en: 'Outbound Time',
    pu: 'Horário de Saída'
  },
  outboundPhotos: {
    zh: '出仓照片',
    en: 'Outbound Photos',
    pu: 'Fotos de Saída'
  },
  multiStoreGroupCode: {
    zh: '一店多铺组号',
    en: 'Multi-store Group Code',
    pu: 'Código de Grupo Multi-loja'
  },
  secondaryOrTertiaryArrivalTime: {
    zh: '二级或三级到件时间',
    en: 'Secondary or Tertiary Arrival Time',
    pu: 'Horário de Chegada Secundária ou Terciária'
  },
  timelinessStartState: {
    zh: '时效起点州',
    en: 'Timeliness Starting State',
    pu: 'Estado de Início do Prazo'
  },
  timelinessCalculationMode: {
    zh: '时效计算模式',
    en: 'Timeliness Calculation Mode',
    pu: 'Modo de Cálculo do Prazo'
  },
  earliestArrivalTime: {
    zh: '最早到件时间',
    en: 'Earliest Arrival Time',
    pu: 'Horário Mais Antigo de Chegada'
  },
  latestArrivalTime: {
    zh: '最晚到件时间',
    en: 'Latest Arrival Time',
    pu: 'Horário Mais Tarde de Chegada'
  },
  pleaseUploadByTemplate: {
    zh: '请按模板上传',
    en: 'Please upload according to the template',
    pu: 'Por favor, faça o upload de acordo com o modelo'
  },
  uploadOnlyCsv: {
    zh: '上传文件只能是csv格式',
    en: '',
    pu: 'Os arquivos enviados só podem estar no formato CSV'
  },
  PleaseEnterNumberBetween1And99: {
    zh: '请输入1-99的数字',
    en: 'Please enter a number between 1 and 99',
    pu: 'Por favor, insira um número entre 1 e 99'
  },
  GeneratePickupCode: {
    zh: '生成集货码',
    en: 'Generate Pickup Code',
    pu: 'Gerar Código de Retirada'
  },
  PickupCode: {
    zh: '集货码',
    en: 'Pickup Code',
    pu: 'Código de Retirada'
  },
  NotBound: {
    zh: '未绑定',
    en: 'Not Bound',
    pu: 'Não vinculado'
  },
  Bound: {
    zh: '已绑定',
    en: 'Bound',
    pu: 'Vinculado'
  },
  BoundBags: {
    zh: '已绑定袋数',
    en: 'Bound Bags',
    pu: 'Bolsas Vinculadas'
  },
  BoundPackages: {
    zh: '已绑定包裹数',
    en: 'Bound Packages',
    pu: 'Pacotes Vinculados'
  },
  TotalInvoiceAmount: {
    zh: '总开票金额',
    en: 'Total Invoice Amount',
    pu: 'Valor Total da Fatura'
  },
  PickupCodeDetails: {
    zh: '集货码详情',
    en: 'Pickup Code Details',
    pu: 'Detalhes do Código de Retirada'
  },
  BoundBagNumber: {
    zh: '已绑定袋号',
    en: 'Bound Bag Number',
    pu: 'Número da Bolsa Vinculada'
  },
  BoundPackageNumber: {
    zh: '已绑定包裹号',
    en: 'Bound Package Number',
    pu: 'Número do Pacote Vinculado'
  },
  PleaseConfirmRemovalBagNumber: {
    zh: '请确认移除以下袋号',
    en: 'Please confirm the removal of the following bag numbers',
    pu: 'Por favor, confirme a remoção dos seguintes números de bolsas'
  },
  PleaseConfirmRemovalPackageNumber: {
    zh: '请确认移除以下包裹号',
    en: 'Please confirm the removal of the following package numbers',
    pu: 'Por favor, confirme a remoção dos seguintes números de pacotes'
  },
  exportStatusNotification: {
    zh: '导出成功，数据将会在1~10分钟内生成表格，请到技术支持中心中的资源任务列表中下载',
    en: 'Export successful, data will be generated into tables within 1-10 minutes, please download from the resource task list in Technical Support Center',
    pu: 'Exportação bem-sucedida, os dados serão gerados em tabelas dentro de 1-10 minutos, faça o download na lista de tarefas de recursos do Centro de Suporte Técnico'
  },
  smallParcelPostcode: {
    zh: '小件派送邮编',
    en: 'Small Parcel Delivery Postcode',
    pu: 'CEP de Entrega para Pequenas Encomendas'
  },
  largeParcelPostcode: {
    zh: '大件派送邮编',
    en: 'Large Parcel Delivery Postcode',
    pu: 'CEP de Entrega para Encomendas Grandes'
  },
  smallParcelCollectionPostcode: {
    zh: '小件揽收邮编',
    en: 'Small Parcel Collection Postcode',
    pu: 'CEP de Coleta para Pequenas Encomendas'
  },
  disabledInactive: {
    zh: '未启用-停用',
    en: 'Disabled - Inactive',
    pu: 'Desativado - Inativo'
  },
  disabledSuspended: {
    zh: '未启用-暂停使用',
    en: 'Disabled - Suspended',
    pu: 'Desativado - Suspenso'
  },
  disabledStandby: {
    zh: '未启用-备用',
    en: 'Disabled - Standby',
    pu: 'Desativado - Em Espera'
  },
  branchBasicInfo: {
    zh: '网点基础信息',
    en: 'Branch Basic Information',
    pu: 'Informações Básicas da Agência'
  },
  branchAddressInfo: {
    zh: '网点地址信息',
    en: 'Branch Address Information',
    pu: 'Informações de Endereço da Agência'
  },
  branchOperationInfo: {
    zh: '网点运营信息',
    en: 'Branch Operation Information',
    pu: 'Informações Operacionais da Agência'
  },
  branchSettlementInfo: {
    zh: '网点结算信息',
    en: 'Branch Settlement Information',
    pu: 'Informações de Liquidação da Agência'
  },
  startPostcodeCannotExceedEnd: {
    zh: '起始邮编不能大于结束邮编，且邮编不允许重复!',
    en: 'Start postcode cannot be greater than end postcode, and postcodes cannot be duplicated!',
    pu: 'O CEP inicial não pode ser maior que o CEP final, e os CEPs não podem ser duplicados!'
  },
  businessStartTime: {
    zh: '营业开始时间',
    en: 'Business Start Time',
    pu: 'Horário de Início do Expediente'
  },
  businessEndTime: {
    zh: '营业结束时间',
    en: 'Business End Time',
    pu: 'Horário de Fim de Expediente'
  },
  changeInfo: {
    zh: '变更信息',
    en: 'Change Information',
    pu: 'Informações de Alteração'
  },
  maxSingleQuerySupport: {
    zh: '最多支持单次查询100个网点',
    en: '',
    pu: 'Uma única consulta em lote não pode exceder 100 pontos de venda.'
  },
  scanInfo: {
    zh: '扫描信息',
    en: 'Scan Information',
    pu: 'Informações de Digitalização'
  },
  operationPage: {
    zh: '操作页面',
    en: 'Operation Page',
    pu: 'Página de Operação'
  },
  operationButton: {
    zh: '操作按钮',
    en: 'Operation Button',
    pu: 'Botão de Operação'
  },
  ExportByPackageNumber: {
    zh: '按包裹号导出',
    en: 'Export by Package Number',
    pu: 'Exportar por Número de Pacote'
  },
  ExportByTimeRange: {
    zh: '按时间区间导出',
    en: 'Export by Time Range',
    pu: 'Exportar por Intervalo de Tempo'
  },
  enterPackageNumber: {
    zh: '请输入包裹号，多个包裹号换行输入',
    en: 'Please enter package number, multiple package numbers separated by line breaks',
    pu: 'Por favor, insira o número do pacote, múltiplos números de pacote separados por quebras de linha'
  },
  creatorBranch: {
    zh: '创建人网点',
    en: 'Creator Branch',
    pu: 'Agência do Criador'
  },
  InboundQuantity: {
    zh: '网点入库量',
    en: 'Inbound Quantity',
    pu: 'Quantidade de Entrada'
  },
  DeliveryQuantity: {
    zh: '派送量',
    en: 'Delivery Quantity',
    pu: 'Quantidade de Entrega'
  },
  DeliveryRate: {
    zh: '派送率',
    en: 'Delivery Rate',
    pu: 'Taxa de Entrega'
  },
  OnTimeDeliveryQuantity: {
    zh: '准时派送量',
    en: 'On Time Delivery Quantity',
    pu: 'Quantidade de Entrega no Tempo'
  },
  OnTimeDeliveryRate: {
    zh: '准时派送率',
    en: 'On Time Delivery Rate',
    pu: 'Taxa de Entrega no Tempo'
  },
  DeliveryDetails: {
    zh: '派送明细',
    en: 'Delivery Details',
    pu: 'Detalhes da Entrega'
  },
  DeliveryTime: {
    zh: '派送时间',
    en: 'Delivery Time',
    pu: 'Tempo de Entrega'
  },
  ExpectedDeliveryTime: {
    zh: '理应派送时间',
    en: 'Expected Delivery Time',
    pu: 'Tempo Esperado de Entrega'
  },
  StatisticalDate: {
    zh: '统计日期',
    en: 'Statistical Date',
    pu: 'Data de Estatística'
  },
  productSKUCode: {
    zh: '产品SKU代码',
    en: 'Product SKU Code',
    pu: 'Código SKU do Produto'
  },
  productName: {
    zh: '产品名称',
    en: 'Product Name',
    pu: 'Nome do Produto'
  },
  productUnitPrice: {
    zh: '产品单价',
    en: 'Product Unit Price',
    pu: 'Preço Unitário do Produto'
  },
  package: {
    zh: '包裹',
    en: 'Package',
    pu: 'Pacotes'
  },
  sealedBagBranch: {
    zh: '封袋网点',
    en: 'Sealed Bag Branch',
    pu: 'Agência de Saco Lacrado'
  },
  supplementCollectionTime: {
    zh: '补充揽收时间',
    en: 'Supplement Collection Time',
    pu: 'Tempo de Coleta Suplementar'
  },
  valueMustExceedTen: {
    zh: '数值必须大于0',
    en: 'Value must be greater than 0',
    pu: 'Valor deve ser maior que 0'
  },
  workOrderNumber: {
    zh: '工单编号',
    en: 'Order Number',
    pu: 'Número do Pedido'
  },
  modifyResult: {
    zh: '修改处理结果',
    en: 'Modify Result',
    pu: 'Modificar Resultado'
  },
  upstreamResponsibility: {
    zh: '上游责任',
    en: 'Upstream Responsibility',
    pu: 'Responsabilidade do Upstream'
  },
  downstreamResponsibility: {
    zh: '下游责任',
    en: 'Downstream Responsibility',
    pu: 'Responsabilidade do Downstream'
  },
  partialResponsibility: {
    zh: '部分责任',
    en: 'Partial Responsibility',
    pu: 'Responsabilidade Parcial'
  },
  processingRegion: {
    zh: '处理大区',
    en: 'Processing Region',
    pu: 'Região de Processamento'
  },
  processingBranch: {
    zh: '处理网点',
    en: 'Processing Branch',
    pu: 'Agência de Processamento'
  },
  reportingBranch: {
    zh: '上报网点',
    en: 'Reporting Branch',
    pu: 'Agência de Relatório'
  },
  endOperator: {
    zh: '结束操作人',
    en: 'End Operator',
    pu: 'Operador Final'
  },
  messageRecord: {
    zh: '消息记录',
    en: 'Message Record',
    pu: 'Registro de Mensagens'
  },
  myReported: {
    zh: '我上报的',
    en: 'My Reported',
    pu: 'Meus Relatados'
  },
  myPending: {
    zh: '我需处理的',
    en: 'My Pending',
    pu: 'Meus Pendentes'
  },
  partiallyCompleted: {
    zh: '部分结束',
    en: 'Partially Completed',
    pu: 'Parcialmente Concluído'
  },
  fullyCompleted: {
    zh: '全部结束',
    en: 'Fully Completed',
    pu: 'Totalmente Concluído'
  },
  discrepancyReport: {
    zh: '差异上报',
    en: 'Discrepancy Report',
    pu: 'Relatório de Divergência'
  },
  atLeastThreeImages: {
    zh: '最少需上传3张照片',
    en: 'Minimum 3 photos required',
    pu: 'Mínimo de 3 fotos necessárias'
  },
  multiLineInputLimit: {
    zh: '多个换行输入，最多支持5万条',
    en: 'Multiple line input, supports up to 50,000 entries',
    pu: 'Entrada múltipla por linhas, suporta até 50,000 registros'
  },
  totalImported: {
    zh: '总导入',
    en: 'Total Imported',
    pu: 'Total Importado'
  },
  end: {
    zh: '结束',
    en: 'End',
    pu: 'Fim'
  },
  messageContentRequired: {
    zh: '消息内容不能为空',
    en: 'Message content cannot be empty',
    pu: 'Conteúdo da mensagem não pode estar vazio'
  },
  enterTrackingNumber: {
    zh: '请输入单号',
    en: 'Enter Tracking Number',
    pu: 'Insira o Número de Rastreamento'
  },
  scanNumberNoDuplicate: {
    zh: '扫描单号不能重复',
    en: 'Scan numbers cannot be duplicated',
    pu: 'Números de digitalização não podem ser duplicados'
  },
  processed: {
    zh: '已处理',
    en: 'Processed',
    pu: 'Processado'
  },
  uploadImageLimit5: {
    zh: '最多可上传5张图片.仅支持上传格式为(jpg、jpeg、png、gif)',
    en: 'Maximum 5 images can be uploaded. Only supports (jpg, jpeg, png, gif) formats',
    pu: 'Máximo de 5 imagens podem ser carregadas. Suporta apenas formatos (jpg, jpeg, png, gif)'
  },
  uploadImageLimit: {
    zh: '最多可上传5张照片',
    en: 'Maximum 5 images can be uploaded',
    pu: 'Máximo de 5 imagens podem ser enviadas'
  },
  waitForUploadImages: {
    zh: '正在上传图片，请稍后...',
    en: 'Uploading images, please wait...',
    pu: 'Enviando imagens, aguarde...'
  },
  modifyPermission: {
    zh: '仅‘全部结束’且‘我需处理的’才能修改',
    en: "Only 'Fully Completed' and 'My Pending' can be modified",
    pu: "Apenas 'Totalmente Concluído' e 'Meus Pendentes' podem ser modificados"
  },
  filteredInvalidData1: {
    zh: '已过滤 ',
    en: 'Filtered ',
    pu: 'Filtrados '
  },
  filteredInvalidData2: {
    zh: ' 条不符合条件的数据',
    en: ' records of invalid data',
    pu: ' registros de dados inválidos'
  },
  registrationSource: {
    zh: '登记来源',
    en: 'Registration Source',
    pu: 'Fonte de Registro'
  },
  selectRegistrationSource: {
    zh: "请选择'登记来源'",
    en: "Please select 'Registration Source'",
    pu: "Por favor, selecione 'Fonte de Registro'"
  },
  LargePiecesCannotModifyAddress: {
    zh: '大件运单暂不支持在本页面修改地址，请重新选择单号',
    en: 'Large-piece orders do not support modifying addresses on this page, please reselect the number',
    pu: 'Ordens de grande volume não suportam a modificação de endereços nesta página, por favor, selecione novamente o número'
  },
  pastePostcode: {
    zh: '粘贴邮编',
    en: 'Paste Postcode',
    pu: 'Colar CEP'
  },
  postcodeFormatInstructions: {
    zh: '如果是连续的邮编，请用"~"隔开，如果不是连续的，请用","隔开',
    en: 'If postcodes are consecutive, separate with "~"; if not consecutive, separate with ","',
    pu: 'Se os CEPs são consecutivos, separe com "~"; se não são consecutivos, separe com ","'
  },
  systemExecutingTask: {
    zh: '系统正在执行任务...',
    en: 'System is executing task...',
    pu: 'Sistema está executando tarefa...'
  },
  taskCompletedCheckResult: {
    zh: '任务已结束，请查看结果',
    en: 'Task completed, please check results',
    pu: 'Tarefa concluída, por favor verifique os resultados'
  },
  importFailedPostcodes: {
    zh: '导入邮编失败：',
    en: 'Postcode Import Failed',
    pu: 'Falha na Importação do CEP'
  },
  branchCode: {
    zh: '网点编码',
    en: 'Branch Code',
    pu: 'Código da Agência'
  },
  addNewBranch: {
    zh: '新增网点',
    en: 'Add New Branch',
    pu: 'Adicionar Nova Agência'
  },
  contractSigned: {
    zh: '是否已签署合同',
    en: 'Whether contract has been signed',
    pu: 'Contrato assinado？'
  },
  addTime: {
    zh: '添加时间',
    en: 'Add Time',
    pu: 'Tempo de Adição'
  },
  addedBy: {
    zh: '添加人',
    en: 'Added By',
    pu: 'Adicionado Por'
  },
  duplicateValuesExist: {
    zh: '存在重复值',
    en: 'Duplicate values exist',
    pu: 'Valores duplicados existem'
  },
  pleaseReenter: {
    zh: '请重新输入',
    en: 'Please re-enter',
    pu: 'Por favor, insira novamente'
  },
  addBusinessHours: {
    zh: '添加营业时间',
    en: 'Add Business Hours',
    pu: 'Adicionar Horário Comercial'
  },
  branchInformation: {
    zh: '网点信息',
    en: 'Branch Information',
    pu: 'Informações da Agência'
  },
  dataArchivedTo: {
    zh: '数据已归档至',
    en: 'Data Archived To',
    pu: 'Dados Arquivados Para'
  },
  archivedDataQuery: {
    zh: '归档数据查询',
    en: 'Archived Data Query',
    pu: 'Consulta de Dados Arquivados'
  },
  unArchived: {
    zh: '未归档',
    en: 'Unarchived',
    pu: 'Não Arquivado'
  },
  isArchived: {
    zh: '已归档',
    en: 'Archived',
    pu: 'Arquivado'
  },
  exportChecked: {
    zh: '导出已勾选记录',
    en: 'Export Checked Records',
    pu: 'Exportar Registros Selecionados'
  },
  exportAll: {
    zh: '按条件导出全部',
    en: 'Export All by Filter',
    pu: 'Exportar Todos por Filtro'
  },
  noOrdersFoundPleaseTry: {
    zh: '未查询到订单请重试',
    en: 'Order not found. Please try again',
    pu: 'Não foi possível encontrar o pedido, tente novamente'
  },
  orderInformationExport: {
    zh: '订单信息导出',
    en: 'Order Information Export',
    pu: 'Exportação de Informações de Pedido'
  },
  waybillInformationExport: {
    zh: '运单信息导出',
    en: 'Waybill Information Export',
    pu: 'Exportação de Informações de Conhecimento'
  },
  failureDetails: {
    zh: '失败明细',
    en: 'Failure Details',
    pu: 'Detalhes de Falha'
  },
  largeOrderCancel: {
    zh: '大件取消订单',
    en: 'Cancel Large Order',
    pu: 'Cancelar Pedido Grande'
  },
  DelivererCount: {
    zh: '派送员数量',
    en: 'Deliverer Count',
    pu: 'Número de Entregadores'
  },
  AbnormalPackageNumber: {
    zh: '异常包裹号',
    en: 'Abnormal Package Number',
    pu: 'Número de Pacote Anormal'
  },
  OrderInformationExport: {
    zh: '订单信息导出',
    en: 'Order Information Export',
    pu: 'Exportação de Informações de Pedido'
  },
  WaybillInformationExport: {
    zh: '运单信息导出',
    en: 'Waybill Information Export',
    pu: 'Exportação de Informações de Rastreamento'
  },
  AbnormalPackageMark: {
    zh: '异常包裹标记',
    en: 'Abnormal Package Mark',
    pu: 'Marca de Pacote Anormal'
  },
  ReasonForAbnormal: {
    zh: '异常原因',
    en: 'Reason for Abnormal',
    pu: 'Motivo da Divergência'
  },
  CustomerRequiresInterceptionReturn: {
    zh: '客户要求拦截退回',
    en: 'Customer Requires Interception Return',
    pu: 'Cliente Requer Interceptação de Retorno'
  },
  ReceivingCustomerRejectsReturn: {
    zh: '收方客户拒收退回',
    en: 'Receiving Customer Rejects Return',
    pu: 'Cliente de Destino Rejeita Retorno'
  },
  PackageDamagedReturn: {
    zh: '包裹破损退回',
    en: 'Package Damaged Return',
    pu: 'Retorno por Danos no Pacote'
  },
  PackageLost: {
    zh: '包裹遗失',
    en: 'Package Lost',
    pu: 'Pacote Perdido'
  },
  AbnormalRemarks: {
    zh: '异常备注',
    en: 'Abnormal Remarks',
    pu: 'Observações Anormais'
  },
  FailureDetails: {
    zh: '失败明细',
    en: 'Failure Details',
    pu: 'Detalhes da Falha'
  },
  DeleteAll: {
    zh: '删除全部',
    en: 'Delete All',
    pu: 'Remover tudo'
  },
  operationDetails: {
    zh: '操作明细',
    en: 'Operation Details',
    pu: 'Detalhes da Operação'
  },
  // 操作记录匹配属性名用---------------start
  op: {
    zh: '操作',
    en: '',
    pu: 'Operação'
  },
  msg: {
    zh: '明细',
    en: '',
    pu: 'Detalhes'
  },
  pmsName: {
    zh: '权限名称',
    en: '',
    pu: 'Nome da Permissão'
  },
  field: {
    zh: '字段',
    en: 'Field',
    pu: 'Campo'
  },
  // 操作记录匹配属性名用---------------end
  removeOp: {
    zh: '移除网点邮编',
    en: '',
    pu: 'Remover CEP do Ponto'
  },
  valueMismatchAlert: {
    zh: '包裹产品价值与开票金额不一致，请检查产品单价',
    en: 'Value mismatch detected, check product price',
    pu: 'Diferença de valor detectada, verifique preço do produto'
  },
  mdfeKey: {
    zh: 'MDFE密钥',
    en: 'MDFE Key',
    pu: 'Chave MDFE'
  },
  mdfeStatus: {
    zh: 'MDFE状态',
    en: 'MDFE Status',
    pu: 'Status MDFE'
  },
  scanningStage: {
    zh: '扫描环节',
    en: 'Scanning Stage',
    pu: 'Etapa de Digitalização'
  },
  sortingMachine: {
    zh: '分拣机',
    en: 'Sorting Machine',
    pu: 'Máquina de Triagem'
  },
  mdfeCreated: {
    zh: 'MDFE创建时间',
    en: 'MDFE Created',
    pu: 'MDFE Criado'
  },
  mdfeStatusChanged: {
    zh: 'MDFE状态变更时间',
    en: 'MDFE Status Changed',
    pu: 'Status MDFE Alterado'
  },
  addPostcode: {
    zh: '添加邮编',
    en: 'Add Postcode',
    pu: 'Adicionar CEP'
  },
  removeFromBranch: {
    zh: '从原网点移除',
    en: 'Remove from Branch',
    pu: 'Remover da Agência'
  },
  airTransport: {
    zh: '航空运输',
    en: 'Air Transport',
    pu: 'Transporte Aaéreo'
  },
  supportBranch: {
    zh: '支援网点',
    en: 'Support Branch',
    pu: 'Ponto de Apoio'
  },
  removeSure: {
    zh: '确定要将该邮编从原网点移除吗？',
    en: '',
    pu: 'Confirmar a remoção do CEP do ponto original?'
  },
  yesRm: {
    zh: '是',
    en: '',
    pu: 'Sim'
  },
  noRm: {
    zh: '否',
    en: '',
    pu: 'Não'
  },
  removeSucTips: {
    zh: '已标记从原网点移除（保存后生效）',
    en: '',
    pu: 'Marcado para remoção da agência original (efeito após salvar)'
  },
  postcodeState: {
    zh: '邮编州',
    en: 'Postcode State',
    pu: 'UF de cidade'
  },
  postcodeCity: {
    zh: '邮编城市',
    en: 'Postcode City',
    pu: 'Cidade de CEP'
  },
  Pause: {
    zh: '暂停',
    en: 'Pause',
    pu: 'Encerramento'
  },
  StateOfLargePostcode: {
    zh: '大件邮编所属州',
    en: 'State of Large Postcode',
    pu: 'UF de CEP Grande'
  },
  StateOfSmallPostcode: {
    zh: '小件邮编所属州',
    en: 'State of Small Postcode',
    pu: 'UF de CEP Pequeno'
  },
  CityOfLargePostcode: {
    zh: '大件邮编所属城市',
    en: 'City of Large Postcode',
    pu: 'Cidade de CEP Grande'
  },
  CityOfSmallPostcode: {
    zh: '小件邮编所属城市',
    en: 'City of Small Postcode',
    pu: 'Cidade de CEP Pequeno'
  },
  Enabled: {
    zh: '启用中',
    en: 'Enabled',
    pu: 'Ativo'
  },
  Disabled: {
    zh: '已停用',
    en: 'Disabled',
    pu: 'Inativo'
  },
  switchedToDeadlineView: {
    zh: '已切换至截止时间维度',
    en: 'Switched to Deadline View',
    pu: 'Mudado para Visualização de Prazo'
  },
  switchedToClosedLoopView: {
    zh: '已切换至闭环时间维度',
    en: 'Switched to Closed-loop View',
    pu: 'Mudado para Visualização de Ciclo Fechado'
  },
  switchedToSignTimeView: {
    zh: '已切换至签收时间维度',
    en: 'Switched to Sign Time View',
    pu: 'Mudado para Visualização de Tempo de Assinatura'
  },
  selectDate: {
    zh: '请选择日期',
    en: 'Please Select Date',
    pu: 'Por favor, selecione a data'
  },
  stateTotal: {
    zh: '州总计',
    en: 'State Total',
    pu: 'Total do Estado'
  },
  collectionSignature: {
    zh: '揽收签名',
    en: 'Collection Signature',
    pu: 'Assinatura de Coleta'
  },
  collectionPhoto: {
    zh: '揽收拍照',
    en: 'Collection Photo',
    pu: 'Foto de Coleta'
  },
  recipientRegion: {
    zh: '收件人所属大区',
    en: 'Recipient Region',
    pu: 'Região do Destinatário'
  },
  RegistrationPositionLongitude: {
    zh: '登记位置经度',
    en: 'Registration Position Longitude',
    pu: 'Longitude de Registro'
  },
  RegistrationPositionLatitude: {
    zh: '登记位置纬度',
    en: 'Registration Position Latitude',
    pu: 'Latitude de Registro'
  },
  DistanceFromReceivingAddress: {
    zh: '距收件地址距离',
    en: 'Distance from Receiving Address',
    pu: 'Distância da Endereço de Recebimento'
  },
  postalCodeFormat: {
    zh: '邮编格式：10000000~20000000，连续的邮编用‘~’连接，不连续的用‘,’间隔',
    en: 'Postal Code Format: 10000000~20000000, continuous postal codes use "~" to connect, non-continuous use "," to separate',
    pu: 'Formato de CEP: 10000000~20000000, CEPs contínuos usam "~" para conectar, CEPs não contínuos usam "," para separar'
  },
  IsOverride: {
    zh: '是否覆盖',
    en: 'Is Override',
    pu: 'Abrangido'
  },
  SelectedAreaTypeIncorrect: {
    zh: ' 行选择的区域类型不正确',
    en: ' Selected area type is incorrect',
    pu: ' Tipo de área selecionado está incorreto'
  },
  ImportPostcodeResult: {
    zh: '导入邮编结果',
    en: 'Import Postcode Result',
    pu: 'Resultado da Importação de CEP'
  },
  qualified: {
    zh: '合格',
    en: 'Qualified',
    pu: 'Qualificado'
  },
  unqualified: {
    zh: '不合格',
    en: 'Unqualified',
    pu: 'Não Qualificado'
  },
  statistics: {
    zh: '统计',
    en: 'Statistics',
    pu: 'Estatística'
  },
  qualifiedCount: {
    zh: '合格票数',
    en: 'Qualified Tickets',
    pu: 'Votos Qualificados'
  },
  unqualifiedCount: {
    zh: '不合格票数',
    en: 'Unqualified Tickets',
    pu: 'Votos Não Qualificados'
  },
  qualificationRate: {
    zh: '合格率',
    en: 'Qualification Rate',
    pu: 'Taxa de Qualificação'
  },
  unqualifiedRate: {
    zh: '不合格率',
    en: 'Unqualified Rate',
    pu: 'Taxa de Não Qualificação'
  },
  stateSummary: {
    zh: '州总计',
    en: 'State Total',
    pu: 'Total do Estado'
  },
  Stored: {
    zh: '暂存',
    en: 'Stored',
    pu: 'Armazenado'
  },
  max31DaysDate: {
    zh: '最多可查询31天的数据',
    en: '31 Days Max Query',
    pu: 'Consulta Máx. 31 Dias'
  },
  intercep200: {
    zh: '单次查询最多200条，已截取前200条数据',
    en: '',
    pu: 'Consulta única até 200 dados, os primeiros 200 dados recebidos'
  },
  lastMonth: {
    zh: '上月',
    en: 'Last Month',
    pu: 'Mês Passado'
  },
  AnJunManagementBoard: {
    zh: '安骏管理看板',
    en: 'Anjun Management Board',
    pu: 'Quadro de Controle'
  },
  ViewData: {
    zh: '查看数据',
    en: 'View Data',
    pu: 'Ver Dados'
  },
  OverdueCount: {
    zh: '超期次数',
    en: 'Overdue Count',
    pu: 'Número de Atrasos'
  },
  QueryNumberCannotExceed2000: {
    zh: '每次查询单号不能超过2000个',
    en: 'Query number cannot exceed 2000',
    pu: 'Número de consulta não pode exceder 2000'
  },
  responsibleOutlet: {
    zh: '填写责任网点',
    en: 'Fill in responsible outlet',
    pu: 'Preencher unidade responsável'
  },
  exportDetails: {
    zh: '导出明细',
    en: 'Export Details',
    pu: 'Exportar Detalhes'
  },
  // 错发监控——专属————start
  val1: {
    zh: '统计日期',
    en: '',
    pu: 'Data'
  },
  val2: {
    zh: '运单号',
    en: '',
    pu: 'Número do Waybill'
  },
  val3: {
    zh: '错发操作大区',
    en: '',
    pu: 'Regional responsável pelo envio indevido'
  },
  val4: {
    zh: '错发操作网点',
    en: '',
    pu: 'Ponto responsável pelo envio indevido'
  },
  val5: {
    zh: '商户',
    en: '',
    pu: 'Mercador'
  },
  val6: {
    zh: '错发装车时间',
    en: '',
    pu: 'Hora Carga Errada'
  },
  val7: {
    zh: '错发下一站',
    en: '',
    pu: 'Próximo Ponto Errado'
  },
  val8: {
    zh: '错发车牌号',
    en: '',
    pu: 'Place'
  },
  val9: {
    zh: '实际到达网点',
    en: '',
    pu: 'Ponto de chegada real'
  },
  val10: {
    zh: '错发入库时间',
    en: '',
    pu: 'Hora de Recebimento Errado'
  },
  val11: {
    zh: '剩余时效时间(H)',
    en: '',
    pu: 'Tempo restante de SLA(H)'
  },
  val12: {
    zh: '理应送达时间减去到达时间',
    en: '',
    pu: 'Horário em que deve ser entregue menos o tempo de entrada'
  },
  val13: {
    zh: '所属HUB',
    en: '',
    pu: 'HUB de afiliação'
  },
  val14: {
    zh: '所属大区',
    en: '',
    pu: 'Região de afiliação'
  },
  // 错发监控——专属————end
  cancelledDeletion: {
    zh: '已取消删除',
    en: 'Cancelled Deletion',
    pu: 'Exclusão Cancelada'
  },
  addLabel: {
    zh: '增加标签',
    en: 'Add Label',
    pu: 'Adicionar Etiqueta'
  },
  labelInputHint: {
    zh: '请输入或选择标签，最多6个字符',
    en: 'Enter or select a label, max 6 characters',
    pu: 'Digite ou selecione uma etiqueta, máx. 6 caracteres'
  },
  enterOrSelectLabel: {
    zh: '请输入或选择标签',
    en: 'Enter or select a label',
    pu: 'Digite ou selecione uma etiqueta'
  },
  historyTags: {
    zh: '历史标签',
    en: 'History Tags',
    pu: 'Tags Históricos'
  },
  todaysTasks: {
    zh: '今日任务',
    en: "Today's Tasks",
    pu: 'Tarefas de Hoje'
  },
  historyRecords: {
    zh: '历史记录',
    en: 'History Records',
    pu: 'Registros Históricos'
  },
  queueCount: {
    zh: '排队个数',
    en: 'Queue Count',
    pu: 'Qtd. na fila'
  },
  cancelTask: {
    zh: '取消任务',
    en: 'Cancel Task',
    pu: 'Cancelar'
  },
  // 投诉工单中，投诉类型选择'Reclame Aqui'时，使用以下数据
  complaintType1: {
    zh: '已签收',
    en: '',
    pu: 'Entregue'
  },
  complaintType2: {
    zh: '因地址错误已退回',
    en: '',
    pu: 'Devolvido endereço incorreto'
  },
  complaintType3: {
    zh: '因收件人不在而退件',
    en: '',
    pu: 'Devolvido destinatário ausente'
  },
  complaintType4: {
    zh: '包裹破损',
    en: '',
    pu: 'Avaria'
  },
  complaintType5: {
    zh: '包裹已确认丢失',
    en: '',
    pu: 'Perda confirma'
  },
  complaintType6: {
    zh: '因海关原因退回',
    en: '',
    pu: 'Devolvido Alfândega'
  },
  complaintType7: {
    zh: '被海关扣留',
    en: '',
    pu: 'Retido Alfândega'
  },
  exportActionsAndTimeline: {
    zh: '导出操作和轨迹时间',
    en: 'Export Actions and Tracking Timeline',
    pu: 'Hora Rastreamento/Operação'
  },
  selectTimeNode: {
    zh: '请选择时间节点...',
    en: 'Please select a time node...',
    pu: 'Por favor, selecione um nó de tempo...'
  },
  // 共8个节点
  totalEightNodes1: {
    zh: '共 ',
    en: 'Total ',
    pu: 'Total de '
  },
  totalEightNodes2: {
    zh: ' 个节点',
    en: ' nodes',
    pu: ' nós'
  },
  timeType1: {
    zh: '揽收操作时间',
    en: '',
    pu: 'Horário da coleta'
  },
  timeType2: {
    zh: '揽收轨迹时间',
    en: '',
    pu: 'Horário da coleta no rastreio'
  },
  timeType3: {
    zh: '网点入库操作时间',
    en: '',
    pu: 'Horário da entrada no ponto'
  },
  timeType4: {
    zh: '网点入库轨迹时间',
    en: '',
    pu: 'Horário da entrada no ponto no rastreio'
  },
  timeType5: {
    zh: '网点派件操作时间',
    en: '',
    pu: 'Horário da saída para entrega'
  },
  timeType6: {
    zh: '网点派件轨迹时间',
    en: '',
    pu: 'Horário da saída para entrega no rastreio'
  },
  timeType7: {
    zh: '正向签收操作时间',
    en: '',
    pu: 'Horário da assinatura'
  },
  timeType8: {
    zh: '正向签收轨迹产生时间',
    en: '',
    pu: 'Horário da assinatura no rastreio'
  },
  timeType9: {
    zh: '派送失败操作时间',
    en: '',
    pu: 'Horário da falha na entrega'
  },
  timeType10: {
    zh: '派送失败轨迹时间',
    en: '',
    pu: 'Horário da falha na entrega no rastreio'
  },
  timeType11: {
    zh: '退件签收操作时间',
    en: '',
    pu: 'Horário da devolução recebida'
  },
  timeType12: {
    zh: '退件签收轨迹时间',
    en: '',
    pu: 'Horário da devolução recebida no rastreio'
  },
  timeType13: {
    zh: '终态操作时间',
    en: '',
    pu: 'Horário do status final'
  },
  timeType14: {
    zh: '终态轨迹时间',
    en: '',
    pu: 'Horário do status final no rastreio'
  },
  branchDelivery: {
    zh: '网点派件',
    en: 'Branch Delivery',
    pu: 'Entrega na Agência'
  },
  deliveryFailed: {
    zh: '派送失败',
    en: 'Delivery Failed',
    pu: 'Falha na Entrega'
  },
  finalStatus: {
    zh: '终态',
    en: 'Final Status',
    pu: 'Status Final'
  },
  smallParcelPriceInquiry: {
    zh: '小件快递询价',
    en: 'Small Parcel Price Inquiry',
    pu: 'Cotação para Pequenos Pacotes'
  },
  largeParcelPriceInquiry: {
    zh: '大件快递询价',
    en: 'Large Parcel Price Inquiry',
    pu: 'Cotação para Pacotes Grandes'
  },
  invalidSenderPostcode: {
    zh: '发件邮编无效，请输入8位数字',
    en: 'Invalid sender postcode, please enter 8 digits',
    pu: 'CEP do remetente inválido, digite 8 dígitos'
  },
  invalidRecipientPostcode: {
    zh: '收件邮编无效，请输入8位数字',
    en: 'Invalid recipient postcode, please enter 8 digits',
    pu: 'CEP do destinatário inválido, digite 8 dígitos'
  },
  lengthWidthHeightOptional: {
    zh: '长宽高（选填）',
    en: 'L/W/H (Optional)',
    pu: 'C/L/A (Opcional)'
  },
  volumeUnitNote: {
    zh: '注：总体积单位为立方厘米(cm³)；长宽高单位为厘米(cm)',
    en: 'Note: Volume unit is cubic centimeters (cm³); L/W/H units are centimeters (cm)',
    pu: 'Nota: Unidade de volume é centímetros cúbicos (cm³); Unidades C/L/A são centímetros (cm)'
  },
  volumeUnitNoteM3: {
    zh: '注：总体积单位为立方米(m³)；长宽高单位为米(m)',
    en: 'Note: Volume unit is cubic meters (m³); L/W/H units are meters (m)',
    pu: 'Nota: Unidade de volume é metros cúbicos (m³); Unidades C/L/A são metros (m)'
  },
  estimatedShippingCost: {
    zh: '预估运费',
    en: 'Estimated Shipping Cost',
    pu: 'Custo Estimado de Envio'
  },
  estimatedShippingDisclaimer: {
    zh: '预估运费，仅供参考，请以实际应付金额为准',
    en: 'Estimated shipping cost for reference only, subject to actual payment amount',
    pu: 'Custo estimado de envio apenas para referência, sujeito ao valor real pago'
  },
  mustBeGreaterThanZero: {
    zh: '必须大于 0',
    en: 'Must be greater than 0',
    pu: 'Deve ser maior que 0'
  },
  maxWeight30KG: {
    zh: '小件包裹不得超过30KG',
    en: 'Small parcel cannot exceed 30KG',
    pu: 'Pacotes pequenos não podem exceder 30KG'
  },
  minWeight10kg: {
    zh: '大件包裹不得低于10.001KG',
    en: 'Large parcel must be at least 10.001KG',
    pu: 'Pacotes grandes devem ter pelo menos 10.001KG'
  },
  maxSixDecimals: {
    zh: '最多保留6位小数',
    en: 'Maximum 6 decimal places',
    pu: 'Máximo 6 casas decimais'
  },
  minZeroMaxTwoDecimals: {
    zh: '需大于等于0，最多可输入2位小数',
    en: 'Must be ≥0, maximum 2 decimal places',
    pu: 'Deve ser ≥0, máximo 2 casas decimais'
  },
  queryQuote: {
    zh: '查询报价',
    en: 'Query Quote',
    pu: 'Consultar Cotação'
  },
  waitingForQuote: {
    zh: '等待查询报价...',
    en: 'Waiting for quote...',
    pu: 'Aguardando cotação...'
  },
  closeQuoteTips: {
    zh: '是否关闭当前窗口',
    en: 'Close current window?',
    pu: 'Fechar janela atual?'
  },
  long: {
    zh: '长',
    en: '',
    pu: 'Comprimento'
  },
  width: {
    zh: '宽',
    en: '',
    pu: 'Largura'
  },
  height: {
    zh: '高',
    en: '',
    pu: 'Altura'
  },
  returnWarehouseHint: {
    zh: '退仓提示',
    en: 'Return Warehouse Hint',
    pu: 'Aviso do devolvido'
  },
  allRegions: {
    zh: '全部大区',
    en: 'All Regions',
    pu: 'Todas as Regiões'
  },
  allStates: {
    zh: '全部州',
    en: 'All States',
    pu: 'Todos os Estados'
  },
  transitCenterType: {
    zh: '转运中心类型',
    en: 'Transit Center Type',
    pu: 'Tipo de Hub'
  },
  allTypes: {
    zh: '全部类型',
    en: 'All Types',
    pu: 'Todos os Tipos'
  },
  hubName: {
    zh: '转运中心名称',
    en: '',
    pu: 'Nome do Hub'
  },
  hubAbbreviation: {
    zh: 'HUB简称',
    en: 'HUB Abbreviation',
    pu: 'Abreviação do HUB'
  },
  levelType: {
    zh: '类型',
    en: '',
    pu: 'Tipe de hub'
  },
  todayInboundTickets: {
    zh: '今日入库票数',
    en: '',
    pu: 'Volumes Recebidos Hoje'
  },
  todayOutboundTickets: {
    zh: '今日出库票数',
    en: '',
    pu: 'Volumes Expedidos Hoje'
  },
  currentInventoryTickets: {
    zh: '当前库存票数',
    en: '',
    pu: 'Estoque Atual'
  },
  inventoryTurnoverDays: {
    zh: '库存周转天数',
    en: '',
    pu: 'Dias de Giro do Estoque'
  },
  avgStorageTimeLast7Days: {
    zh: '近7天平均在库时长',
    en: '',
    pu: 'Tempo Médio em Estoque (7 dias)'
  },
  inventoryAgingRate: {
    zh: '库存老化率',
    en: '',
    pu: 'Taxa de Estoque Antigo'
  },
  netInventoryIncrease: {
    zh: '净增库存',
    en: '',
    pu: 'Variação Líquida de Estoque'
  },
  inventoryLe24h: {
    zh: '≤24h库存',
    en: '≤24h Inventory',
    pu: 'Estoque ≤24h'
  },
  inventory24_48h: {
    zh: '24~48h库存',
    en: '24-48h Inventory',
    pu: 'Estoque 24-48h'
  },
  inventory48_72h: {
    zh: '48~72h库存',
    en: '48-72h Inventory',
    pu: 'Estoque 48-72h'
  },
  inventory3_7days: {
    zh: '3~7天库存',
    en: '3-7 Days Inventory',
    pu: 'Estoque 3-7 Dias'
  },
  inventoryOver7Days: {
    zh: '＞7天库存',
    en: '>7 Days Inventory',
    pu: 'Estoque >7 Dias'
  },
  inboundTickets: {
    zh: '入库票数',
    en: 'Inbound Tickets',
    pu: 'Tickets de Entrada'
  },
  outboundTickets: {
    zh: '出库票数',
    en: 'Outbound Tickets',
    pu: 'Tickets de Saída'
  },
  inventoryTickets: {
    zh: '库存票数',
    en: 'Inventory Tickets',
    pu: 'Tickets de Estoque'
  },
  transitCenterInventoryDashboard: {
    zh: '转运中心库存监控看板',
    en: 'Transit Center Inventory Dashboard',
    pu: 'Painel de Monitoramento de Estoque dos Hubs'
  },
  hubVal1: {
    zh: '核心目标：监控每个转运中心每日入库票数、出库票数，以及当前仍停留在转运中心未发出的库存票数。',
    en: 'Core Objective: Monitor daily inbound tickets, outbound tickets, and current pending inventory tickets at each transit center.',
    pu: 'Objetivo principal: Monitorar tickets de entrada diários, tickets de saída e tickets de estoque atualmente pendentes em cada centro de transferência.'
  },
  hubVal2: {
    zh: '数据更新时间',
    en: 'Data Update Time',
    pu: 'Hora da Atualização dos Dados'
  },
  hubVal3: {
    zh: '自动刷新：1小时',
    en: 'Auto refresh: 1 hour',
    pu: 'Atualização automática: 1 hora'
  },
  hubVal4: {
    zh: '一、全局概览',
    en: '1. Global Overview',
    pu: '1. Visão Geral'
  },
  hubVal5: {
    zh: '快速查看当日流入、流出、当前库存压力和分拣出库效率',
    en: 'Quick view of daily inflow, outflow, current inventory pressure, and sorting outbound efficiency',
    pu: 'Visualização rápida de entrada diária, saída, pressão atual de estoque e eficiência de separação de saída'
  },
  hubVal6: {
    zh: '二、库存年龄与层级库存',
    en: '2. Inventory Age & Tiered Inventory',
    pu: '2. Idade do Estoque e Estoque por Nível'
  },
  hubVal7: {
    zh: '重点判断当前库存是否开始老化、是否集中在某类转运中心',
    en: 'Focus on identifying whether current inventory is aging or concentrated in certain types of transit centers',
    pu: 'Concentre-se em identificar se o estoque atual está envelhecendo ou concentrado em certos tipos de centros de transferência'
  },
  hubVal8: {
    zh: '库存年龄结构',
    en: '',
    pu: 'Estrutura de Idade do Estoque'
  },
  hubVal9: {
    zh: '按当前库存包裹的在库时长统计：库存时长 = 当前时间 - 转运中心入库时间。',
    en: 'Calculated based on current storage duration: Storage duration = Current time - Transit center inbound time.',
    pu: 'Distribuição dos volumes conforme o tempo atual em estoque: Tempo em Estoque = Hora atual - Hora de entrada no centro de transferência.'
  },
  hubVal10: {
    zh: '转运中心层级库存',
    en: '',
    pu: 'Estoque por Nível de Hub'
  },
  hubVal11: {
    zh: '按转运中心层级汇总当前库存票数。',
    en: 'Summarize current inventory tickets by transit center tier.',
    pu: 'Resuma os tickets de estoque atuais por nível do centro de transferência.'
  },
  hubVal12: {
    zh: '判断重点',
    en: 'Key Insights',
    pu: 'Principais Insights'
  },
  hubVal13: {
    zh: '如果库存主要集中在一级转运中心，需要优先检查干线出车、装车效率和下级转运承接能力。',
    en: 'If inventory is mainly concentrated in Level 1 transit centers, priority should be given to checking linehaul departures, loading efficiency, and downstream transfer capacity.',
    pu: 'Se o estoque estiver concentrado principalmente em centros de transferência de Nível 1, a prioridade deve ser verificar as partidas de linha principal, a eficiência de carga e a capacidade de transferência a jusante.'
  },
  hubVal14: {
    zh: '高库存风险HUB TOP10',
    en: '',
    pu: 'TOP 10 Hubs com Maior Risco de Estoque'
  },
  hubVal15: {
    zh: '按照库存周转天数倒序排列，库存周转天数 = 当前库存票数 ÷ 近7日日均出库票数。',
    en: 'Sort by inventory turnover days in descending order. Inventory turnover days = Current inventory tickets ÷ Average daily outbound tickets of the last 7 days.',
    pu: 'Classificado pelos Dias de Giro do Estoque. Dias de giro de estoque = Tickets de estoque atuais ÷ Média diária de tickets de saída dos últimos 7 dias.'
  },
  hubVal16: {
    zh: '当前库存',
    en: '',
    pu: 'Estoque Atual'
  },
  hubVal17: {
    zh: '近7日日均出库',
    en: '',
    pu: 'Média Diária de Expedição (7 dias)'
  },
  hubVal18: {
    zh: '库存老化风险HUB TOP10',
    en: '',
    pu: 'TOP 10 Hubs com Estoque Antigo'
  },
  hubVal19: {
    zh: '按照超过48小时库存票数 ÷ 实时库存票数，作用：衡量库存积压风险',
    en: 'Calculated as Inventory tickets >48h ÷ Real-time inventory tickets. Purpose: Measure inventory backlog risk.',
    pu: 'Classificado pela proporção de volumes com mais de 48h em estoque. Objetivo: medir o risco de acúmulo de estoque'
  },
  hubVal20: {
    zh: '三、近7日入库/出库趋势',
    en: '3. Inbound/Outbound Trends (Last 7 Days)',
    pu: '3. Tendência de Recebimento e Expedição dos Últimos 7 Dias'
  },
  hubVal21: {
    zh: '用于判断库存是否持续积压',
    en: '',
    pu: 'Utilizado para identificar se o estoque está acumulando continuamente'
  },
  hubVal22: {
    zh: '库存票数为当天23:59:59的实施库存数量',
    en: '',
    pu: 'Estoque referente ao fechamento do dia (23:59:59)'
  },
  hubVal23: {
    zh: '四、转运中心明细',
    en: '4. Transit Center Details',
    pu: '4. Detalhamento dos Hubs'
  },
  hubVal24: {
    zh: '按转运中心展示每日入库、出库、库存、库存周转天数和近7天平均在库时长。',
    en: 'Display daily inbound, outbound, inventory, inventory turnover days, and average storage time over the last 7 days by transit center.',
    pu: 'Exibir entrada diária, saída, estoque, dias de giro de estoque e tempo médio de armazenamento nos últimos 7 dias por centro de transferência.'
  },
  hubVal25: {
    zh: '导出列表信息',
    en: '',
    pu: 'Exportar Lista'
  },
  hubVal26: {
    zh: '统计口径',
    en: 'Statistical Scope',
    pu: 'Escopo Estatístico'
  },
  hubVal27: {
    zh: '入库票数=统计日期内完成转运中心入库扫描的包裹数；出库票数=统计日期内完成转运中心出库扫描/装车发出的包裹数；当前库存票数=已入库但尚未出库的包裹数；净增库存=出库票数-入库票数；趋势图库存票数=当天23:59:59的实际库存减取净增库存；库存周转天数=当前库存票数÷近7日日均出库票数；库存老化率=超过72小时库存票数÷实时库存票数；近7天平均在库时长=近7天已出库包裹的（转运中心出库时间-转运中心入库时间）的平均值，仅统计已出库包裹；库存时长=当前时间-转运中心入库时间；库存年龄结构仅统计当前仍未出库的包裹。',
    en: 'Inbound Tickets = Number of packages that completed inbound scanning at the transit center within the statistical period; Outbound Tickets = Number of packages that completed outbound scanning/loading dispatch at the transit center within the statistical period; Current Inventory Tickets = Number of packages that have been inbound but not yet outbound; Net Inventory Increase = Outbound Tickets - Inbound Tickets; Inventory Tickets in Trend Chart = Actual inventory at 23:59:59 minus net inventory increase; Inventory Turnover Days = Current Inventory Tickets ÷ Average daily outbound tickets of the last 7 days; Inventory Aging Rate = Inventory tickets >72h ÷ Real-time inventory tickets; Avg Storage Time (Last 7 Days) = Average of (Transit center outbound time - Transit center inbound time) for packages that were outbound in the last 7 days, only counting outbound packages; Storage Duration = Current time - Transit center inbound time; Inventory Age Structure only counts packages that have not yet been outbound.',
    pu: 'Tickets de Entrada = Número de pacotes que concluíram a digitalização de entrada no centro de transferência dentro do período estatístico; Tickets de Saída = Número de pacotes que concluíram a digitalização de saída/expedição de carga no centro de transferência dentro do período estatístico; Tickets de Estoque Atual = Número de pacotes que deram entrada mas ainda não saíram; Aumento Líquido de Estoque = Tickets de Saída - Tickets de Entrada; Tickets de Estoque no Gráfico de Tendência = Estoque real às 23:59:59 menos o aumento líquido de estoque; Dias de Giro de Estoque = Tickets de Estoque Atual ÷ Média diária de tickets de saída dos últimos 7 dias; Taxa de Envelhecimento do Estoque = Tickets de estoque >72h ÷ Tickets de estoque em tempo real; Tempo Médio em Estoque (Últimos 7 Dias) = Média de (Horário de saída do centro de transferência - Horário de entrada no centro de transferência) para pacotes que saíram nos últimos 7 dias, contando apenas pacotes já saídos; Duração em Estoque = Horário atual - Horário de entrada no centro de transferência; Estrutura de Idade do Estoque conta apenas pacotes que ainda não saíram.'
  },
  hubVal28: {
    zh: '一级转运中心',
    en: '',
    pu: 'Hub de 1º Nível'
  },
  hubVal29: {
    zh: '二级转运中心',
    en: '',
    pu: 'Hub de 2º Nível'
  },
  hubVal30: {
    zh: '三级转运中心',
    en: '',
    pu: 'Hub de 3º Nível'
  },
  hubVal31: {
    zh: '全部转运中心',
    en: 'All Transit Centers',
    pu: 'Todos os Centros de Transferência'
  },
  hubVal32: {
    zh: '今日进入转运中心的包裹总量。',
    en: 'Total packages entering transit centers today.',
    pu: 'Total de pacotes que entraram nos centros de transferência hoje.'
  },
  hubVal33: {
    zh: '今日从转运中心发出的包裹总量。',
    en: 'Total packages dispatched from transit centers today.',
    pu: 'Total de pacotes enviados dos centros de transferência hoje.'
  },
  hubVal34: {
    zh: '当前仍停留在转运中心且未发出的包裹。',
    en: 'Packages currently still at transit centers that have not been dispatched.',
    pu: 'Pacotes atualmente ainda nos centros de transferência que não foram enviados.'
  },
  hubVal35: {
    zh: '当前库存票数 ÷ 近7日日均出库票数。',
    en: 'Current Inventory Tickets ÷ Average daily outbound tickets of the last 7 days.',
    pu: 'Tickets de Estoque Atual ÷ Média diária de tickets de saída dos últimos 7 dias.'
  },
  hubVal36: {
    zh: '近7天已出库包裹，从入库到出库的平均耗时。',
    en: 'Average time from inbound to outbound for packages that were outbound in the last 7 days.',
    pu: 'Tempo médio da entrada à saída para pacotes que saíram nos últimos 7 dias.'
  },
  hubVal37: {
    zh: '出库票数 - 入库票数。',
    en: 'Outbound Tickets - Inbound Tickets.',
    pu: 'Tickets de Saída - Tickets de Entrada.'
  },
  hubVal38: {
    zh: '超过48小时库存票数 ÷ 实时库存票数，用于衡量库存积压风险。',
    en: 'Inventory tickets over 48 hours ÷ Real-time inventory tickets, used to measure backlog risk.',
    pu: 'Tickets de estoque acima de 48 horas ÷ Tickets de estoque em tempo real, usado para medir risco de acúmulo.'
  },
  hubVal39: {
    zh: '一级',
    en: '',
    pu: 'Nível 1'
  },
  hubVal40: {
    zh: '二级',
    en: '',
    pu: 'Nível 2'
  },
  hubVal41: {
    zh: '三级',
    en: '',
    pu: 'Nível 3'
  },
  misroutingRuleDescription: {
    zh: '错发判断时，系统按照规则生成允许路径：规则名称 + 始发转运中心 → 途径转运中心（可多个）→ 预派送网点（可批量选择）。同一个州下不同派送网点可配置不同途径中心，例如 ABC 走 C 转运中心，OPQ 走 D 转运中心。',
    en: 'When determining misrouting, the system generates allowed paths based on rules: Rule Name + Origin Transit Center → Intermediate Transit Centers (multiple allowed) → Pre-delivery Branches (batch selectable). Different delivery branches within the same state can be configured with different intermediate centers, e.g., ABC goes through C Transit Center, OPQ goes through D Transit Center.',
    pu: 'Ao determinar roteamento incorreto, o sistema gera caminhos permitidos com base nas regras: Nome da Regra + Centro de Transferência de Origem → Centros de Transferência Intermediários (múltiplos permitidos) → Agências de Pré-entrega (selecionáveis em lote). Diferentes agências de entrega no mesmo estado podem ser configuradas com diferentes centros intermediários, ex.: ABC passa pelo Centro C, OPQ passa pelo Centro D.'
  },
  addRule: {
    zh: '新增规则',
    en: 'Add Rule',
    pu: 'Adicionar Regra'
  },
  searchConditions: {
    zh: '查询条件',
    en: 'Search Conditions',
    pu: 'Condições de Busca'
  },
  configInstructions: {
    zh: '配置说明 ？',
    en: 'Configuration Instructions?',
    pu: 'Instruções de Configuração?'
  },
  mis1: {
    zh: '始发转运中心',
    en: '',
    pu: 'Hub de Origem'
  },
  originTransitCenterPlaceholder: {
    zh: '请选择始发转运中心',
    en: 'Please select origin transit center',
    pu: 'Selecione o centro de transferência de origem'
  },
  mis2: {
    zh: '完整允许路径',
    en: '',
    pu: 'Rota Permitida'
  },
  mis3: {
    zh: '覆盖预派送网点',
    en: '',
    pu: 'Pontos de Entrega Vinculadas'
  },
  mis4: {
    zh: '规则名称',
    en: '',
    pu: 'Nome da Regra'
  },
  ruleNamePlaceholder: {
    zh: '请输入规则名称',
    en: 'Please enter rule name',
    pu: 'Digite o nome da regra'
  },
  mis5: {
    zh: '途径转运中心',
    en: '',
    pu: 'Hub Intermediário'
  },
  intermediateCenterPlaceholder: {
    zh: '请选择途径中心',
    en: 'Select intermediate center',
    pu: 'Selecione o centro intermediário'
  },
  mis6: {
    zh: '预派送网点',
    en: '',
    pu: 'Ponto Previsto de Entrega'
  },
  mis7: {
    zh: '错发路径配置',
    en: 'Misrouting Configuration',
    pu: 'Configuração de Rotas Permitidas'
  },
  mis8: {
    zh: '新增 / 编辑路径规则',
    en: 'Add / Edit Path Rule',
    pu: 'Adicionar / Editar Regra de Caminho'
  },
  mis9: {
    zh: '新增路径规则',
    en: 'Add Path Rule',
    pu: 'Adicionar Regra de Caminho'
  },
  mis10: {
    zh: '编辑路径规则',
    en: 'Edit Path Rule',
    pu: 'Editar Regra de Caminho'
  },
  mis11: {
    zh: '查看路径规则',
    en: 'View Path Rule',
    pu: 'Visualizar Regra de Caminho'
  },
  mis12: {
    zh: '路径配置',
    en: 'Path Configuration',
    pu: 'Configuração de Caminho'
  },
  mis13: {
    zh: '保存规则',
    en: 'Save Rule',
    pu: 'Salvar Regra'
  },
  mis14: {
    zh: '如所选网点已存在其它启用规则，保存时提示冲突。',
    en: 'If the selected branch already has other active rules, a conflict warning will be shown when saving.',
    pu: 'Se a agência selecionada já tiver outras regras ativas, um aviso de conflito será exibido ao salvar.'
  },
  mis15: {
    zh: '规则名称不能为空',
    en: '',
    pu: 'O nome da regra é obrigatório'
  },
  mis16: {
    zh: '包裹允许到达的起始转运节点',
    en: 'Starting transit node where packages are allowed to arrive',
    pu: 'Nó de transferência inicial onde os pacotes podem chegar'
  },
  mis17: {
    zh: '途径转运中心（可添加多个，按顺序展示）',
    en: 'Intermediate Transit Centers (multiple can be added, displayed in order)',
    pu: 'Centros de Transferência Intermediários (vários podem ser adicionados, exibidos em ordem)'
  },
  mis18: {
    zh: '增加途径转运中心',
    en: 'Add Intermediate Center',
    pu: 'Adicionar Centro Intermediário'
  },
  mis19: {
    zh: '已选',
    en: 'Selected',
    pu: 'Selecionado'
  },
  mis20: {
    zh: '个网点',
    en: 'branches',
    pu: 'agências'
  },
  mis21: {
    zh: '个',
    en: '',
    pu: ''
  },
  mis22: {
    zh: '路径预览',
    en: 'Path Preview',
    pu: 'Visualização do Caminho'
  },
  mis23: {
    zh: '请至少选择一个预派送网点',
    en: '',
    pu: 'Selecione pelo menos um ponto de entrega'
  },
  mis24: {
    zh: '你确认要停用吗？',
    en: 'Are you sure you want to deactivate?',
    pu: 'Tem certeza de que deseja desativar?'
  },
  mis25: {
    zh: '你确认要启用吗？',
    en: 'Are you sure you want to activate?',
    pu: 'Tem certeza de que deseja ativar?'
  },
  misroutedInboundRegion: {
    zh: '错发入库大区',
    en: 'Misrouted Inbound Region',
    pu: 'Região de Entrada com Roteamento Incorreto'
  },
  misroutedInboundBranch: {
    zh: '错发入库网点',
    en: 'Misrouted Inbound Branch',
    pu: 'Agência de Entrada com Roteamento Incorreto'
  },
  agingHistoryRefresh: {
    zh: '时效历史数据更新',
    en: 'Aging History Refresh',
    pu: 'Atualização de histórico de SLA'
  },
  deliveryMonitor: {
    zh: '包裹尝试投递监控',
    en: 'Package delivery attempt monitoring',
    pu: 'Monitoramento de Reentregas'
  },
  deliveryFailureStats: {
    zh: '用于统计每个包裹多次投递失败时间、失败原因及两次失败之间的时间间隔，辅助质控分析重投效率。',
    en: 'Used to count the time and reasons for multiple delivery failures per package, as well as the time intervals between failures, to assist quality control in analyzing redelivery efficiency.',
    pu: 'Usado para contabilizar o horário e os motivos de múltiplas falhas de entrega por pacote, bem como os intervalos de tempo entre as falhas, para auxiliar o controle de qualidade na análise da eficiência de reenvio.'
  },
  latestFailTime: {
    zh: '最新投递失败时间',
    en: 'Latest delivery failure time',
    pu: 'Horário da última falha de entrega'
  },
  failedDeliveryCount: {
    zh: '投递失败包裹数',
    en: 'Number of packages with delivery failures',
    pu: 'Número de pacotes com falhas de entrega'
  },
  totalPackagesFiltered: {
    zh: '当前筛选条件下的包裹总量',
    en: 'Total packages under current filter conditions',
    pu: 'Total de pacotes nas condições de filtro atuais'
  },
  multiFailPackages: {
    zh: '二次及以上失败包裹',
    en: 'Packages with two or more failures',
    pu: 'Pacotes com duas ou mais falhas'
  },
  failCountGe2: {
    zh: '失败次数 ≥ 2',
    en: 'Failure count ≥ 2',
    pu: 'Contagem de falhas ≥ 2'
  },
  multiFailPackages3Plus: {
    zh: '三次及以上失败包裹',
    en: 'Packages with three or more failures',
    pu: 'Pacotes com três ou mais falhas'
  },
  qualityControlFocus: {
    zh: '重点质控关注对象',
    en: 'Key quality control focus',
    pu: 'Foco principal do controle de qualidade'
  },
  avgRetryInterval: {
    zh: '平均重投间隔',
    en: 'Average retry interval',
    pu: 'Intervalo médio de reenvio'
  },
  adjacentFailInterval: {
    zh: '相邻两次投递失败时间差',
    en: 'Time interval between two consecutive delivery failures',
    pu: 'Intervalo de tempo entre duas falhas de entrega consecutivas'
  },
  deliveryFailDetails: {
    zh: '投递失败明细',
    en: 'Delivery failure details',
    pu: 'Detalhes das falhas de entrega'
  },
  deliveryFailCount: {
    zh: '投递失败次数',
    en: 'Delivery failure count',
    pu: 'Contagem de falhas de entrega'
  },
  latestFailReason: {
    zh: '最新投递失败原因',
    en: 'Latest delivery failure reason',
    pu: 'Último motivo de falha de entrega'
  },
  firstFailTime: {
    zh: '第一次投递失败时间',
    en: 'First delivery failure time',
    pu: 'Horário da primeira falha de entrega'
  },
  timeInterval: {
    zh: '时间间隔',
    en: 'Time interval',
    pu: 'Intervalo de tempo'
  },
  secondFailTime: {
    zh: '第二次投递失败时间',
    en: 'Second delivery failure time',
    pu: 'Horário da segunda falha de entrega'
  },
  thirdFailTime: {
    zh: '第三次投递失败时间',
    en: 'Third delivery failure time',
    pu: 'Horário da terceira falha de entrega'
  },
  exportOrderNumberDetails: {
    zh: '导出单号明细',
    en: 'Export order number details',
    pu: 'Exportar detalhes dos números de remessa'
  },
  firstLoadingNextStop: {
    zh: '第一次装车下一站',
    en: 'First load next stop',
    pu: 'Próx. parada 1º carreg.'
  },
  firstUnloader: {
    zh: '第一次卸车人',
    en: 'First unloader',
    pu: '1º descarregador'
  },
  firstLoadSignature: {
    zh: '第一次装车签名',
    en: 'First loading signature',
    pu: 'Assinatura 1º carreg.'
  },
  firstUnloadSignature: {
    zh: '第一次卸车签名',
    en: 'First unloading signature',
    pu: 'Assinatura 1º descarreg.'
  },
  merchantConfirmReceipt: {
    zh: '商家确认签收',
    en: 'Merchant confirmation of receipt',
    pu: 'Conf. recebimento comerciante'
  },
  secondLoader: {
    zh: '第二次装车人',
    en: 'Second loader',
    pu: '2º carregador'
  },
  secondLoadSignature: {
    zh: '第二次装车签名',
    en: 'Second loading signature',
    pu: 'Assinatura 2º carreg.'
  },
  secondLoadNextStop: {
    zh: '第二次装车下一站',
    en: 'Second load next stop',
    pu: 'Próx. parada 2º carreg.'
  },
  secondUnloader: {
    zh: '第二次卸车人',
    en: 'Second unloader',
    pu: '2º descarregador'
  },
  secondUnloadLocation: {
    zh: '第二次卸车网点',
    en: 'Second unloading location',
    pu: '2º local descarreg.'
  },
  secondUnloadSignature: {
    zh: '第二次卸车签名',
    en: 'Second unloading signature',
    pu: 'Assinatura 2º descarreg.'
  },
  thirdLoader: {
    zh: '第三次装车人',
    en: 'Third loader',
    pu: '3º carregador'
  },
  thirdLoadTime: {
    zh: '第三次装车时间',
    en: 'Third loading time',
    pu: 'Horário 3º carreg.'
  },
  thirdLoadLocation: {
    zh: '第三次装车网点',
    en: 'Third loading location',
    pu: '3º local carreg.'
  },
  thirdLoadSignature: {
    zh: '第三次装车签名',
    en: 'Third loading signature',
    pu: 'Assinatura 3º carreg.'
  },
  thirdLoadNextStop: {
    zh: '第三次装车下一站',
    en: 'Third load next stop',
    pu: 'Próx. parada 3º carreg.'
  }
};
export { collectionCenter };
